import React from "react";
import { useHistory } from "react-router-dom";
import { Api } from "../app-controller.js";
import { useAuth } from "../components/content/auth.jsx";
import { TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";
import classnames from "classnames";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import Swal from "sweetalert2";
import { format } from "date-fns";

import ModalSolicitudCertificado from "../components/content/certificados/ModalSolicitudCertificado";
import ModalSolicitudPrecertificado from "../components/pre-certificado/ModalSolicitudPrecertificado";
//import ModalPrecertificado from "../components/pre-certificado/ModalPrecertificado";
import ModalSolicitudMovimiento from "../components/content/movimientos/ModalSolicitudMovimiento";
import ModalSolicitudCasoEspecial from "../components/content/casos_especiales/ModalSolicitudCasoEspecial";
import ModalSolicitudAutorizacion from "../components/PrecertificadoCE/ModalSolicitudAutorizacion";
import ModalClasificacion from "../components/content/modal_clasificacion.jsx";

class Applications extends React.Component {
  constructor(props) {
    super(props);
    /* Inicia Regentes */
    this.handleRegentePage = this.handleRegentePage.bind(this);
    this.handleOpenRegent = this.handleOpenRegent.bind(this);
    this.handleRegentDocumentStatus =
      this.handleRegentDocumentStatus.bind(this);
    this.handleRegentChecks = this.handleRegentChecks.bind(this);
    this.handleDownloadZipRegentes = this.handleDownloadZipRegentes.bind(this);
    this.allDocsRegent = this.allDocsRegent.bind(this);
    this.handleRegentStatus = this.handleRegentStatus.bind(this);
    this.handleCasosEspecialesPage = this.handleCasosEspecialesPage.bind(this);

    /* Termina Regentes*/

    /* Inicia Establecimientos */
    this.handleEstablecimientoDocumentoStatus =
      this.handleEstablecimientoDocumentoStatus.bind(this);
    this.handleDownloadZipEstablecimientos =
      this.handleDownloadZipEstablecimientos.bind(this);
    this.allDocsEst = this.allDocsEst.bind(this);
    this.handleEstablecimientoStatus =
      this.handleEstablecimientoStatus.bind(this); //SINAIP 1 SI APRUEBA
    this.handleEstablecimientoPage = this.handleEstablecimientoPage.bind(this);
    this.handleOpenEstablecimiento = this.handleOpenEstablecimiento.bind(this);
    this.handleEstChecks = this.handleEstChecks.bind(this);
    this.handleEstBtn = this.handleEstBtn.bind(this);
    /* Termina Establecimientos */

    /* Inicia Productos */
    this.handleProChecks = this.handleProChecks.bind(this);
    this.handleDownloadZipProductos =
      this.handleDownloadZipProductos.bind(this);
    this.allDocsPro = this.allDocsPro.bind(this);
    this.handleOpenRegentPago = this.handleOpenRegentPago.bind(this);
    this.handleProductoStatus = this.handleProductoStatus.bind(this); //SINAIP 1 SI APRUEBA
    this.handleProductoPage = this.handleProductoPage.bind(this);
    this.handleOpenProductos = this.handleOpenProductos.bind(this);
    this.handleProductosDocumentoStatus =
      this.handleProductosDocumentoStatus.bind(this);

    this.handleChangeStatusProducto =
      this.handleChangeStatusProducto.bind(this);
    this.handleClasificacionProd = this.handleClasificacionProd.bind(this);
    this.handleEditarProducto = this.handleEditarProducto.bind(this);
    this.setProductosPage = this.setProductosPage.bind(this);
    this.handleChangeClasificacion = this.handleChangeClasificacion.bind(this);
    this.setClasificacion = this.setClasificacion.bind(this);
    this.closeClasificacion = this.closeClasificacion.bind(this);
    /* Termina Productos */

    /*Incia MEDICO VETERINARIO */
    this.handleMedicoVeterinarioPage =
      this.handleMedicoVeterinarioPage.bind(this);
    this.handleOpenMedicoVeterinario =
      this.handleOpenMedicoVeterinario.bind(this);
    this.handleMedicoVetDocumentoStatus =
      this.handleMedicoVetDocumentoStatus.bind(this);
    this.handleMedicoVetChecks = this.handleProChecks.bind(this);
    this.handleDownloadZipMedicoVet =
      this.handleDownloadZipMedicoVet.bind(this);
    this.allDocsMV = this.allDocsMV.bind(this);
    this.handleMedicoVetStatus = this.handleMedicoVetStatus.bind(this); //SINAIP 1 SI APRUEBA
    this.handleChangeStatusMedicoVet =
      this.handleChangeStatusMedicoVet.bind(this);
    /* Termina MEDICO VETERINARIO */

    this.handleSearch = this.handleSearch.bind(this);
    this.handleUpdateRevisa = this.handleUpdateRevisa.bind(this);
    this.handlePrevia = this.handlePrevia.bind(this);

    /*Constancias */
    this.handleConstanciasPage = this.handleConstanciasPage.bind(this);
    this.handleOpenConstancias = this.handleOpenConstancias.bind(this);
    this.handleConstanciaStatus = this.handleConstanciaStatus.bind(this);
    this.handleTextActaChange = this.handleTextActaChange.bind(this);
    this.handleTextAM = this.handleTextAM.bind(this);
    this.handleCreateConstancia = this.handleCreateConstancia.bind(this);
    this.setConstanciasPage = this.setConstanciasPage.bind(this);
    /**REFRENDA */
    this.handleOpenProductosRefrenda =
      this.handleOpenProductosRefrenda.bind(this);

    /* Inicia certificados*/
    //this.handleCertificadoDocumentoStatus = this.handleCertificadoDocumentoStatus.bind(this);
    this.handleDownloadZipCertificados =
      this.handleDownloadZipCertificados.bind(this);
    //this.allDocsCer = this.allDocsCer.bind(this);
    this.handleCertificadoStatus = this.handleCertificadoStatus.bind(this);
    this.handleCertificadoPage = this.handleCertificadoPage.bind(this);
    this.handleOpenCertificado = this.handleOpenCertificado.bind(this);
    this.handleEstChecks = this.handleEstChecks.bind(this);
    this.closeModalCertificado = this.closeModalCertificado.bind(this);
    this.handleChangeStatusCertificado =
      this.handleChangeStatusCertificado.bind(this);
    //handleChangeStatusCertificado
    /* Termina certificados */

    /*Precertificado*/
    this.closeModalPrecertificado = this.closeModalPrecertificado.bind(this);
    this.handleOpenModalPrecertificado =
      this.handleOpenModalPrecertificado.bind(this);
    //this.handleClickPrecertificados = this.handleClickPrecertificados.bind(this);
    this.handlesolicitudDocumentoStatusPre =
      this.handlesolicitudDocumentoStatusPre.bind(this);
    this.handleBtnPRE = this.handleBtnPRE.bind(this);
    this.handlePrecertificadoStatus =
      this.handlePrecertificadoStatus.bind(this);
    this.handleChangeStatusPRE = this.handleChangeStatusPRE.bind(this);
    this.allDocsSolPre = this.allDocsSolPre.bind(this);
    this.handlePreviaPre = this.handlePreviaPre.bind(this);
    this.handlePreviaClosePre = this.handlePreviaClosePre.bind(this);
    this.handleDownloadZipPRE = this.handleDownloadZipPRE.bind(this);
    this.handleSolicitudChecksPre = this.handleSolicitudChecksPre.bind(this);
    /*TERMINA PRECERTIFICADO */

    /**AUTORIZACIÓN DE ADQUISICION */
    this.closeModalAutorizacion = this.closeModalAutorizacion.bind(this);
    this.handleOpenModalAutorizacion =
      this.handleOpenModalAutorizacion.bind(this);
    this.handleAutorizacionStatus = this.handleAutorizacionStatus.bind(this);
    this.handleChangeStatusADA = this.handleChangeStatusADA.bind(this);
    this.handleDesactivarSolicitud = this.handleDesactivarSolicitud.bind(this);
    this.handleUpdateSolicitudADA = this.handleUpdateSolicitudADA.bind(this);
    /**TERMINA AUTORIZACIÓN */

    /**MOVIMIENTO DE PRODUCTOS */
    this.closeModalMovimientos = this.closeModalMovimientos.bind(this);
    this.setMovimientoProductosPage =
      this.setMovimientoProductosPage.bind(this);
    this.handleMovimientoProductosPage =
      this.handleMovimientoProductosPage.bind(this);
    this.handleMovimientoProducto = this.handleMovimientoProducto.bind(this);
    this.handleOpenMovimiento = this.handleOpenMovimiento.bind(this);
    this.closeModalMovimiento = this.closeModalMovimiento.bind(this);
    /** TERMINA MOVIMIENTO DE PRODUCTOS */

    /**CASOS ESPECIALES */
    this.setCasosEspecialesPage = this.setCasosEspecialesPage.bind(this);
    this.handleOpenCasoEspecial = this.handleOpenCasoEspecial.bind(this);
    this.closeModalCasoEspecial = this.closeModalCasoEspecial.bind(this);
    this.closeModalCasoEspecial = this.closeModalCasoEspecial.bind(this);
    this.handleSingleErrorForm = this.handleSingleErrorForm.bind(this);
    this.cleanErrorsValidation = this.cleanErrorsValidation.bind(this);
    this.handleCasoEspecialEstatus = this.handleCasoEspecialEstatus.bind(this);
    this.handleImportacionAdicionalDataChange =
      this.handleImportacionAdicionalDataChange.bind(this);
    this.handleCasoEspecialDocumentoEstatusChange =
      this.handleCasoEspecialDocumentoEstatusChange.bind(this);

    /** TERMINA CASOS ESPECIALES */

    this.state = {
      previa: false,
      previa_url: "",
      working: true,
      modalRegente: false,
      modalEstablecimiento: false,
      modalPago: false,
      modalMV: false,
      toggle: false,
      paginaActual: 0,
      paginaActual_e: 0,
      paginas: 0,
      paginas_e: 0,
      registros: 0,
      registros_e: 0,
      regentes: [],
      regenteDocsCheck: [],
      establecimientoDocsCheck: [],
      allRc: false,
      allEst: false,
      allMV: false,
      accionCombo: Api.loadCatalogue("cat_accion"),
      tipoRegenteCombo: Api.loadCatalogue("cat_tipo_regente"),
      estatusTramiteCombo: Api.loadCatalogue("cat_estatus_tramite"),
      tipo_establecimiento: Api.loadCatalogue("cat_tipo_establecimiento"),
      actividad_establecimiento: Api.loadCatalogue("cat_actividad"),
      cat_tipo_producto: Api.loadCatalogue("cat_tipo_producto"),
      cat_constancia_tipo: Api.loadCatalogue("cat_constancia_tipo"),
      cat_tipo_certificado: Api.loadCatalogue("cat_tipo_certificado"),
      cat_tipo_precertificado: Api.loadCatalogue("cat_tipo_precertificado"),
      cat_estatus_tramite_ce: Api.loadCatalogue("cat_estatus_tramite"),
      cat_tipo_importacion: Api.loadCatalogue("cat_tipo_importacion"),
      cat_grupo_ingrediente: Api.loadCatalogue("cat_grupo_ingrediente"),
      cat_categorizacion_oficial: Api.loadCatalogue(
        "cat_categorizacion_oficial"
      ),
      option_clase_producto: [],
      regente: {
        name: "",
        apellido_paterno: "",
        apellido_materno: "",
        folio_solicitud: "",
        sexo: "",
        departamento: "",
        municipio: "",
        email: "",
        telefono: "",
        celular: "",
        fecha_solicitud: "",
        solicitud_id: "",
        documentos: [],
        sgi_info: {},
      },
      reg_estatus_tramite_id: "",
      activeTab: "1",
      buscar: {},
      buscarEstablecimientos: {},
      buscarMovimientos: {},
      buscarCasosEspeciales: {},
      nivelUsuario: localStorage.nivel_actual,
      buscarProductos: {},
      buscaConstancias: {},
      buscaMedicoV: {},
      buscaCertificados: {},
      collapse: [
        {
          id: 1,
          collapse: true,
        },
        {
          id: 2,
          collapse: false,
        },
        {
          id: 3,
          collapse: false,
        },
      ],
      establecimientos: [],
      id_establecimiento: "",
      solicitud_est: {
        id: "",
        folio_solicitud: "",
        fecha_solicitud: "",
        accion: "",
        actividad: "",
        tipo: "",
        estatus: "",
        //documentos:[],
      },
      establecimiento: {
        caracteristicas: [],
        documentos: [],
        establecimiento: {},
        regentes: [],
        representante_legal: [],
        solicitud: {},
      },
      id_producto: "",
      solicitud_prod: {
        id: "",
        folio_solicitud: "",
        accion: "",
        actividad: "",
        fecha_solicitud: "",
        tipo: "",
        estatus: "",
        fecha_solicitud: "",
        anotacion_marginal: false,
      },
      producto: {
        id: "",
        forma_farmaceutica: "",
        forma_farmaceutica_id: "",
        folio: "",
        medida_tiempo: "",
        medida_tiepo_id: "",
        nombre_comercial: "",
        pais: "",
        pais_id: "",
        precauciones_generales: "",
        uso: "",
      },
      productos: [],
      solicitud_pro: {},
      productoDocsCheck: [],
      paginaActual_p: 0,
      paginas_p: 0,
      registros_p: 0,
      medico_veterinario: {
        documentos: [],
      },
      medicos_veterinarios: [],
      solicitud_mv: {
        id: "",
        folio_solicitud: "",
        tramite: "",
        accion: "",
        estatus: "",
      },
      medicoVetDocsCheck: [],
      paginaActual_mv: 0,
      paginas_mv: 0,
      registros_mv: 0,
      docProductos: [],
      paginaActual_c: 0,
      paginas_c: 0,
      registros_c: 0,
      constancias: [],
      am: "", //es nota marginal
      nota_marginal: {},
      solicitud_cons: {
        id: "",
        folio_solicitud: "",
        fecha_solicitud: "",
        nombre_servicio: "",
        tipo_constancia: "",
        estatus: "",
      },
      constancia: {},
      cons_productos: [],
      texto_acta: "",
      validez_id: "0",
      txt_actaMaxLen: 10000,
      //certificados
      id_certificado: "",
      solicitud_cer: {
        id: "",
        folio_solicitud: "",
        accion: "",
        actividad: "",
        tipo: "",
        estatus: "",
        estatus_tramite_id: "",
        tipo_certificado_id: false,
      },
      certificado: {
        id: "",
        forma_farmaceutica: "",
        forma_farmaceutica_id: "",
        folio: "",
        medida_tiempo: "",
        medida_tiepo_id: "",
        nombre_comercial: "",
        pais: "",
        pais_id: "",
        precauciones_generales: "",
        uso: "",
        //metemos las listas que pudieramos necesitar para el certificado
        lista_composiciones_biologicas: [],
        lista_composiciones_quimicas: [],
        lista_analisis: [],
        lista_ingredientes: [],
        lista_principios_activos: [],
        lista_excipiente: [],
        fabricante: [],
        titular: [],
        lista_especie_dosis: [],
        lista_empaque: [],
        lista_presentaciones: [],
        lista_descarte: [],
        representantes_legales: [],
        regentes: [],
        aprobado: "",
      },
      certificados: [],
      certificadoDocsCheck: [],
      paginaActual_cer: 0,
      paginas_cer: 0,
      registros_cer: 0,
      openModalCertificado: false,
      openModalClasificacion: false,
      allCerDocs: [],
      allCer: [],
      docsCertificado: [],
      text_AM: "",
      productos_constancia_AM: [],
      /**precertificado */
      paginas_pre: 0,
      registros_pre: 0,
      paginaActual_pre: 0,
      solicitud_pre: [],
      precertificados: [],
      openModalPrecertificado: false,
      // movimiento de productos
      registros_mov: 0,
      movimientos: [],
      casos_especiales: [],
      paginaActual_m: 0,
      paginaActual_ce: 0,
      paginas_m: 0,
      paginas_ce: 0,
      registros_m: 0,
      registros_ce: 0,
      openModalMovimiento: false,
      openModalCasoEspecial: false,
      movimiento: {
        id: "",
        solicitud_id: "",
        establecimiento_envia_id: "",
        establecimiento_recibe_id: "",
        actividad_envia_id: "",
        actividad_recibe_id: "",
        acepto: "",
        url_factura: "",
        usuario_id: "",
        created: "",
        modified: "",
        usuario_acepta_id: "",
        establecimiento_envia_nombre: "",
        establecimiento_recibe_nombre: "",
        fecha_acepta: "",
        formulario_envio: "",
        observaviones: "",
        formulario_acepta: "",
        formulario_movimiento: "",
        secuencial: "",
        fecha_respuesta: "",
        //metemos las listas que pudieramos necesitar para movimiento
        bitacora_producto_detalle_entrada: {},
        bitacora_producto_egreso: {},
        rel_bitacora_producto_lote: [],
        actividad_envia: {},
        actividad_recibe: {},
        producto: {},
      },
      caso_especial: {
        id: "",
        solicitud_id: "",
        tipo_importacion_id: "",
        usuario_id: "",
        status: "",
        created: "",
        modified: "",
        casos_especiales_establecimiento_id: "",
        documentacion: [],
        datos_importacion: {},
        establecimiento: {},
        tipo_importacion: {},
        productos: [],
        todosDocsAprobados: false,
      },
      importacion: {
        importacion_texto: "",
        fines_texto: "",
      },
      solicitud_mov: {
        id: "",
        folio_solicitud: "",
        accion_id: "",
        tramite_id: "",
        estatus_tramite_id: "",
        fecha_solicitud: "",
        estatus: {},
        tramite: {},
        accion: {},
      },
      solicitud_ce: {
        id: "",
        folio_solicitud: "",
        accion_id: "",
        tramite_id: "",
        estatus_tramite_id: "",
        fecha_solicitud: "",
        estatus: {},
        tramite: {},
        accion: {},
      },
      documentos_pre: [],
      registros_docs_pre: 0,
      solicitudDocsCheckPre: [],
      allSolDocsPre: false,
      allDocsPre: false,
      buscarPrecertificado: {},
      /**Autorizacion */
      paginaActual_ada: 0,
      paginas_ada: 0,
      registros_ada: 0,
      buscarAutorizacionDA: {},
      openModalAutorizacion: false,
      autorizacion: {},
      solicitud_ada: {},
      clasificacion: {
        grupo_ingrediente_id: "",
        clase_producto_id: "",
        categorizacion_oficial_id: "",
        tomo: "",
        folio: "",
        no_registro_drycip: "",
        dossier: "",
        asesoria: false,
        solid: "",
      },
      tipo_producto_veterinario: true,
      constancia_revisada_8: false,
    };
    this.toggleCollapse = this.toggleCollapse.bind(this);

    if (props.auth.user.name === undefined) {
      this.props.history.push("login");
    }

    /* 	this.setState({
			collapse: newArray
		}); */
  }

  detalleEstablecimiento = "";
  detalleRepresentante = "";
  detalleRegente = "";
  detalleCaracteristicas = "";
  detalleCondiciones = "";
  regente = {};
  representante_legal = {};
  condiciones = {};
  principioActivo = {};
  excipiente = {};
  tabla_dosis = {};
  tabla_envase = {};
  tabla_periodo = {};
  detalleProducto = "";
  AnotacionProducto = "";
  representante_legal_pro = {};
  regente_pro = {};
  detalleMedicamento = "";
  detalleNombre = "";
  tabla_biologica = {};
  tabla_quimica = {};
  tabla_modo_empleo = {};
  tabla_componentes = {};
  tabla_especies = {};
  tabla_presentacion = {};
  tabla_analisis = {};
  tabla_ingredientes = {};
  clasificacion = "";
  cons_form_regente = {};
  cons_form_actividad = {};
  cons_establecimiento = {};
  cons_txt_libre = {};
  cons_representante = {};
  detalleMedicoVeterinario = "";
  refrenda_form = {};
  tabla_refrenda_productos = {};
  detalleCertificado = "";
  constancia_AM = {};

  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({ activeTab: tab });
    }
  }

  toggleCollapse(index) {
    var newArray = [];
    for (let collapseObj of this.state.collapse) {
      if (collapseObj.id === index) {
        collapseObj.collapse = !collapseObj.collapse;
      } else {
        collapseObj.collapse = false;
      }
      newArray.push(collapseObj);
    }

    this.setState({ collapse: newArray });
  }

  componentDidMount() {
    // si el usuario no es nivel drycip redireccionamos a home
    if (this.state.nivelUsuario !== "3") {
      window.location.href = "/";
    }

    this.setState({ buscar: this.search });

    this.setRegentesPage(1);
    this.setEstablecimientosPage(1);
    this.setProductosPage(1);
    this.setMovimientoProductosPage(1);
    this.setConstanciasPage(1);
    this.setMedicoVeterinarioPage(1);
    this.setCertificadoPage(1);
    this.setPrecertificadosPage(1);
    this.setAutorizacionPage(1);
    this.setCasosEspecialesPage(1);

    /* BUSCADORES */
    /* Regentes*/
    let bregente = {
      target: "#busquedaRegente",
      nombre: "busquedaRegente",
      elementClass: "form-control",
      elements: [
        {
          input: {
            cols: 2,
            name: "folio",
            type: "text",
            label: "Folio",
          },
        },
        {
          select: {
            cols: 2,
            name: "solicitud",
            type: "text",
            label: "Trámite",
            render: (me) => {
              me.innerHTML = `<option value="">Seleccione</option>`;
              this.state.accionCombo.forEach((s) => {
                me.innerHTML += `<option value=${s.descripcion}>${s.descripcion}</option>`;
              });
            },
          },
        },
        {
          input: {
            cols: 8,
            name: "nombre",
            type: "text",
            label: "Nombre",
          },
        },
        {
          select: {
            cols: 2,
            name: "tipo",
            label: "Tipo regente",
            render: (me) => {
              me.innerHTML = `<option value="">Seleccione</option>`;
              this.state.tipoRegenteCombo.forEach((s) => {
                me.innerHTML += `<option value=${s.id}>${s.descripcion}</option>`;
              });
            },
          },
        },
        {
          input: {
            cols: 3,
            name: "fecha",
            type: "date",
            label: "Fecha desde",
          },
        },
        {
          input: {
            cols: 3,
            name: "fecha2",
            type: "date",
            label: "Fecha hasta",
          },
        } /* {
          span: {
              cols: 2,
              label: "",
              class:"hide"
          }
        }*/,
        {
          select: {
            cols: 2,
            name: "estatus",
            label: "Estado",
            render: (me) => {
              me.innerHTML = `<option value="">Seleccione</option>`;
              this.state.estatusTramiteCombo.forEach((s) => {
                me.innerHTML += `<option value=${s.id}>${s.descripcion}</option>`;
              });
            },
          },
        },
        {
          button: {
            cols: 2,
            name: "buscareg",
            label: "",
            text: "Buscar",
            class: "form-control btn-warning ",
            icon: "fas fa-search",
            click: (e) => {
              this.setState({ buscar: bregente.data() });
              this.setRegentesPage(1);
            },
          },
        },
      ],
    };

    bregente = Api.form(bregente);
    /* Termina buscador regentes */

    /*Buscador establecimiento */
    let bestablecimiento = {
      target: "#busquedaEstablecimiento",
      nombre: "busquedaEstablecimiento",
      elementClass: "form-control",
      elements: [
        {
          input: {
            cols: 2,
            name: "folio",
            type: "text",
            label: "Folio",
          },
        },
        {
          select: {
            cols: 2,
            name: "solicitud",
            type: "text",
            label: "Trámite",
            render: (me) => {
              me.innerHTML = `<option value="">Seleccione</option>`;
              this.state.accionCombo.forEach((s) => {
                me.innerHTML += `<option value="${s.descripcion}">${s.descripcion}</option>`;
              });
            },
          },
        },
        {
          input: {
            cols: 4,
            name: "razon_social",
            type: "text",
            label: "Razón social",
          },
        },
        {
          select: {
            cols: 2,
            name: "tipo",
            label: "Tipo establecimiento",
            render: (me) => {
              me.innerHTML = `<option value="">Seleccione</option>`;
              this.state.tipo_establecimiento.forEach((s) => {
                me.innerHTML += `<option value="${s.descripcion}">${s.descripcion}</option>`;
              });
            },
          },
        },
        {
          select: {
            cols: 2,
            name: "actividad",
            label: "Actividad",
            render: (me) => {
              me.innerHTML = `<option value="">Seleccione</option>`;
              this.state.actividad_establecimiento.forEach((s) => {
                me.innerHTML += `<option value="${s.descripcion}">${s.descripcion}</option>`;
              });
            },
          },
        },
        {
          select: {
            cols: 2,
            name: "ffecha",
            label: "Rango fecha",
            render: (me) => {
              me.innerHTML = `
                              <option value="">Seleccione</option>
                              <option value="fecha_solicitud">Solicitud</option>
                              <option value="fecha_aprueba_sinaip">Aprueba SINAIP</option>
                              <option value="fecha_aprueba_asesoria">Aprueba Asesoria</option>
                        `;
            },
          },
        },
        {
          input: {
            cols: 3,
            name: "fecha",
            type: "date",
            label: "Fecha desde",
          },
        },
        {
          input: {
            cols: 3,
            name: "fecha2",
            type: "date",
            label: "Fecha hasta",
          },
        },
        {
          select: {
            cols: 2,
            name: "estatus",
            label: "Estado",
            render: (me) => {
              me.innerHTML = `<option value="">Seleccione</option>`;
              this.state.estatusTramiteCombo.forEach((s) => {
                me.innerHTML += `<option value="${s.id}">${s.descripcion}</option>`;
              });
            },
          },
        },
        {
          button: {
            cols: 2,
            name: "buscaest",
            label: "",
            text: "Buscar",
            class: "form-control btn-warning",
            icon: "fas fa-search",
            click: (e) => {
              this.setState({
                buscarEstablecimientos: bestablecimiento.data(),
              });
              this.setEstablecimientosPage(1);
            },
          },
        },
      ],
    };

    bestablecimiento = Api.form(bestablecimiento);

    let buscadorMP = {
      target: "#buscadorMP",
      nombre: "buscadorMP",
      elementClass: "form-control",
      elements: [
        {
          input: {
            cols: 3,
            name: "folio_solicitud",
            type: "text",
            label: "Folio",
          },
        },
        {
          input: {
            cols: 3,
            name: "establecimiento_envia_nombre",
            type: "text",
            label: "Establecimiento envía",
          },
        },
        {
          input: {
            cols: 3,
            name: "establecimiento_recibe_nombre",
            type: "text",
            label: "Establecimiento recibe",
          },
        },
        {
          input: {
            cols: 3,
            name: "no_registro",
            type: "text",
            label: "Número de registro",
          },
        },

        {
          input: {
            cols: 4,
            name: "nombre_comercial",
            type: "text",
            label: "Nombre comercial",
          },
        },

        {
          input: {
            cols: 3,
            name: "fecha_solicitud",
            type: "date",
            label: "Fecha de solicitud",
          },
        },
        {
          select: {
            cols: 3,
            name: "estatus",
            label: "Estado",
            render: (me) => {
              me.innerHTML = `<option value="">Seleccione</option>`;
              this.state.estatusTramiteCombo.forEach((s) => {
                me.innerHTML += `<option value="${s.id}">${s.descripcion}</option>`;
              });
            },
          },
        },
        {
          button: {
            cols: 2,
            name: "buscamov",
            label: "",
            text: "Buscar",
            class: "form-control btn-warning",
            icon: "fas fa-search",
            click: (e) => {
              this.setState({ buscarMovimientos: buscadorMP.data() });
              this.setMovimientoProductosPage(1);
            },
          },
        },
        // {
        //   select: {
        //     cols: 2,
        //     name: "solicitud",
        //     type: "text",
        //     label: "Trámite",
        //     render: (me) => {
        //       me.innerHTML = `<option value="">Seleccione</option>`;
        //       this.state.accionCombo.forEach((s) => {
        //         me.innerHTML += `<option value="${s.descripcion}">${s.descripcion}</option>`;
        //       });
        //     },
        //   },
        // },
      ],
    };

    buscadorMP = Api.form(buscadorMP);
    /* Termina buscador establecimientos */

    /*Buscador productos */
    let bproducto = {
      target: "#busquedaProducto",
      nombre: "busquedaProducto",
      elementClass: "form-control",
      elements: [
        {
          input: {
            cols: 2,
            name: "folio",
            type: "text",
            label: "Folio",
          },
        },
        {
          select: {
            cols: 2,
            name: "solicitud",
            type: "text",
            label: "Trámite",
            render: (me) => {
              me.innerHTML = `<option value="">Seleccione</option>`;
              this.state.accionCombo.forEach((s) => {
                me.innerHTML += `<option value="${s.descripcion}">${s.descripcion}</option>`;
              });
            },
          },
        },
        {
          input: {
            cols: 4,
            name: "nombre_comercial",
            type: "text",
            label: "Nombre comercial",
          },
        },
        {
          select: {
            cols: 4,
            name: "tipo",
            label: "Tipo producto",
            render: (me) => {
              me.innerHTML = `<option value="">Seleccione</option>`;
              this.state.cat_tipo_producto.forEach((s) => {
                me.innerHTML += `<option value="${s.descripcion}">${s.descripcion}</option>`;
              });
            },
          },
        },
        {
          select: {
            cols: 2,
            name: "ffecha",
            label: "Rango fecha",
            render: (me) => {
              me.innerHTML = `
                            <option value="">Seleccione</option>
                            <option value="fecha_solicitud">Solicitud</option>
                            <option value="fecha_aprueba_sinaip">Aprueba SINAIP</option>
                            <option value="fecha_aprueba_asesoria">Aprueba Asesoria</option>
                      `;
            },
          },
        },
        {
          input: {
            cols: 3,
            name: "fecha",
            type: "date",
            label: "Fecha desde",
          },
        },
        {
          input: {
            cols: 3,
            name: "fecha2",
            type: "date",
            label: "Fecha hasta",
          },
        },
        {
          select: {
            cols: 2,
            name: "estatus",
            label: "Estado",
            render: (me) => {
              me.innerHTML = `<option value="">Seleccione</option>`;
              this.state.estatusTramiteCombo.forEach((s) => {
                me.innerHTML += `<option value="${s.id}">${s.descripcion}</option>`;
              });
            },
          },
        },
        {
          button: {
            cols: 2,
            name: "buscaest",
            label: "",
            text: "Buscar",
            class: "form-control btn-warning",
            icon: "fas fa-search",
            click: (e) => {
              this.setState({ buscarProductos: bproducto.data() });
              this.setProductosPage(1);
            },
          },
        },
      ],
    };

    bproducto = Api.form(bproducto);
    /* Termina buscador productos */

    /* Constancia*/
    let bconsancia = {
      target: "#busquedaConstancia",
      nombre: "busquedaConstancia",
      elementClass: "form-control",
      elements: [
        {
          input: {
            cols: 3,
            name: "folio",
            type: "text",
            label: "Folio",
          },
        },
        {
          input: {
            cols: 3,
            name: "fecha",
            type: "date",
            label: "Fecha desde",
          },
        },
        {
          input: {
            cols: 3,
            name: "fecha2",
            type: "date",
            label: "Fecha hasta",
          },
        },
        {
          select: {
            cols: 3,
            name: "tipo",
            label: "Tipo constancia",
            render: (me) => {
              me.innerHTML = `<option value="">Seleccione</option>`;
              this.state.cat_constancia_tipo.forEach((s) => {
                me.innerHTML += `<option value=${s.id}>${s.descripcion}</option>`;
              });
            },
          },
        },
        {
          input: {
            cols: 6,
            name: "usuario_solicita",
            type: "text",
            label: "Nombre",
          },
        },
        {
          select: {
            cols: 3,
            name: "estatus",
            label: "Estado",
            render: (me) => {
              me.innerHTML = `<option value="">Seleccione</option>`;
              this.state.estatusTramiteCombo.forEach((s) => {
                me.innerHTML += `<option value=${s.id}>${s.descripcion}</option>`;
              });
            },
          },
        },
        {
          button: {
            cols: 3,
            name: "buscarcons",
            label: "",
            text: "Buscar",
            class: "form-control btn-warning ",
            icon: "fas fa-search",
            click: (e) => {
              this.setState({ buscaConstancias: bconsancia.data() });
              this.setConstanciasPage(1);
            },
          },
        },
      ],
    };
    bconsancia = Api.form(bconsancia);

    /* Inicia buscador medico veterinario */
    let bmedicov = {
      target: "#busquedaMedicoV",
      nombre: "busquedaMedicoV",
      elementClass: "form-control",
      elements: [
        {
          input: {
            cols: 4,
            name: "folio",
            type: "text",
            label: "Folio solicitud",
          },
        },
        {
          select: {
            cols: 2,
            name: "solicitud",
            type: "text",
            label: "Solicitud",
            render: (me) => {
              me.innerHTML = `<option value="">Seleccione</option>`;
              this.state.accionCombo.forEach((s) => {
                me.innerHTML += `<option value=${s.descripcion}>${s.descripcion}</option>`;
              });
            },
          },
        },
        {
          input: {
            cols: 6,
            name: "nombre",
            type: "text",
            label: "Nombre",
          },
        },
        {
          input: {
            cols: 2,
            name: "fecha",
            type: "date",
            label: "Fecha solicitud desde",
          },
        },
        {
          input: {
            cols: 2,
            name: "fecha2",
            type: "date",
            label: "Fecha solicitud hasta",
          },
        },
        {
          select: {
            cols: 2,
            name: "estatus",
            label: "Estado",
            render: (me) => {
              me.innerHTML = `<option value="">Seleccione</option>`;
              this.state.estatusTramiteCombo.forEach((s) => {
                me.innerHTML += `<option value=${s.id}>${s.descripcion}</option>`;
              });
            },
          },
        },
        {
          input: {
            cols: 2,
            name: "fecha3",
            type: "date",
            label: "Fecha verificación desde",
          },
        },
        {
          input: {
            cols: 2,
            name: "fecha4",
            type: "date",
            label: "Fecha verificación hasta",
          },
        },
        {
          button: {
            cols: 2,
            name: "buscamv",
            label: "",
            text: "Buscar",
            class: "form-control btn-warning ",
            icon: "fas fa-search",
            click: (e) => {
              this.setState({ buscaMedicoV: bmedicov.data() });
              this.setMedicoVeterinarioPage(1);
            },
          },
        },
      ],
    };

    bmedicov = Api.form(bmedicov);
    /* Termina buscador medico veterinario */

    let bcertificado = {
      target: "#busquedaCertificados",
      nombre: "busquedaCertificados",
      elementClass: "form-control",
      elements: [
        {
          input: {
            cols: 3,
            name: "folio_certificado",
            type: "text",
            label: "Folio certificado",
          },
        },
        {
          select: {
            cols: 3,
            name: "tipo_certificado",
            type: "text",
            label: "Tipo certificado",
            render: (me) => {
              me.innerHTML = `<option value="">Seleccione</option>`;
              this.state.cat_tipo_certificado.forEach((s) => {
                me.innerHTML += `<option value=${s.id}>${s.descripcion}</option>`;
              });
            },
          },
        },
        {
          input: {
            cols: 3,
            name: "folio_solicitud",
            type: "text",
            label: "Folio solicitud",
          },
        },
        {
          select: {
            cols: 3,
            name: "solicitud",
            type: "text",
            label: "Solicitud",
            render: (me) => {
              me.innerHTML = `<option value="">Seleccione</option>`;
              this.state.accionCombo.forEach((s) => {
                me.innerHTML += `<option value=${s.descripcion}>${s.descripcion}</option>`;
              });
            },
          },
        },
        ,
        {
          input: {
            cols: 2,
            name: "fecha",
            type: "date",
            label: "Fecha solicitud desde",
          },
        },
        {
          input: {
            cols: 2,
            name: "fecha2",
            type: "date",
            label: "Fecha solicitud hasta",
          },
        },
        {
          select: {
            cols: 2,
            name: "estatus",
            label: "Estado",
            render: (me) => {
              me.innerHTML = `<option value="">Seleccione</option>`;
              this.state.estatusTramiteCombo.forEach((s) => {
                if (s.id < 10) {
                  me.innerHTML += `<option value=${s.id}>${s.descripcion}</option>`;
                }
              });
            },
          },
        },
        {
          input: {
            cols: 2,
            name: "fecha3",
            type: "date",
            label: "Fecha verificación desde",
          },
        },
        {
          input: {
            cols: 2,
            name: "fecha4",
            type: "date",
            label: "Fecha verificación hasta",
          },
        },
        {
          button: {
            cols: 2,
            name: "buscareg",
            label: "",
            text: "Buscar",
            class: "form-control btn-warning ",
            icon: "fas fa-search",
            click: (e) => {
              this.setState({ buscaCertificados: bcertificado.data() });
              this.setCertificadoPage(1);
            },
          },
        },
      ],
    };

    bcertificado = Api.form(bcertificado);
    /* Termina buscador medico veterinario */

    /**DEFINO MI FORMA para BUSQUEDA de establecimientos */

    let busqueda_establecimientos = Api.form({
      target: "#busqueda_establecimiento",
      onchange: (me, data, serial) => {
        forma.go(1, serial);
      },
      render: (form) => {
        let tipo_accion = Api.loadCatalogue("cat_accion");
        let option_a = "<option value=0>Seleccione tipo de solicitud</option>";
        for (let p in tipo_accion) {
          option_a += `<option value="${tipo_accion[p].id}">
                    ${tipo_accion[p].descripcion}
                </option>`;
        }
        form.querySelector("#accion_id").innerHTML = option_a;

        /*  //ESTATUS
            let tipo_sitio = Api.loadCatalogue("cat_evento_sitio")
            let option_s = "<option value=0>Seleccione tipo de sitio</option>";
            for (let p in tipo_sitio) {
                option_s += `<option value="${tipo_sitio[p].id}">
                    ${tipo_sitio[p].descripcion}
                </option>`;
            }
            form.querySelector("#tipo_sitio").innerHTML = option_s;
            
            //TIPO ESTABLECIMIENTO
            let tipo_sitio = Api.loadCatalogue("cat_evento_sitio")
            let option_s = "<option value=0>Seleccione tipo de sitio</option>";
            for (let p in tipo_sitio) {
                option_s += `<option value="${tipo_sitio[p].id}">
                    ${tipo_sitio[p].descripcion}
                </option>`;
            }
            form.querySelector("#tipo_sitio").innerHTML = option_s;
            //TIPO ACTIVIDAD
            let tipo_sitio = Api.loadCatalogue("cat_evento_sitio")
            let option_s = "<option value=0>Seleccione tipo de sitio</option>";
            for (let p in tipo_sitio) {
                option_s += `<option value="${tipo_sitio[p].id}">
                    ${tipo_sitio[p].descripcion}
                </option>`;
            }
            form.querySelector("#tipo_sitio").innerHTML = option_s; */
      },
      elementClass: "form-control",
      elements: [
        {
          input: {
            type: "text",
            name: "folio_solicitud",
            label: "Folio de la solicitud",
            placeHolder: "Folio solicitud",
            cols: 3,
            value: "",
          },
        },
        {
          select: {
            type: "text",
            name: "accion_id",
            label: "Trámite",
            placeHolder: "Solicitud",
            cols: 3,
            value: "",
          },
        },
        {
          input: {
            type: "text",
            name: "razon_social",
            label: "Ingresa razón social",
            placeHolder: "Razón social",
            cols: 3,
            value: "",
          },
        },
        {
          select: {
            type: "text",
            name: "tipo_establecimiento_id",
            label: "Tipo de establecimiento",
            placeHolder: "Tipo de establecimiento",
            cols: 3,
            value: "",
          },
        },
        {
          select: {
            type: "text",
            name: "tipo_actividad_id",
            label: "Tipo de actividad",
            placeHolder: "Tipo de actividad",
            cols: 3,
            value: "",
          },
        },
        {
          input: {
            type: "date",
            name: "actividad_id",
            label: "Fecha solicitud",
            placeHolder: "Ingresa la fecha de la solicitud",
            cols: 3,
            value: "",
          },
        },
        {
          select: {
            type: "text",
            name: "estatus_tramite_id",
            label: "Estado",
            placeHolder: "Estado",
            cols: 3,
            value: "",
          },
        },

        /* {
                input: {
                    type: "date",
                    name: "fecha_fin",
                    label: "Fecha fin solicitud",
                    placeHolder: "Ingresa la fecha fin",
                    cols: 2,
                    value: ""
                }
            },  */
      ],
    });
    Api.dummy(busqueda_establecimientos);

    let bPrecertificado = {
      target: "#f_busqueda_pre",
      elementClass: "form-control",
      elements: [
        {
          input: {
            type: "text",
            name: "folio",
            label: "Folio precertificado",
            placeHolder: "Folio precertificado",
            cols: 4,
            value: "",
          },
        },
        {
          input: {
            type: "text",
            name: "folio_solicitud",
            label: "Folio solicitud",
            placeHolder: "Folio solicitud",
            cols: 4,
            value: "",
          },
        },
        /*         {
          input: {
            type: "text",
            name: "fabricante",
            label: "Establecimiento",
            placeHolder: "Fabricante",
            cols: 5,
            value: "",
          },
        },
        {
          input: {
            type: "text",
            name: "pais",
            label: "País de origen",
            placeHolder: "País de origen",
            cols: 4,
            value: "",
          },
        }, */
        {
          select: {
            type: "text",
            name: "tipo_precertificado",
            label: "Tipo de Precertificado",
            placeHolder: "Tipo de precertificado",
            cols: 4,
            //value: "",
            render: (me) => {
              me.innerHTML = `<option value="">Seleccione</option>`;
              this.state.cat_tipo_precertificado.forEach((s) => {
                me.innerHTML += `<option value="${s.id}">${s.descripcion}</option>`;
              });
            },
          },
        },
        {
          input: {
            type: "date",
            name: "fecha",
            label: "Fecha desde",
            cols: 3,
            value: "",
          },
        },
        {
          input: {
            type: "date",
            name: "fecha2",
            label: "Fecha hasta",
            cols: 3,
            value: "",
          },
        },
        {
          select: {
            cols: 3,
            name: "estado",
            label: "Estado",
            render: (me) => {
              me.innerHTML = `<option value="">Seleccione</option>`;
              this.state.estatusTramiteCombo.forEach((s) => {
                me.innerHTML += `<option value=${s.id}>${s.descripcion}</option>`;
              });
            },
          },
        },
        {
          button: {
            name: "buscar",
            class: "form-control btn-orange",
            icon: "fa fa-search",
            cols: 3,
            text: "Buscar",
            click: (e) => {
              this.setState({ buscarPrecertificado: bPrecertificado.data() });
              this.setPrecertificadosPage(1);
            },
          },
        },
      ],
    };

    bPrecertificado = Api.form(bPrecertificado);

    /* BUSQUEDA AUTORIZACION*/
    let bAutorizacion = {
      target: "#busquedaAutorizacion",
      nombre: "busquedaAutorizacion",
      elementClass: "form-control",
      elements: [
        {
          input: {
            cols: 4,
            name: "folio_solicitud",
            type: "text",
            label: "Folio",
            placeHolder: "Folio solicitud",
          },
        },
        {
          input: {
            cols: 8,
            name: "razon_social",
            type: "text",
            label: "Establecimiento",
            placeHolder: "Establecimiento",
          },
        },
        {
          input: {
            cols: 4,
            name: "fecha",
            type: "date",
            label: "Fecha desde",
          },
        },
        {
          input: {
            cols: 4,
            name: "fecha2",
            type: "date",
            label: "Fecha hasta",
          },
        },
        {
          select: {
            cols: 2,
            name: "estatus",
            label: "Estatus",
            render: (me) => {
              me.innerHTML = `<option value="">Seleccione</option>`;
              this.state.estatusTramiteCombo.forEach((s) => {
                me.innerHTML += `<option value=${s.id}>${s.descripcion}</option>`;
              });
            },
          },
        },
        {
          button: {
            cols: 2,
            name: "buscarAutorizacion",
            label: "",
            text: "Buscar",
            class: "form-control btn-warning ",
            icon: "fas fa-search",
            click: (e) => {
              this.setState({ buscarAutorizacionDA: bAutorizacion.data() });
              this.setAutorizacionPage(1);
            },
          },
        },
      ],
    };

    bAutorizacion = Api.form(bAutorizacion);
    /* Termina buscador AUTORIZACION */

    /** BUSCADOR PARA CASOS ESPECIALES */
    let buscadorCE = {
      target: "#buscadorCE",
      nombre: "buscadorCE",
      elementClass: "form-control",
      elements: [
        {
          input: {
            cols: 3,
            name: "folio_solicitud",
            type: "text",
            label: "Folio solicitud",
          },
        },
        {
          input: {
            cols: 3,
            name: "fecha_solicitud",
            type: "date",
            label: "Fecha solicitud",
          },
        },
        {
          select: {
            cols: 3,
            name: "tipo_importacion",
            type: "text",
            label: "Tipo importación",
            render: (me) => {
              me.innerHTML = `<option value="">Seleccione</option>`;
              this.state.cat_tipo_importacion.forEach((ti) => {
                me.innerHTML += `<option value="${ti.id}">${ti.descripcion}</option>`;
              });
            },
          },
        },
        {
          select: {
            cols: 3,
            name: "estatus_tramite",
            type: "text",
            label: "Estado",
            render: (me) => {
              me.innerHTML = `<option value="">Seleccione</option>`;
              this.state.cat_estatus_tramite_ce
                .filter((item) =>
                  ["4", "5", "9", "7", "16", "18"].includes(item.id)
                )
                .forEach((t) => {
                  me.innerHTML += `<option value="${t.id}">${t.descripcion}</option>`;
                });
            },
          },
        },

        {
          input: {
            cols: 4,
            name: "establecimiento_importador",
            type: "text",
            label: "Establecimiento importador",
          },
        },

        {
          input: {
            cols: 4,
            name: "establecimiento_fabricante",
            type: "text",
            label: "Establecimiento fabricante",
          },
        },

        {
          input: {
            cols: 2,
            name: "fecha_verificacion",
            type: "date",
            label: "Fecha verificación",
          },
        },
        {
          button: {
            cols: 2,
            name: "buscamov",
            label: "",
            text: "Buscar",
            class: "form-control btn-warning",
            icon: "fas fa-search",
            click: (e) => {
              this.setState({ buscarCasosEspeciales: buscadorCE.data() });
              this.setCasosEspecialesPage(1);
            },
          },
        },
        // {
        //   select: {
        //     cols: 2,
        //     name: "solicitud",
        //     type: "text",
        //     label: "Trámite",
        //     render: (me) => {
        //       me.innerHTML = `<option value="">Seleccione</option>`;
        //       this.state.accionCombo.forEach((s) => {
        //         me.innerHTML += `<option value="${s.descripcion}">${s.descripcion}</option>`;
        //       });
        //     },
        //   },
        // },
      ],
    };

    buscadorCE = Api.form(buscadorCE);
    /** TERMINA BUSCADOR PARA CASOS ESPECIALES */

    /**DEFINO MI FORMA para detalles de establecimiento */
    let forma = {
      target: "#establecimiento",
      nombre: "forma",
      elementClass: "form-control",
      elements: [
        {
          input: {
            cols: 6,
            name: "razon_social",
            type: "text",
            label: "Razón social",
            disabled: true,
          },
        },
        {
          input: {
            cols: 6,
            name: "telefono",
            type: "text",
            label: "Teléfono activo",
            disabled: true,
          },
        },
        {
          input: {
            cols: 6,
            name: "correo_electronico",
            type: "text",
            label: "Correo electrónico activo",
            disabled: true,
          },
        },
        {
          input: {
            cols: 6,
            name: "numero_de_identificacion",
            type: "text",
            label: "Cédula RUC",
            disabled: true,
          },
        },
        {
          input: {
            cols: 12,
            name: "direccion",
            type: "text",
            label: "Dirección",
            disabled: true,
          },
        },
        {
          input: {
            cols: 6,
            name: "municipio",
            type: "text",
            label: "Municipio",
            disabled: true,
          },
        },
        {
          input: {
            cols: 6,
            name: "departamento",
            type: "text",
            label: "Departamento",
            disabled: true,
          },
        },
        {
          input: {
            cols: 6,
            name: "latitud",
            type: "text",
            label: "Latitud",
            disabled: true,
          },
        },
        {
          input: {
            cols: 6,
            name: "longitud",
            type: "text",
            label: "Longitud",
            disabled: true,
          },
        },
        {
          input: {
            cols: 12,
            name: "pais_texto",
            type: "text",
            label: "País",
            disabled: true,
          },
        },
      ],
    };
    this.detalleEstablecimiento = Api.form(forma);

    /**DEFINO MI FORMA CLASIFICACION */
    let formaClasificacion = {
      target: "#clasificacion",
      nombre: "clasificacion",
      elementClass: "form-control",
      render: (me) => {
        let ingredientes = Api.loadCatalogue("cat_grupo_ingrediente");
        let grupotpl = "<option value=0>Seleccione grupo</option>";
        for (let ingrediente in ingredientes) {
          grupotpl += `<option value="${ingredientes[ingrediente].id}">
              ${ingredientes[ingrediente].descripcion}
          </option>`;
        }
        me.querySelector("#grupo_ingrediente_id").innerHTML = grupotpl;

        me.querySelector("#clase_producto_id").innerHTML =
          "<option value=''>Cargando espere...</option>";

        let cates = Api.loadCatalogue("cat_categorizacion_oficial");
        let catesTpl = "<option value=0>Seleccione clase</option>";
        for (let cate in cates) {
          catesTpl += `<option value="${cates[cate].id}">
              ${cates[cate].descripcion}
          </option>`;
        }
        me.querySelector("#categorizacion_oficial_id").innerHTML = catesTpl;
      },
      elements: [
        {
          select: {
            cols: 12,
            name: "grupo_ingrediente_id",
            label: "Grupo de riesgo<span class='text-danger'>*</span>",
          },
        },
        {
          select: {
            cols: 12,
            name: "clase_producto_id",
            label:
              "Clasificación de producto<span class='text-danger'>*</span>",
          },
        },
        {
          select: {
            cols: 12,
            name: "categorizacion_oficial_id",
            label: "Categoría de venta<span class='text-danger'>*</span>",
          },
        },
        {
          input: {
            cols: 6,
            type: "text",
            name: "tomo",
            label: "Tomo<span class='text-danger'>*</span>",
          },
        },
        {
          input: {
            cols: 6,
            type: "text",
            name: "folio",
            label: "Folio<span class='text-danger'>*</span>",
          },
        },
        {
          input: {
            cols: 6,
            type: "number",
            name: "no_registro_drycip",
            label: "Número de registro<span class='text-danger'>*</span>",
            min: "1",
          },
        },
        {
          input: {
            cols: 6,
            type: "text",
            name: "dossier",
            label: "Dossier<span class='text-danger'>*</span>",
          },
        },
        {
          input: {
            type: "checkbox",
            name: "asesoria",
            label: "Solicitar revisión de asesoría legal",
            cols: 12,
          },
        },
      ],
    };

    this.clasificacion = Api.form(formaClasificacion);

    /**DEFINO MI FORMA para detalles de representante TABLA*/
    this.representante_legal = {
      target: "#representanteLegal",
      tableClass: "table table-striped m-b-0 table-hover ", //blockea las clases de estilo de la tabla
      rowsPerPage: [5, 10, 25, 50, 100],
      progressText: "Cargando representantes legales", //El mensaje de carga
      hidePager: true, //Oculta el paginador
      rows: {
        nombres: {
          label: "Nombres",
        },
        apellido_paterno: {
          label: "Apellido paterno",
        },
        apellido_materno: {
          label: "Apellido materno",
        },
        correo_electronico: {
          label: "Correo electrónico",
        },
      },
    };

    /**DEFINO MI FORMA para detalles de regente TABLA*/
    this.regente = {
      target: "#gridRegente",
      tableClass: "table table-striped m-b-0 table-hover ", //blockea las clases de estilo de la tabla style="pointer-events: none;"
      rowsPerPage: [5, 10, 25, 50, 100],
      progressText: "Cargando regentes", //El mensaje de carga
      hidePager: true, //Oculta el paginador
      rows: {
        nombres: {
          label: "Nombres",
        },
        apellido_paterno: {
          label: "Apellido paterno",
        },
        apellido_materno: {
          label: "Apellido materno",
        },
        guid: {
          label: "GUID",
        },
      },
    };

    /**DEFINO MI FORMA para detalles de características TABLA*/
    this.condiciones = {
      target: "#condiciones",
      tableClass: "table table-striped m-b-0 table-hover ", //blockea las clases de estilo de la tabla
      progressText: "Cargando condiciones", //El mensaje de carga
      hidePager: true, //Oculta el paginador
      rowsPerPage: [100],
      rows: {
        condiciones: {
          label: "Condiciones",
        },
      },
    };

    let caracteristicas = {
      target: "#caracteristicas",
      disabled: false,
      nombre: "formatica",
      render: (forma) => {},
      elementClass: "form-control",
      elements: [
        {
          input: {
            cols: 12,
            name: "area",
            type: "text",
            label: "Área total(m²)",
            disabled: true,
          },
        },
        {
          input: {
            cols: 12,
            name: "direccion_bodegas",
            type: "text",
            label: "Dirección de bodegas y almacenamiento",
            disabled: true,
          },
        },
      ],
    };
    this.detalleCaracteristicas = Api.form(caracteristicas);

    /**********DEFINO MI FORMA para detalles del tipo de producto TABLA*/

    this.principioActivo = {
      target: "#producto_activo",
      tableClass: "table table-striped m-b-0 table-hover blockea", //las clases de estilo de la tabla
      rowsPerPage: [5, 10, 25, 50, 100],
      progressText: "Cargando principio_activo", //El mensaje de carga
      hidePager: true, //Oculta el paginador

      rows: {
        ingrediente: {
          label: "Principio activo",
        },
        concentracion: {
          label: "Concentración",
        },
        unidad_medida: {
          label: "Unidad de medida pa",
        },
      },
    };

    this.excipiente = {
      target: "#excipiente",
      tableClass: "table table-striped m-b-0 table-hover blockea", // las clases de estilo de la tabla
      rowsPerPage: [5, 10, 25, 50, 100],
      progressText: "Cargando excipiente", //El mensaje de carga

      hidePager: true, //Oculta el paginador
      rows: {
        excipiente: {
          label: "excipiente",
        },
        concentracion: {
          label: "Concentración",
        },
        unidad_medida: {
          label: "Unidad de medida pa",
        },
      },
    };

    this.tabla_dosis = {
      target: "#dosis",
      tableClass: "table table-striped m-b-0 table-hover blockea", //las clases de estilo de la tabla
      rowsPerPage: [5, 10, 25, 50, 100],
      progressText: "Cargando dosis", //El mensaje de carga
      hidePager: true, //Oculta el paginador
      rows: {
        dosis: {
          label: "Dosis por especie y vía de administracion",
        },
        especie: {
          label: "Especie de destino",
        },
        categoria: {
          label: "Categoría",
        },
      },
    };

    this.tabla_envase = {
      target: "#envase",
      tableClass: "table table-striped m-b-0 table-hover blockea", // las clases de estilo de la tabla
      rowsPerPage: [5, 10, 25, 50, 100],
      progressText: "Cargando envase", //El mensaje de carga
      hidePager: true, //Oculta el paginador
      rows: {
        envase: {
          label: "Tipo envase/empaque",
        },
        /*  presentacion: {
          label: "Presentaciones",
        }, */
        cantidad: {
          label: "Presentaciones cantidad",
        },
        unidad_medida: {
          label: "Unidad de medida",
        },
      },
    };

    this.tabla_periodo = {
      target: "#periodo",
      tableClass: "table table-striped m-b-0 table-hover blockea", //las clases de estilo de la tabla
      progressText: "Cargando periodo", //El mensaje de carga
      hidePager: true, //Oculta el paginador
      rowsPerPage: [5, 10, 25, 50, 100],
      rows: {
        periodo: {
          label: "Periodo de retiro/descarte",
        },
        tiempo: {
          label: "Unidad de tiempo",
        },
        especie: {
          label: "Especie",
        },
      },
    };

    this.tabla_biologica = {
      //source:'app/getRegenteEstablecimiento?id=26&',
      target: "#biologica",
      tableClass: "table table-striped m-b-0 table-hover blockea", // las clases de estilo de la tabla
      rowsPerPage: [5, 10, 25, 50, 100],
      progressText: "Cargando principio_activo", //El mensaje de carga
      hidePager: true, //Oculta el paginador

      rows: {
        composicion: {
          label: "Composición biológica",
        },
        titulo: {
          label: "Título",
        },
      },
    };

    this.tabla_quimica = {
      //source:'app/getRegenteEstablecimiento?id=26&',
      target: "#quimica",
      tableClass: "table table-striped m-b-0 table-hover blockea", //las clases de estilo de la tabla
      rowsPerPage: [5, 10, 25, 50, 100],
      progressText: "Cargando principio_activo", //El mensaje de carga
      hidePager: true, //Oculta el paginador

      rows: {
        composicion: {
          label: "Composición química",
        },
        concentracion: {
          label: "Concentración",
        },
        unidad_medida: {
          label: "Unidad de medida",
        },
      },
    };
    /**  DEFINO MI FORMA PARA EL DETALLE DEL PRODUCTO **/
    let detalle_producto = {
      target: "#d_producto",
      disabled: false,
      nombre: "producto",
      render: (producto) => {},
      elementClass: "form-control",
      elements: [
        {
          input: {
            cols: 12,
            name: "nombre_comercial",
            type: "text",
            label: "Nombre comercial",
            disabled: true,
          },
        },
        {
          input: {
            cols: 12,
            name: "clasificacion",
            type: "text",
            label: "Clasificación",
            disabled: true,
          },
        },
        {
          input: {
            cols: 12,
            name: "precauciones_generales",
            type: "textarea",
            label: "Precauciones generales",
            disabled: true,
          },
        },
        {
          input: {
            cols: 6,
            name: "precauciones_uso",
            type: "textarea",
            label: "Precauciones de uso",
            disabled: true,
          },
        },
        {
          input: {
            cols: 6,
            name: "precauciones_almacenamiento",
            type: "textarea",
            label: "Precauciones almacenamiento",
            disabled: true,
          },
        },
        {
          input: {
            cols: 8,
            name: "caducidad",
            type: "text",
            label: "Caducidad del producto",
            disabled: true,
          },
        },
        {
          input: {
            cols: 4,
            name: "medida_tiempo",
            type: "text",
            label: "Tiempo",
            disabled: true,
          },
        },
        {
          input: {
            cols: 12,
            name: "forma_farmaceutica",
            type: "text",
            label: "Forma farmaceutica",
            disabled: true,
          },
        },
        {
          input: {
            cols: 12,
            name: "pais",
            type: "text",
            label: "País de origen",
            disabled: true,
          },
        },
        {
          input: {
            cols: 12,
            name: "uso",
            type: "textarea",
            label: "Indicaciones de uso",
            disabled: true,
          },
        },
        {
          input: {
            cols: 12,
            name: "instrucciones_uso",
            type: "textarea",
            label: "Instruccioness de uso",
            disabled: true,
          },
        },
        {
          input: {
            cols: 12,
            name: "validez_preparacion",
            type: "text",
            label: "Validez para preparación extemporánea",
            disabled: true,
          },
        },
        {
          input: {
            cols: 12,
            name: "propiedades_inmunologicas",
            type: "text",
            label: "Propiedades inmunológicas",
            disabled: true,
          },
        },
        {
          input: {
            cols: 6,
            name: "fabricante",
            type: "text",
            label: "Fabricante",
            disabled: true,
          },
        },
        {
          input: {
            cols: 6,
            name: "titular",
            type: "text",
            label: "Titular",
            disabled: true,
          },
        },
      ],
    };
    this.detalleProducto = Api.form(detalle_producto);

    /**DEFINO MI FORMA para detalles de representante para producto TABLA*/
    this.representante_legal_pro = {
      //source: "app/getRepresentanteProducto?id=5&",
      target: "#representanteLegal_pro",
      tableClass: "table table-striped m-b-0 table-hover blockea", //las clases de estilo de la tabla
      rowsPerPage: [5, 10, 25, 50, 100],
      progressText: "Cargando representantes legales", //El mensaje de carga
      hidePager: true, //Oculta el paginador
      rows: {
        nombres: {
          label: "Nombres",
        },
        apellido_paterno: {
          label: "Apellido paterno",
        },
        apellido_materno: {
          label: "Apellido materno",
        },
        correo_electronico: {
          label: "Correo electrónico",
        },
      },
    };

    /**DEFINO MI FORMA para detalles de regente para producto TABLA*/
    this.regente_pro = {
      //source:'app/getRegenteProducto?id=1&',
      target: "#regente_pro",
      tableClass: "table table-striped m-b-0 table-hover blockea", //las clases de estilo de la tabla
      rowsPerPage: [5, 10, 25, 50, 100],
      progressText: "Cargando regentes", //El mensaje de carga
      hidePager: true, //Oculta el paginador
      rows: {
        nombres: {
          label: "Nombres",
        },
        apellido_paterno: {
          label: "Apellido paterno",
        },
        apellido_materno: {
          label: "Apellido materno",
        },
        guid: {
          label: "GUID",
        },
      },
    };

    let anotacion_marginal_producto = {
      target: "#anotacion_marginal_prod",
      disabled: false,
      nombre: "anotacion_marginal_prod",
      render: (e) => {},
      elementClass: "form-control",
      elements: [
        {
          input: {
            cols: 12,
            name: "anotacion_marginal_peticion",
            type: "text",
            label: "Anotación Marginal: ",
            disabled: true,
          },
        },
      ],
    };

    this.AnotacionProducto = Api.form(anotacion_marginal_producto);

    this.tabla_modo_empleo = {
      target: "#modo_empleo",
      tableClass: "table table-striped m-b-0 table-hover blockea", //las clases de estilo de la tabla
      rowsPerPage: [5, 10, 25, 50, 100],
      progressText: "Cargando detalles", //El mensaje de carga
      hidePager: true, //Oculta el paginador
      rows: {
        dosis: {
          label: "Modo de empleo",
        },
        especie: {
          label: "Especie de destino",
        },
        categoria: {
          label: "Categoría",
        },
      },
    };

    this.tabla_componentes = {
      //source:'app/getRegenteEstablecimiento?id=26&',
      target: "#componente",
      tableClass: "table table-striped m-b-0 table-hover blockea", //las clases de estilo de la tabla
      rowsPerPage: [5, 10, 25, 50, 100],
      progressText: "Cargando componentes", //El mensaje de carga
      hidePager: true, //Oculta el paginador
      rows: {
        componente: {
          label: "Componentes",
        },
        concentracion: {
          label: "Concentración",
        },
      },
    };

    this.tabla_especies = {
      target: "#especie_interes",
      tableClass: "table table-striped m-b-0 table-hover blockea", //las clases de estilo de la tabla
      rowsPerPage: [5, 10, 25, 50, 100],
      progressText: "Cargando especies", //El mensaje de carga
      hidePager: true, //Oculta el paginador
      rows: {
        especie_interes: {
          label: "Especie de interés diagnóstico",
        },
      },
    };

    this.tabla_presentacion = {
      target: "#presentaciones",
      tableClass: "table table-striped m-b-0 table-hover blockea", //las clases de estilo de la tabla
      rowsPerPage: [5, 10, 25, 50, 100],
      progressText: "Cargando presentaciones", //El mensaje de carga
      hidePager: true, //Oculta el paginador
      rows: {
        /* presentacion: {
          label: "Presentaciones",
        }, */
        cantidad: {
          label: "Presentaciones cantidad",
        },
        unidad_medida: {
          label: "Unidad de medida",
        },
      },
    };

    this.tabla_analisis = {
      target: "#analisis",
      tableClass: "table table-striped m-b-0 table-hover blockea", //las clases de estilo de la tabla
      rowsPerPage: [5, 10, 25, 50, 100],
      progressText: "Cargando datos", //El mensaje de carga
      hidePager: true, //Oculta el paginador
      rows: {
        analisis: {
          label: "Análisis garantizado",
        },
        porcentaje: {
          label: "Porcentaje(%)",
        },
      },
    };

    this.tabla_ingredientes = {
      target: "#ingredientes",
      tableClass: "table table-striped m-b-0 table-hover blockea", //las clases de estilo de la tabla
      rowsPerPage: [5, 10, 25, 50, 100],
      progressText: "Cargando datos", //El mensaje de carga
      hidePager: true, //Oculta el paginador
      rows: {
        ingrediente: {
          label: "Ingrediente",
        },
      },
    };

    /** DEFINO NI FORMA PARA DETALLE DE MEDICO VETERINARIO**/
    let forma_mv = {
      target: "#medico_veterinario",
      nombre: "forma_mv",
      elementClass: "form-control",
      elements: [
        {
          input: {
            cols: 4,
            name: "nombres",
            type: "text",
            label: "Nombre",
            disabled: true,
          },
        },
        {
          input: {
            cols: 4,
            name: "apellido_paterno",
            type: "text",
            label: "Apellido Paterno",
            disabled: true,
          },
        },
        {
          input: {
            cols: 4,
            name: "apellido_materno",
            type: "text",
            label: "Apellido Materno",
            disabled: true,
          },
        },
        {
          input: {
            cols: 12,
            name: "direccion",
            type: "text",
            label: "Dirección",
            disabled: true,
          },
        },
        {
          input: {
            cols: 6,
            name: "telefono",
            type: "text",
            label: "Teléfono activo",
            disabled: true,
          },
        },

        /*   {
          input: {
            cols: 6,
            name: "correo_electronico",
            type: "text",
            label: "Correo electrónico activo",
            disabled: true,
          },
        }, */

        {
          input: {
            cols: 6,
            name: "codigo_ipsa",
            type: "text",
            label: "Codigo IPSA",
            disabled: true,
          },
        },
      ],
    };
    this.detalleMedicoVeterinario = Api.form(forma_mv);

    this.establecimientos_medico_veterinario = {
      target: "#establecimientos_mv",
      tableClass: "table table-striped m-b-0 table-hover ", //blockea las clases de estilo de la tabla
      progressText: "Cargando establecimientos", //El mensaje de carga
      hidePager: true, //Oculta el paginador
      rowsPerPage: [5, 10, 25, 50, 100],
      rows: {
        razon_social: {
          label: "Razón social",
        },
        guid: {
          label: "GUID",
        },
      },
    };

    /* DEFINO FORMA CONSTANCIA */
    this.cons_form_regente = Api.form({
      target: "#f_cons_regente",
      disabled: false,
      nombre: "cons_regente",
      render: (cons_regente) => {},
      elementClass: "form-control",
      elements: [
        {
          input: {
            name: "tipo_constancia",
            label: "Tipo de constancia",
            type: "text",
            cols: 12,
            disabled: true,
          },
        },
        {
          input: {
            name: "tipo_regente",
            label: "Tipo de regente",
            type: "text",
            cols: 12,
            disabled: true,
          },
        },
        {
          input: {
            name: "razon_social",
            label: "Establecimiento",
            type: "text",
            cols: 12,
            disabled: true,
          },
        },
      ],
    });

    this.cons_form_actividad = Api.form({
      target: "#f_cons_actividad",
      disabled: false,
      nombre: "cons_actividad",
      render: (cons_actividad) => {},
      elementClass: "form-control",
      elements: [
        {
          input: {
            name: "tipo_constancia",
            label: "Tipo de constancia",
            type: "text",
            cols: 12,
            disabled: true,
          },
        },
        {
          input: {
            name: "razon_social",
            label: "Establecimiento",
            type: "text",
            cols: 12,
            disabled: true,
          },
        },
        {
          input: {
            name: "actividad",
            label: "Actividad",
            type: "text",
            cols: 12,
            disabled: true,
          },
        },
      ],
    });

    this.cons_establecimiento = Api.form({
      target: "#f_cons_establecimiento",
      disabled: false,
      nombre: "cons_establecimiento",
      render: (cons_actividad) => {},
      elementClass: "form-control",
      elements: [
        {
          input: {
            name: "tipo_constancia",
            label: "Tipo de constancia",
            type: "text",
            cols: 12,
            disabled: true,
          },
        },
        {
          input: {
            name: "razon_social",
            label: "Establecimiento",
            type: "text",
            cols: 12,
            disabled: true,
          },
        },
      ],
    });

    this.cons_representante = Api.form({
      target: "#f_cons_representante",
      disabled: false,
      nombre: "cons_representante",
      render: (cons_actividad) => {},
      elementClass: "form-control",
      elements: [
        {
          input: {
            name: "tipo_constancia",
            label: "Tipo de constancia",
            type: "text",
            cols: 12,
            disabled: true,
          },
        },
        {
          input: {
            name: "razon_social",
            label: "Establecimiento",
            type: "text",
            cols: 12,
            disabled: true,
          },
        },
        {
          input: {
            name: "representante_texto",
            label: "Representante legal",
            type: "text",
            cols: 12,
            disabled: true,
          },
        },
      ],
    });

    this.cons_txt_libre = Api.form({
      target: "#f_cons_txt_libre",
      disabled: false,
      nombre: "cons_txt_libre",
      render: (cons_txt_libre) => {},
      elementClass: "form-control",
      elements: [
        {
          input: {
            name: "tipo_constancia",
            label: "Tipo de constancia",
            type: "text",
            cols: 12,
            disabled: true,
          },
        },
        {
          textarea: {
            name: "texto",
            label: "Petición",
            //type: "textarea",
            cols: 12,
            rows: 5,
            disabled: true,
          },
        },
      ],
    });

    this.constancia_AM = Api.form({
      target: "#f_cons_AM",
      nombre: "cons_am",
      disabled: false,
      render: (cons_am) => {},
      elementClass: "form-control",
      elements: [
        {
          input: {
            name: "peticion",
            label: "Petición",
            type: "text",
            cols: 12,
            disabled: true,
          },
        },
        {
          input: {
            name: "valor_anterior",
            label: "Valor anterior",
            type: "text",
            cols: 12,
            disabled: true,
          },
        },
        {
          input: {
            name: "valor_nuevo",
            label: "Valor nuevo",
            type: "text",
            cols: 12,
            disabled: true,
          },
        },
        {
          textarea: {
            name: "texto",
            label: "Ingresar texto anotación marginal en constancia",
            cols: 12,
            rows: 5,
          },
        },
      ],
    });

    this.validez = Api.form({
      target: "#f_validez",
      nombre: "validez",
      onchange: (me) => {
        this.setState({
          validez_id: me.value,
        });
      },
      render: (validez) => {
        Api.fetch("app/getValidez").then((data) => {
          if (data) {
            let options = `<option value="0">Seleccione</option>`;
            for (let e in data) {
              options += `<option value="${data[e].id}">
                ${data[e].descripcion}
                </option>`;
            }
            validez.querySelector("#validez_id").innerHTML = options;
          }
        });
      },
      elementClass: "form-control",
      elements: [
        {
          select: {
            name: "validez_id",
            label: "Seleccione",
            placeHolder: "Seleccione",
            cols: 12,
          },
        },
      ],
    });

    /**DEFINO MI FORMA Y TABLA PARA REFRENDA */
    this.refrenda_form = {
      target: "#f_refrenda",
      disabled: false,
      nombre: "refrenda",
      elementClass: "form-control",
      elements: [
        {
          input: {
            name: "titular",
            label: "Titular",
            type: "text",
            cols: 12,
            disabled: true,
          },
        },
        {
          input: {
            name: "fabricante",
            label: "Fabricante",
            type: "text",
            cols: 6,
            disabled: true,
          },
        },
        {
          input: {
            name: "pais",
            label: "País",
            type: "text",
            cols: 6,
            disabled: true,
          },
        },
      ],
    };

    this.tabla_refrenda_productos = {
      target: "#refrenda_productos",
      tableClass: "table table-striped m-b-0 table-hover ", //blockea las clases de estilo de la tabla
      rowsPerPage: [5, 10, 25, 50, 100],
      progressText: "Cargando productos", //El mensaje de carga
      hidePager: true, //Oculta el paginador
      rows: {
        nombre_comercial: {
          label: "Nombre Comercial",
        },
        no_registro: {
          label: "No. Registro",
        },
        no_refrenda: {
          label: "No. Refrenda",
        },
      },
    };

    /* DEFINO MI FORMA DE DETALLE DE CERTIFICADO */
    let detalle_certificado = {
      target: "#d_certificado",
      disabled: false,
      nombre: "producto",
      render: (producto) => {},
      elementClass: "form-control",
      elements: [
        {
          input: {
            cols: 6,
            name: "nombre_comercial",
            type: "text",
            label: "Nombre comercial",
            disabled: true,
          },
        },
        {
          input: {
            cols: 6,
            name: "tipo_producto",
            type: "text",
            label: "Tipo de producto",
            disabled: true,
          },
        },
        {
          input: {
            cols: 6,
            name: "fabricante",
            type: "text",
            label: "Fabricante",
            disabled: true,
          },
        },
        {
          input: {
            cols: 6,
            name: "direccion_establecimiento",
            type: "text",
            label: "Dirección fabricante",
            disabled: true,
          },
        },
        {
          input: {
            cols: 4,
            name: "pais",
            type: "text",
            label: "País destino",
            disabled: true,
          },
        },
        {
          input: {
            cols: 4,
            name: "fecha_registro",
            type: "text",
            label: "Fecha de registro",
            disabled: true,
          },
        },
        {
          input: {
            cols: 4,
            name: "vigencia_registro",
            type: "text",
            label: "Vencimiento del registro",
            disabled: true,
          },
        },
        {
          input: {
            cols: 12,
            name: "uso",
            type: "text",
            label: "Uso",
            disabled: true,
          },
        },
        {
          input: {
            cols: 12,
            name: "precauciones_uso",
            type: "textarea",
            label: "Precauciones de uso",
            disabled: true,
          },
        },
        {
          input: {
            cols: 8,
            name: "caducidad_producto",
            type: "text",
            label: "Caducidad del producto",
            disabled: true,
          },
        },
        {
          input: {
            cols: 4,
            name: "medida_tiempo",
            type: "text",
            label: "Tiempo",
            disabled: true,
          },
        },

        /*  {
          input: {
            cols: 6,
            name: "composicion",
            type: "text",
            label: "Composición",
            disabled: true,
          },
        }, */
      ],
    };
    this.detalleCertificado = Api.form(detalle_certificado);

    /**DEFINO MI FORMA para detalles de representante para producto TABLA*/
    this.representante_legal_cer = {
      //source: "app/getRepresentanteProducto?id=5&",
      target: "#representante_legal_cer",
      tableClass: "table table-striped m-b-0 table-hover blockea", //las clases de estilo de la tabla
      rowsPerPage: [5, 10, 25, 50, 100],
      progressText: "Cargando representantes legales", //El mensaje de carga
      hidePager: true, //Oculta el paginador
      rows: {
        nombres: {
          label: "Nombres",
        },
        apellido_paterno: {
          label: "Apellido paterno",
        },
        apellido_materno: {
          label: "Apellido materno",
        },
        correo_electronico: {
          label: "Correo electrónico",
        },
      },
    };

    /**DEFINO MI FORMA para detalles de regente para certificado TABLA*/
    this.regente_cer = {
      //source:'app/getRegenteProducto?id=1&',
      target: "#regente_cer",
      tableClass: "table table-striped m-b-0 table-hover blockea", //las clases de estilo de la tabla
      rowsPerPage: [5, 10, 25, 50, 100],
      progressText: "Cargando regentes", //El mensaje de carga
      hidePager: true, //Oculta el paginador
      rows: {
        nombres: {
          label: "Nombres",
        },
        apellido_paterno: {
          label: "Apellido paterno",
        },
        apellido_materno: {
          label: "Apellido materno",
        },
        guid: {
          label: "GUID",
        },
      },
    };
    //Termina componenDidMount
  }

  /* INICIA LOGICA  (grid y detalle) */

  search = [];

  handleSearch(obj) {
    this.search[obj.target.name] = obj.target.value;
    this.setState({ buscar: this.search });
    this.setRegentesPage(1);
  }

  //Funcion para cambiar de pagina en el grid de regente
  setRegentesPage(page) {
    this.setState({ workingGrid: true });
    let search = this.state.buscar;
    let src = "";
    for (let param in search) {
      if (search[param] !== "") {
        src += "&" + param + "=" + search[param];
      }
    }

    Api.fetch("app/getRegenteApplications?page=" + page + src).then((r) => {
      this.setState({
        regentes: r.data,
        paginas: r.last_page,
        registros: r.total,
        paginaActual: r.current_page,
        workingGrid: false,
      });
    });
  }

  handleImportacionAdicionalDataChange(e) {
    let targetName = e.target.name,
      targetValue = e.target.value,
      importacion = { ...this.state.importacion };

    this.cleanErrorsValidation(targetName);

    switch (targetName) {
      case "importacion_texto":
        importacion.importacion_texto = targetValue.toUpperCase();
        break;
      case "fines_texto":
        importacion.fines_texto = targetValue.toUpperCase();
        break;

      default:
        break;
    }

    this.setState({ importacion: importacion });
  }

  setEstablecimientosPage(page) {
    this.setState({ workingGrid: true });

    let search = this.state.buscarEstablecimientos;
    let src = "";
    for (let param in search) {
      if (search[param] !== "") {
        src += "&" + param + "=" + search[param];
      }
    }

    Api.fetch("app/getSolicitudesEstablecimiento?page=" + page + src).then(
      (e) => {
        this.setState({
          establecimientos: e.data,
          paginas_e: e.last_page,
          registros_e: e.total,
          paginaActual_e: e.current_page,
          workingGrid: false,
        });
      }
    );
  }

  setProductosPage(page) {
    this.setState({ workingGrid: true });
    let search = this.state.buscarProductos;
    let src = "";
    for (let param in search) {
      if (search[param] !== "") {
        src += "&" + param + "=" + search[param];
      }
    }
    //caso en que llegue object en el argumento de page
    if (typeof page === "object") {
      page = page.target.value;
    }

    Api.fetch("app/getSolicitudesProductos?page=" + page + src).then((p) => {
      this.setState({
        productos: p.data,
        paginas_p: p.last_page,
        registros_p: p.total,
        paginaActual_p: p.current_page,
        workingGrid: false,
      });
    });
  }

  closeModalMovimientos() {
    this.setState({
      openModalMovimiento: false,
      importacion: {
        importacion_texto: "",
        fines_texto: "",
      },
    });
  }

  setMovimientoProductosPage(page) {
    this.setState({ workingGridMP: true });
    let search = this.state.buscarMovimientos;
    let src = "";
    for (let param in search) {
      if (search[param] !== "") {
        src += "&" + param + "=" + search[param];
      }
    }
    //caso en que llegue object en el argumento de page
    if (typeof page === "object") {
      page = page.target.value;
    }

    Api.fetch("app/getSolicitudesMovimientoProductos?page=" + page + src).then(
      (m) => {
        this.setState({
          movimientos: m.data,
          paginas_m: m.last_page,
          registros_m: m.total,
          paginaActual_m: m.current_page,
          workingGridMP: false,
        });
      }
    );
  }

  setCasosEspecialesPage(page) {
    this.setState({ workingGridCE: true });
    let search = this.state.buscarCasosEspeciales;
    let src = "";
    for (let param in search) {
      if (search[param] !== "") {
        src += "&" + param + "=" + search[param];
      }
    }
    //caso en que llegue object en el argumento de page
    if (typeof page === "object") {
      page = page.target.value;
    }

    Api.fetch("app/getSolicitudesCasosEspeciales?page=" + page + src).then(
      (ce) => {
        this.setState({
          casos_especiales: ce.data,
          paginas_ce: ce.last_page,
          registros_ce: ce.total,
          paginaActual_ce: ce.current_page,
          workingGridCE: false,
        });
      }
    );
  }

  setConstanciasPage(page) {
    this.setState({ workingGrid: true });

    let search = this.state.buscaConstancias;

    if (typeof page === "object") {
      page = page.target.value;
    }

    let src = "";
    for (let param in search) {
      if (search[param] !== "") {
        src += "&" + param + "=" + search[param];
      }
    }

    Api.fetch("app/getSolicitudesConstancias?page=" + page + src).then((m) => {
      this.setState({
        constancias: m.data,
        paginas_c: m.last_page,
        registros_c: m.total,
        paginaActual_c: m.current_page,
        workingGrid: false,
      });
    });
  }

  setMedicoVeterinarioPage(page) {
    this.setState({ workingGrid: true });

    let search = this.state.buscaMedicoV;
    let src = "";
    for (let param in search) {
      if (search[param] !== "") {
        src += "&" + param + "=" + search[param];
      }
    }

    Api.fetch("app/getSolicitudesMedicoVeterinario?page=" + page + src).then(
      (mv) => {
        this.setState({
          medicos_veterinarios: mv.data,
          paginas_mv: mv.last_page,
          registros_mv: mv.total,
          paginaActual_mv: mv.current_page,
          workingGrid: false,
        });
      }
    );
  }

  setCertificadoPage(page) {
    this.setState({ workingGrid: true });

    let search = this.state.buscaCertificados;
    let src = "";
    for (let param in search) {
      if (search[param] !== "") {
        src += "&" + param + "=" + search[param];
      }
    }

    Api.fetch("app/getSolicitudesCertificados?page=" + page + src).then(
      (cer) => {
        this.setState({
          certificados: cer.data,
          paginas_cer: cer.last_page,
          registros_cer: cer.total,
          paginaActual_cer: cer.current_page,
          workingGrid: false,
        });
      }
    );
  }

  setPrecertificadosPage(page) {
    this.setState({ workingGrid: true });

    let search = this.state.buscarPrecertificado;
    let src = "";
    for (let param in search) {
      if (search[param] !== "") {
        src += "&" + param + "=" + search[param];
      }
    }

    Api.fetch("app/getSolicitudesPrecertificados?page=" + page + src).then(
      (m) => {
        this.setState({
          precertificados: m.data,
          paginas_pre: m.last_page,
          registros_pre: m.total,
          paginaActual_pre: m.current_page,
          workingGrid: false,
        });
      }
    );
  }

  setAutorizacionPage(page) {
    this.setState({ workingGrid: true });

    let search = this.state.buscarAutorizacionDA;
    let src = "";
    for (let param in search) {
      if (search[param] !== "") {
        src += "&" + param + "=" + search[param];
      }
    }

    Api.fetch("app/getSolicitudesAutorizacionDA?page=" + page + src).then(
      (m) => {
        this.setState({
          autorizacion: m.data,
          paginas_ada: m.last_page,
          registros_ada: m.total,
          paginaActual_ada: m.current_page,
          workingGrid: false,
        });
      }
    );
  }

  //Funcion auxiliar para cambiar de pagina en el grid de regente
  handleRegentePage(e) {
    this.setRegentesPage(e.target.value);
  }

  //Funcion auxiliar para cambiar de pagina en el grid de establecimientos
  handleEstablecimientoPage(e) {
    this.setEstablecimientosPage(e.target.value);
  }

  //Funcion auxiliar para cambiar de pagina en el grid de productos
  handleProductoPage(e) {
    this.setProductosPage(e.target.value);
  }

  //Funcion auxiliar para cambiar de pagina en el grid de movimientos
  handleMovimientoProductosPage(e) {
    this.setMovimientoProductosPage(e.target.value);
  }

  //Funcion auxiliar para cambiar de pagina en el grid de constancias
  handleConstanciasPage(e) {
    this.setConstanciasPage(e.target.value);
  }
  //Funcion auxiliar para cambiar de pagina en el grid de medico_veterinario
  handleMedicoVeterinarioPage(e) {
    this.setMedicoVeterinarioPage(e.target.value);
  }

  //Funcion auxiliar para cambiar de pagina en el grid de certificado
  handleCertificadoPage(e) {
    this.setCertificadoPage(e.target.value);
  }

  //Funcion auxiliar para cambiar de pagina en el grid de precertifiado
  handlePreCertificadosPage(e) {
    this.setPreCertificadosPage(e.target.value);
  }

  //Funcion auxiliar para cambiar de pagina en el grid de Autorizacion
  handleAutorizacionPage(e) {
    this.setAutorizacionPage(e.target.value);
  }

  //Funcion auxiliar para cambiar de pagina en el grid de casos especiales
  handleCasosEspecialesPage(e) {
    this.setCasosEspecialesPage(e.target.value);
  }

  //Funcion para abrir el detalle del regente
  handleOpenRegent(e) {
    e.stopPropagation();
    let regente_id = e.target.getAttribute("data-regente-id");
    this.setState({ modalRegente: true, working: true });

    Api.fetch(
      "app/getRegenteApplication",
      {
        id: regente_id,
      },
      "POST"
    ).then((r) => {
      this.setState({
        regente: r,
        solicitud_reg: regente_id,
        reg_estatus_tramite_id: r.estatus_tramite_id,
        tramite_id: r.tramite_id,
        working: false,
      });
      let regenteDocsCheck = []; //[...this.state.regenteDocsCheck];
      for (let file in r.documentos) {
        // this.state.regenteDocsCheck[r.documentos[file].id] = false;
        regenteDocsCheck[r.documentos[file].id] = false;
        this.setState({ regenteDocsCheck: regenteDocsCheck });
      }

      this.handleRegBtn();

      if (r.estatus_tramite_id !== "1" && r.estatus_tramite_id !== "9") {
        let s = document.querySelectorAll(".btn-success");
        s.forEach((e) => {
          e.classList = "btn btn-success blockea ";
        });
        s = document.querySelectorAll(".btn-danger");
        s.forEach((e) => {
          e.classList = "btn btn-danger blockea ";
        });
      }else{
        this.handleUpdateRevisa(regente_id);
      }

      if (this.state.regente.tipo_regente_id === "1") {
        r.sgi_info && r.sgi_info.nombre_validado
          ? document.getElementById("nombreSGI").classList.add("is-valid")
          : document.getElementById("nombreSGI").classList.add("is-invalid");

        r.sgi_info && !r.sgi_info.fecha_caducada
          ? document.getElementById("caducaSGI").classList.add("is-valid")
          : document.getElementById("caducaSGI").classList.add("is-invalid");
      }
    });
  }

  modalEst = {};
  handleOpenEstablecimiento(e) {
    let tituloModal = e.target.dataset.folio;
    Api.loading(true);

    let detalle = document.querySelector("#detalleEstablecimiento");
    let solicitud_id = e.target.getAttribute("data-solicitud-id");

    Api.fetch(
      "app/getSolicitudEstablecimiento",
      { solicitud_id: solicitud_id },
      "POST"
    ).then((e) => {
      this.setState({
        establecimiento: e,
        solicitud_est: e.solicitud,
        working: false,
      });

      document.getElementById("anotacion_marginal").classList = "col-12 hide";
      if (e.nota_marginal) {
        this.setState({
          am: "NM",
          nota_marginal: e.nota_marginal,
          solicitud_est: e.nota_marginal.solicitud,
        });

        document.getElementById("anotacion_marginal").classList = "col-12";
        document.getElementById("nota_marginal").innerText =
          e.nota_marginal.descripcion;
        document.querySelector(".estTipo").innerText =
          e.nota_marginal.descripcion;

        import(`../components/notas-marginales/NMGeneral.jsx`).then((m) => {
          m.detail(e.nota_marginal, (r) => {
            let notaForm = Api.form(r);
            notaForm.querySelector("#peticion").innerText =
              e.nota_marginal.peticion;
          });
        });
      }
      this.representante_legal.source =
        "app/getRepresentanteEstablecimiento?id=" + e.establecimiento.id + "&";
      this.detalleRepresentante = Api.grid(this.representante_legal);

      this.regente.source =
        "app/getRegenteEstablecimiento?id=" + e.establecimiento.id + "&";
      this.detalleRegente = Api.grid(this.regente);

      this.condiciones.source =
        "app/getCondicionesEstablecimiento?id=" + e.establecimiento.id + "&";

      this.detalleCondiciones = Api.grid(this.condiciones);

      let edc = [];
      for (let file in e.documentos) {
        edc[e.documentos[file].id] = false;
      }

      this.setState({
        allEst: false,
        establecimientoDocsCheck: edc,
      });

      this.detalleEstablecimiento.merge(e.establecimiento);
      if (e.establecimiento.nacional === "1") {
        if (this.detalleEstablecimiento.querySelector(".pais_texto") !== null) {
          this.detalleEstablecimiento.querySelector(".pais_texto").remove();
        }
      } else {
        if (this.detalleEstablecimiento.querySelector(".municipio") !== null) {
          this.detalleEstablecimiento.querySelector(".municipio").remove();
          this.detalleEstablecimiento.querySelector(".departamento").remove();
        }
      }
      this.detalleCaracteristicas.merge(e.establecimiento);

      /*Abrimos el modal */

      let docAcepta = detalle.querySelectorAll(".documento-aceptar");

      docAcepta.forEach((doc) => {
        doc.addEventListener(
          "click",
          this.handleEstablecimientoDocumentoStatus
        );
      });
      let docRechaza = detalle.querySelectorAll(".documento-rechazar");

      docRechaza.forEach((doc) => {
        doc.addEventListener(
          "click",
          this.handleEstablecimientoDocumentoStatus
        );
      });

      let docVistaPrevia = detalle.querySelectorAll(".vista-previa");
      docVistaPrevia.forEach((doc) => {
        doc.addEventListener("click", this.handlePrevia);
      });

      let checkboxs = detalle.querySelectorAll(".checkbox_est");
      checkboxs.forEach((doc) => {
        doc.addEventListener("change", this.handleEstChecks);
      });

      detalle.querySelector("#regresar_est").addEventListener("click", (e) => {
        this.setEstablecimientosPage(this.state.paginaActual);
        this.modalEst.close();
      });
      //if(this.state.solicitud_est.estatus_tramite_id !== "9"){
      if (
        this.state.solicitud_est.estatus_tramite_id === "4" ||
        this.state.solicitud_est.estatus_tramite_id === "5" ||
        this.state.solicitud_est.estatus_tramite_id === "10"
      ) {
        detalle.querySelector("#rechazar_est").classList =
          "btn btn-danger blockea";
        detalle.querySelector("#aprobar_est").classList =
          "btn btn-success blockea";
      } else {
        this.handleUpdateRevisa(solicitud_id);
        document
          .getElementById("rechazar_est")
          .addEventListener("click", this.handleEstablecimientoStatus);
        document
          .getElementById("aprobar_est")
          .addEventListener("click", this.handleEstablecimientoStatus);
      }

      document
        .getElementById("allc_e")
        .addEventListener("change", this.allDocsEst);
      document
        .getElementById("descarga_docs_est")
        .addEventListener("click", this.handleDownloadZipEstablecimientos);

      this.modalEst = Api.modal({
        title: "Folio solicitud: " + tituloModal,
        html: detalle,
      });

      this.handleEstBtn();

      Api.loading(false);
    });
  }

  modalPro = {};

  /// DOCUMENTOS DE PRODUCTOS
  modal_clasificacion = {};
  handleClasificacionProd(e) {
    let rset = JSON.parse(e.target.dataset.rset);

    //### Si tipo producto veterinario <= 3 entonces mostramos el combo de clasificar si no lo ocultamos
    if (parseInt(rset.tipo_producto_veterinario_id) <= 3) {
      Api.fetch(
        "app/getCatClasificacionProVet?id=" + rset.tipo_producto_veterinario_id
      ).then((r) => {
        this.setState({ option_clase_producto: r });
      });
    } else {
      this.setState({ tipo_producto_veterinario: false });
    }

    let solid = rset.solicitud_id;
    let obj_clas = { ...this.state.clasificacion };

    obj_clas["solid"] = solid;

    this.setState({ openModalClasificacion: true, clasificacion: obj_clas });

    /* 
    this.modal_clasificacion = Api.modal({
      title: "Folio solicitud: ",
      html: clasificacion,
    }); */

    /* Swal.fire({
      title: "Clasifique este producto",
      html: clasificacion,//this.clasificacion,
      showCancelButton: true,
      confirmButtonText: "Clasificar",
      showLoaderOnConfirm: true,
      reverseButtons: true,
      cancelButtonText: "Regresar",
      preConfirm: () => {
        let dataForm = this.state.clasificacion;//this.clasificacion.data();

        let solid = rset.solicitud_id;
        let pass = 1;

        if (dataForm.grupo_ingrediente_id === "0") {
          Swal.showValidationMessage("Seleccione");
          pass = 0;
        }

        if (parseInt(rset.tipo_producto_veterinario_id) <= 3) {
          if (dataForm.clase_producto_id === "0") {
            //resolve("Seleccione la clase del producto");
            Swal.showValidationMessage("Seleccione");
            pass = 0;
          }
        }

        if (dataForm.dossier === "" || !dataForm.dossier) {
          Swal.showValidationMessage("Ingrese dossier");
          pass = 0;
        }

        if (
          dataForm.no_registro_drycip === "" ||
          !dataForm.no_registro_drycip
        ) {
          Swal.showValidationMessage("Ingrese el número de registro");
          pass = 0;
        }

        if (dataForm.folio === "" || !dataForm.folio) {
          Swal.showValidationMessage("Ingrese el folio");
          pass = 0;
        }

        if (dataForm.tomo === "" || !dataForm.tomo) {
          Swal.showValidationMessage("Ingrese el tomo");
          pass = 0;
        }

        if (dataForm.categorizacion_oficial_id === "0") {
          Swal.showValidationMessage("Seleccione");
          pass = 0;
        }

        if (dataForm.grupo_ingrediente_id === "0") {
          Swal.showValidationMessage("Seleccione");
          pass = 0;
        }

    /*  if (pass) {
          return Api.fetch(
            "app/setClasification",
            {
              clasificacion: dataForm,
              solicitud_id: solid,
            },
            "POST"
          ).then((r) => {
            Swal.fire({
              icon: "success",
              title: "Clasificación exitosa.",
              text: "El producto se ha clasificado",
            });
            this.setProductosPage(this.state.paginaActual_p);
          });
        } /*/
    /* },
      allowOutsideClick: () => !Swal.isLoading(),
    });  */
  }

  setClasificacion(e) {
    Swal.fire({
      title: "¿Está seguro que quiere guardar la clasificación del producto?",
      showCancelButton: true,
      confirmButtonColor: "#4CD964",
      confirmButtonText: "Continuar",
      showLoaderOnConfirm: true,
      reverseButtons: true,
      cancelButtonColor: "red",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        if (this.validarClasificacion(this.state.clasificacion)) {
          Api.loading(true);
          return Api.fetch(
            "app/setClasification",
            {
              clasificacion: this.state.clasificacion,
              solicitud_id: this.state.clasificacion.solid,
            },
            "POST"
          ).then((r) => {
            Api.loading(false);
            Swal.fire({
              icon: "success",
              title: "Clasificación exitosa.",
              text: "El producto se ha clasificado",
            });

            let obj_clas = { ...this.state.clasificacion };
            for (let d in obj_clas) {
              obj_clas[d] = d === "asesoria" ? false : "";
            }
            this.setProductosPage(this.state.paginaActual_p);
            this.setState({
              clasificacion: obj_clas,
              openModalClasificacion: false,
              tipo_producto_veterinario: true,
            });
          });
        }
      }
    });
  }

  handleChangeClasificacion(e) {
    let clasificacion = { ...this.state.clasificacion };

    if (e.target.name === "asesoria") {
      clasificacion[e.target.name] = e.target.checked;
    } else {
      clasificacion[e.target.name] = e.target.value.toUpperCase();
    }

    this.setState({ clasificacion: clasificacion });
  }

  validarClasificacion(data) {
    for (let d in data) {
      if (
        data[d] === "" &&
        d !== "asesoria" &&
        this.state.tipo_producto_veterinario === true
      ) {
        Swal.fire({
          title: "Atención",
          icon: "warning",
          text: "Favor de revisar el formulario.",
        });
        return 0;
      }
    }

    return 1;
  }

  closeClasificacion(e) {
    let obj_clas = { ...this.state.clasificacion };
    for (let d in obj_clas) {
      obj_clas[d] = d === "asesoria" ? false : "";
    }

    this.setState({
      openModalClasificacion: false,
      clasificacion: obj_clas,
      tipo_producto_veterinario: true,
    });
  }

  handleEditarProducto(e) {
    let solicitud_id = e.target.getAttribute("data-solicitud-id");
    Api.loading(true);
    //A partir de la solicitud obetenemos el tipo de producto y el producto id
    //Buscar producto en nota marginal producto
    Api.fetch(
      "app/getProductoInfoBySolicitudAM?solicitud_id=" + solicitud_id
    ).then((e) => {
      let tipo_producto_id;
      if (e[0].tipo_producto_veterinario_id === "5") {
        tipo_producto_id = 3; //alimento
      } else {
        tipo_producto_id = 1;
      }
      window.location.href =
        "/solicitud/editar-producto/" +
        tipo_producto_id +
        "/" +
        e[0].id +
        "/" +
        solicitud_id;
      Api.loading(false);
    });

    //window.location.href = '/solicitud/editar-producto/'+solicitud_id;
  }

  handleOpenProductos(e) {
    let tituloModal = e.target.dataset.folio;
    // Reseteamos los valores de producto y solicitud_prod para que no haya anomalías si ya se abrieron otros modales
    this.setState({
      producto: {
        id: "",
        forma_farmaceutica: "",
        forma_farmaceutica_id: "",
        folio: "",
        medida_tiempo: "",
        medida_tiepo_id: "",
        nombre_comercial: "",
        pais: "",
        pais_id: "",
        precauciones_generales: "",
        uso: "",
      },
      solicitud_prod: {
        id: "",
        folio_solicitud: "",
        accion: "",
        actividad: "",
        tipo: "",
        fecha_solicitud: "",
        estatus: "",
        fecha_solicitud:"",
        anotacion_marginal: false,
      },
    });

    let solid = e.target.getAttribute("data-solicitud-id");
    let detalle = document.querySelector("#detalleProducto");

    Api.loading(true);

    Api.fetch("app/getSolicitudProducto?id=" + solid).then((e) => {
      this.setState({
        producto: e.producto,
        solicitud_prod: e.solicitud,
        allPro: false,
        working: false,
      });

      if (e.producto.tipo_producto_veterinario_id) {
        this.detalleProducto.querySelector(
          ".forma_farmaceutica label"
        ).innerText = "Forma de comercialización";
      } else {
        this.detalleProducto.querySelector(
          ".forma_farmaceutica label"
        ).innerText = "Forma farmacéutica";
      }

      this.detalleProducto.merge(e.producto);

      if (e.producto.tipo_producto_veterinario_id === "1") {
        // MEDICAMENTO VETERINARIO
        this.detalleProducto.querySelector(".precauciones_uso").style.display =
          "none";
        this.detalleProducto.querySelector(
          ".precauciones_almacenamiento"
        ).style.display = "none";
        this.detalleProducto.querySelector(
          ".propiedades_inmunologicas"
        ).style.display = "none";
        this.detalleProducto.querySelector(".instrucciones_uso").style.display =
          "none";
        this.detalleProducto.querySelector(".clasificacion").style.display =
          "none";

        this.detalleProducto.querySelector(
          ".precauciones_generales"
        ).style.display = "";
        this.detalleProducto.querySelector(
          ".validez_preparacion"
        ).style.display = "";
        this.detalleProducto.querySelector(".uso").style.display = "";
        this.detalleProducto.querySelector(
          ".forma_farmaceutica"
        ).style.display = "";
      } else if (e.producto.tipo_producto_veterinario_id === "2") {
        // BIOLOGICO
        this.detalleProducto.querySelector(
          ".precauciones_generales"
        ).style.display = "none";
        this.detalleProducto.querySelector(
          ".validez_preparacion"
        ).style.display = "none";
        this.detalleProducto.querySelector(".uso").style.display = "none";
        this.detalleProducto.querySelector(".instrucciones_uso").style.display =
          "none";
        this.detalleProducto.querySelector(".clasificacion").style.display =
          "none";

        this.detalleProducto.querySelector(".precauciones_uso").style.display =
          "";
        this.detalleProducto.querySelector(
          ".precauciones_almacenamiento"
        ).style.display = "";
        this.detalleProducto.querySelector(
          ".propiedades_inmunologicas"
        ).style.display = "";
        this.detalleProducto.querySelector(
          ".forma_farmaceutica"
        ).style.display = "";
      } else if (e.producto.tipo_producto_veterinario_id === "3") {
        // PRODUCTO AFIN
        this.detalleProducto.querySelector(".precauciones_uso").style.display =
          "none";
        this.detalleProducto.querySelector(
          ".precauciones_almacenamiento"
        ).style.display = "none";
        this.detalleProducto.querySelector(
          ".propiedades_inmunologicas"
        ).style.display = "none";
        this.detalleProducto.querySelector(
          ".validez_preparacion"
        ).style.display = "none";
        this.detalleProducto.querySelector(".instrucciones_uso").style.display =
          "none";
        this.detalleProducto.querySelector(".clasificacion").style.display =
          "none";

        this.detalleProducto.querySelector(
          ".forma_farmaceutica"
        ).style.display = "";
        this.detalleProducto.querySelector(
          ".precauciones_generales"
        ).style.display = "";
        this.detalleProducto.querySelector(".uso").style.display = "";
      } else if (e.producto.tipo_producto_veterinario_id === "4") {
        // REACTIVO DIAGNOSTICO
        this.detalleProducto.querySelector(".precauciones_uso").style.display =
          "none";
        this.detalleProducto.querySelector(
          ".precauciones_almacenamiento"
        ).style.display = "none";
        this.detalleProducto.querySelector(
          ".propiedades_inmunologicas"
        ).style.display = "none";
        this.detalleProducto.querySelector(
          ".validez_preparacion"
        ).style.display = "none";
        this.detalleProducto.querySelector(
          ".forma_farmaceutica"
        ).style.display = "none";
        this.detalleProducto.querySelector(".clasificacion").style.display =
          "none";

        this.detalleProducto.querySelector(
          ".precauciones_generales"
        ).style.display = "";
        this.detalleProducto.querySelector(".uso").style.display = "";
        this.detalleProducto.querySelector(".instrucciones_uso").style.display =
          "";
      } else if (e.producto.tipo_producto_veterinario_id === "5") {
        // ALIMENTACION
        this.detalleProducto.querySelector(
          ".precauciones_generales"
        ).style.display = "none";
        this.detalleProducto.querySelector(
          ".validez_preparacion"
        ).style.display = "none";
        this.detalleProducto.querySelector(".instrucciones_uso").style.display =
          "none";
        this.detalleProducto.querySelector(
          ".propiedades_inmunologicas"
        ).style.display = "none";

        this.detalleProducto.querySelector(".clasificacion").style.display = "";
        this.detalleProducto.querySelector(".precauciones_uso").style.display =
          "";
        this.detalleProducto.querySelector(
          ".precauciones_almacenamiento"
        ).style.display = "";
        this.detalleProducto.querySelector(
          ".forma_farmaceutica"
        ).style.display = "";
      }

      if (
        e.solicitud.tipo_producto_veterinario_id === "1" ||
        e.solicitud.tipo_producto_veterinario_id === "3"
      ) {
        //PRINCIPIO ACTIVO
        this.principioActivo.source =
          "app/getActivoProducto?id=" + e.producto.id + "&";
        Api.grid(this.principioActivo);
        //EXCIPIENTE
        this.excipiente.source =
          "app/getExcipienteProducto?id=" + e.producto.id + "&";
        Api.grid(this.excipiente);
      }

      if (e.solicitud.tipo_producto_veterinario_id === "2") {
        //PRINCIPIO ACTIVO
        this.tabla_biologica.source =
          "app/getComposicionBiologica?id=" + e.producto.id + "&";
        Api.grid(this.tabla_biologica);
        //EXCIPIENTE
        this.tabla_quimica.source =
          "app/getComposicionQuimica?id=" + e.producto.id + "&";
        Api.grid(this.tabla_quimica);
      }

      if (
        e.solicitud.tipo_producto_veterinario_id === "1" ||
        e.solicitud.tipo_producto_veterinario_id === "2" ||
        e.solicitud.tipo_producto_veterinario_id === "5"
      ) {
        //DOSIS
        this.tabla_dosis.source =
          "app/getDosisProducto?id=" + e.producto.id + "&";
        Api.grid(this.tabla_dosis);
        //ENVASE
        this.tabla_envase.source =
          "app/getEnvaseProducto?id=" + e.producto.id + "&";
        Api.grid(this.tabla_envase);
        //PERIODO DESCARTE
        this.tabla_periodo.source =
          "app/getDescarteProducto?id=" + e.producto.id + "&";
        Api.grid(this.tabla_periodo);
      }

      if (e.solicitud.tipo_producto_veterinario_id === "3") {
        //MODO EMPLEO
        this.tabla_modo_empleo.source =
          "app/getDosisProducto?id=" + e.producto.id + "&";
        Api.grid(this.tabla_modo_empleo);
        //ENVASE
        this.tabla_envase.source =
          "app/getEnvaseProducto?id=" + e.producto.id + "&";
        Api.grid(this.tabla_envase);
      }

      if (e.solicitud.tipo_producto_veterinario_id === "4") {
        //COMPONENTES
        this.tabla_componentes.source =
          "app/getComponente?id=" + e.producto.id + "&";
        Api.grid(this.tabla_componentes);
        //ESPECIE INTERES
        this.tabla_especies.source =
          "app/getEspecieInteres?id=" + e.producto.id + "&";
        Api.grid(this.tabla_especies);
        //PRESENTACIONES
        this.tabla_presentacion.source =
          "app/getPresentacion?id=" + e.producto.id + "&";
        Api.grid(this.tabla_presentacion);
      }

      if (e.solicitud.tipo_producto_veterinario_id === "5") {
        //ANALISIS GARANTIZADO
        this.tabla_analisis.source =
          "app/getAnalisisAlimento?id=" + e.producto.id + "&";
        Api.grid(this.tabla_analisis);
        //INGREDIENTE
        this.tabla_ingredientes.source =
          "app/getIngredienteAnimal?id=" + e.producto.id + "&";
        Api.grid(this.tabla_ingredientes);
      }
      /*     //REPRESENTANTES
      this.representante_legal_pro.source = "app/getRepresentanteProducto?id=" + e.producto.id + "&";
      Api.grid(this.representante_legal_pro); */
      //REGENTES
      this.regente_pro.source =
        "app/getRegenteProducto?id=" + e.producto.id + "&";
      Api.grid(this.regente_pro);

      if (e.solicitud.anotacion_marginal) {
        //this.AnotacionProducto.querySelector(".precauciones_generales").style.display = "none";

        this.AnotacionProducto.querySelector(
          ".anotacion_marginal_peticion label"
        ).innerHTML = e.solicitud.anotacion_marginal_name;
        this.AnotacionProducto.merge(e.solicitud);
      }

      /*Abrimos el modal */
      this.modalPro = Api.modal({
        title: "Folio solicitud: " + tituloModal,
        html: detalle,
      });

      Api.fetch("app/getProductDocsDetails?solicitud_id=" + solid).then(
        (files) => {
          this.setState({
            docProductos: files,
            working: false,
            solicitud_pro: {
              id: solid,
            },
          });

          this.handleProBtn();

          //
          /*  if(!e.solicitud.anotacion_marginal){

          } */

          let docAcepta = detalle.querySelectorAll(".documento-pro-rechazar");

          docAcepta.forEach((doc) => {
            doc.addEventListener("click", this.handleProductosDocumentoStatus);
          });

          let docRechaza = detalle.querySelectorAll(".documento-pro-aceptar");

          docRechaza.forEach((doc) => {
            doc.addEventListener("click", this.handleProductosDocumentoStatus);
          });

          let docVistaPrevia = detalle.querySelectorAll(".vista-previa");
          docVistaPrevia.forEach((doc) => {
            doc.addEventListener("click", this.handlePrevia);
          });

          let checkboxs = detalle.querySelectorAll(".checkbox_pro");
          checkboxs.forEach((doc) => {
            doc.addEventListener("change", this.handleProChecks);
          });

          detalle
            .querySelector("#regresar_pro")
            .addEventListener("click", (e) => {
              this.modalPro.close();
            });

          document
            .getElementById("rechazar_pro")
            .addEventListener("click", this.handleProductoStatus);
          document
            .getElementById("aprobar_pro")
            .addEventListener("click", this.handleProductoStatus);
          document
            .getElementById("allc_p")
            .addEventListener("change", this.allDocsPro);
          document
            .getElementById("descarga_docs_pro")
            .addEventListener("click", this.handleDownloadZipProductos);

          if (
            e.solicitud.estatus_tramite_id !== "1" &&
            e.solicitud.estatus_tramite_id !== "9"
          ) {
            let s = detalle.querySelectorAll(".btn-success");
            s.forEach((e) => {
              e.classList = "btn btn-success blockea ";
            });
            s = detalle.querySelectorAll(".btn-danger");
            s.forEach((e) => {
              e.classList = "btn btn-danger blockea ";
            });
          }else{
            this.handleUpdateRevisa(solid);
          }
          Api.loading(false);
        }
      );
    });
  }

  handleOpenProductosRefrenda(e) {
    let tituloModal = e.target.dataset.folio;

    let solid = e.target.getAttribute("data-solicitud-id");
    let detalle = document.querySelector("#detalleProducto");
    let tramite = e.target.getAttribute("data-solicitud-tramite");

    Api.loading(true);
    Api.fetch("app/getSolicitudRefenda?id=" + solid).then((e) => {
      this.setState({
        solicitud_prod: e.solicitud,
        working: false,
      });
      /*Abrimos el modal*/
      this.modalPro = Api.modal({
        title: "Folio solicitud: " + tituloModal,
        html: detalle,
      });

      //.detalleProducto.merge(e.solicitud);
      let refrenda = Api.form(this.refrenda_form);
      refrenda.merge(e.solicitud);

      this.tabla_refrenda_productos.source =
        "app/getProductoSolicitudRefrenda?id=" + solid + "&";
      Api.grid(this.tabla_refrenda_productos);

      Api.fetch(
        "app/getProductDocsDetails?solicitud_id=" +
          solid +
          "&tramite_id=" +
          tramite
      ).then((files) => {
        Api.loading(0);
        this.setState({
          docProductos: files,
          working: false,
          solicitud_pro: {
            id: solid,
          },
        });

        this.handleProBtn();

        let docAcepta = detalle.querySelectorAll(".documento-pro-rechazar");

        docAcepta.forEach((doc) => {
          doc.addEventListener("click", this.handleProductosDocumentoStatus);
        });

        let docRechaza = detalle.querySelectorAll(".documento-pro-aceptar");

        docRechaza.forEach((doc) => {
          doc.addEventListener("click", this.handleProductosDocumentoStatus);
        });

        let docVistaPrevia = detalle.querySelectorAll(".vista-previa");
        docVistaPrevia.forEach((doc) => {
          doc.addEventListener("click", this.handlePrevia);
        });

        let checkboxs = detalle.querySelectorAll(".checkbox_pro");
        checkboxs.forEach((doc) => {
          doc.addEventListener("change", this.handleProChecks);
        });

        detalle
          .querySelector("#regresar_pro")
          .addEventListener("click", (e) => {
            this.modalPro.close();
          });

        document
          .getElementById("rechazar_pro")
          .addEventListener("click", this.handleProductoStatus);
        document
          .getElementById("aprobar_pro")
          .addEventListener("click", this.handleProductoStatus);
        document
          .getElementById("allc_p")
          .addEventListener("change", this.allDocsPro);
        document
          .getElementById("descarga_docs_pro")
          .addEventListener("click", this.handleDownloadZipProductos);

        if (
          e.solicitud.estatus_tramite_id !== "1" &&
          e.solicitud.estatus_tramite_id !== "9"
        ) {
          let s = detalle.querySelectorAll(".btn-success");
          s.forEach((e) => {
            e.classList = "btn btn-success blockea ";
          });
          s = detalle.querySelectorAll(".btn-danger");
          s.forEach((e) => {
            e.classList = "btn btn-danger blockea ";
          });
        }

        Api.loading(false);
      });
    });
  }

  modalMV = {};

  handleOpenMedicoVeterinario(e) {
    let tituloModal = e.target.dataset.folio;
    let solicitud_id = e.target.getAttribute("data-solicitud-id");
    Api.loading(true);

    let detalle = document.querySelector("#detalleMedicoVeterinario");

    //establecimientos
    this.establecimientos_medico_veterinario.source =
      "app/getEstablecimientosMedicoVet?id=" +
      e.target.dataset.medico_veterinario_id +
      "&";
    Api.grid(this.establecimientos_medico_veterinario);

    Api.fetch(
      "app/getSolicitudMedicoVeterinario",
      {
        solicitud_id: solicitud_id,
      },
      "POST"
    ).then((e) => {
      this.setState({
        medico_veterinario: e,
        solicitud_mv: e.solicitud,
        working: false,
      });

      this.detalleMedicoVeterinario.merge(e.solicitud);

      for (let file in e.documentos) {
        let medicoVetDocsCheck = [...this.state.medicoVetDocsCheck];
        medicoVetDocsCheck[e.documentos[file].id] = false;
        this.setState({ medicoVetDocsCheck: medicoVetDocsCheck });
      }

      //Abrimos el modal

      let docAcepta = detalle.querySelectorAll(".documento-aceptar");

      docAcepta.forEach((doc) => {
        doc.addEventListener("click", this.handleMedicoVetDocumentoStatus);
      });

      let docRechazar = detalle.querySelectorAll(".documento-rechazar");

      docRechazar.forEach((doc) => {
        doc.addEventListener("click", this.handleMedicoVetDocumentoStatus);
      });

      let docVistaPrevia = detalle.querySelectorAll(".vista-previa");
      docVistaPrevia.forEach((doc) => {
        doc.addEventListener("click", this.handlePrevia);
      });

      let checkboxs = detalle.querySelectorAll(".checkbox_mv");
      checkboxs.forEach((doc) => {
        doc.addEventListener("change", this.handleMedicoVetChecks);
      });

      document.getElementById("regresar_mv").addEventListener("click", (e) => {
        this.modalMV.close();
      });

      document
        .getElementById("rechazar_mv")
        .addEventListener("click", this.handleMedicoVetStatus);
      document
        .getElementById("aprobar_mv")
        .addEventListener("click", this.handleMedicoVetStatus);
      document
        .getElementById("allc_mv")
        .addEventListener("change", this.allDocsMV);
      document
        .getElementById("descarga_docs_mv")
        .addEventListener("click", this.handleDownloadZipMedicoVet);

      this.modalMV = Api.modal({
        title: "Folio solicitud: " + tituloModal,
        html: detalle,
      });

      this.handleMVBtn();

      if (
        e.solicitud.estatus_tramite_id !== "1" &&
        e.solicitud.estatus_tramite_id !== "9"
      ) {
        let s = detalle.querySelectorAll(".btn-success");
        s.forEach((el) => {
          el.classList = "btn btn-success blockea ";
        });

        s = detalle.querySelectorAll(".btn-danger");
        s.forEach((el) => {
          el.classList = "btn btn-danger blockea ";
        });
      }

      Api.loading(false);
    });
  }

  // Funcion para cambiar el estatus de los documentos
  // handleRegentDocumentStatus(id, solicitud_id,nom_boton, solicitud_estatus) {
  handleRegentDocumentStatus(e) {
    e.stopPropagation();
    e.preventDefault();

    let id = e.target.getAttribute("data-rrd-id"); //e.target.id; //parseInt(id);
    let estatus = 1;
    let razonText = "";
    let solicitud_id = e.target.getAttribute("data-solicitud_id");

    let statusString = {
      Aprobar: 2,
      Rechazar: 3,
    };

    estatus = statusString[e.target.getAttribute("data-name")];

    if (estatus === 3) {
      //Si lo rechazas dime por que...
      Swal.fire({
        title: "Descripción del rechazo",
        input: "textarea",
        inputAttributes: {
          autocapitalize: "off",
        },
        showCancelButton: true,
        confirmButtonText: "Continuar",
        showLoaderOnConfirm: true,
        cancelButtonText: "Regresar",
        cancelButtonColor: "Red",
        confirmButtonColor: "#4CD964",
        reverseButtons: true,
        preConfirm: (razon) => {
          if (razon !== "") {
            razonText = razon;
            return true;
          } else {
            Swal.showValidationMessage("Debe ingresar una razón");
          }
        },
        allowOutsideClick: () => !Swal.isLoading(),
      }).then((result) => {
        if (result.isConfirmed) {
          Api.loading(true);
          Api.fetch(
            "app/setRegentDocumentStatus",
            {
              id: id,
              estatus: 3,
              razon: razonText,
              solicitud_id: solicitud_id,
            },
            "POST"
          ).then((r) => {
            Api.loading(false);
            this.setState({ regente: r });
            this.handleRegBtn();
          });
        }
      });
    } else if (estatus === 2) {
      Swal.fire({
        title: "¿Seguro que desea aceptar este documento?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Regresar",
        reverseButtons: true,
        cancelButtonColor: "Red",
        confirmButtonColor: "#4CD964",
      }).then((result) => {
        if (result.isConfirmed) {
          Api.loading(true);
          Api.fetch(
            "app/setRegentDocumentStatus",
            {
              id: id,
              estatus: 2,
              razon: "",
              solicitud_id: solicitud_id,
            },
            "POST"
          ).then((r) => {
            Api.loading(false);
            this.setState({ regente: r });
            this.handleRegBtn();
          });
        }
      });
    }
  }

  // Funcion para cambiar el estatus de los documentos ESTABLECIMIENTOS
  handleEstablecimientoDocumentoStatus(e) {
    e.stopPropagation();
    e.preventDefault();

    let id = e.target.id; //parseInt(id);
    let estatus = 1;
    let razonText = "";

    let solicitud_id = e.target.getAttribute("data-solicitud_id");

    let statusString = {
      Aprobar: 2,
      Rechazar: 3,
    };

    //	estatus = statusString[nom_boton];

    estatus = statusString[e.target.getAttribute("data-name")];

    if (estatus === 3) {
      //Si lo rechazas dime por que...

      Swal.fire({
        title: "Descripción del rechazo",
        input: "textarea",
        inputAttributes: {
          autocapitalize: "off",
        },
        showCancelButton: true,
        confirmButtonText: "Continuar",
        showLoaderOnConfirm: true,
        cancelButtonText: "Regresar",
        cancelButtonColor: "Red",
        confirmButtonColor: "#4CD964",
        reverseButtons: true,
        preConfirm: (razon) => {
          if (razon !== "") {
            razonText = razon;
            return true;
          } else {
            Swal.showValidationMessage("Debe ingresar una razón");
          }
        },
        allowOutsideClick: () => !Swal.isLoading(),
      }).then((result) => {
        //rechazado
        if (result.isConfirmed) {
          Api.loading(true);
          Api.fetch(
            "app/setEstablecimientoDocumentStatus" + this.state.am,
            {
              id: id,
              estatus: 3,
              sinaip: 0,
              razon: razonText,
              solicitud_id: solicitud_id,
            },
            "POST"
          ).then((r) => {
            Api.loading(false);
            let est = {
              ...this.state.establecimiento,
            };
            est["documentos"] = r.documentos;
            this.setState({ establecimiento: est, solicitud_est: r.solicitud });
            this.handleEstBtn();
          });
        }
      });
    } else if (estatus === 2) {
      //aceptado
      Swal.fire({
        title: "¿Seguro que desea aceptar este documento?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Regresar",
        reverseButtons: true,
        cancelButtonColor: "Red",
        confirmButtonColor: "#4CD964",
      }).then((result) => {
        if (result.isConfirmed) {
          Api.loading(true);
          Api.fetch(
            "app/setEstablecimientoDocumentStatus" + this.state.am,
            {
              id: id,
              sinaip: 1,
              estatus: 4,
              razon: "",
              solicitud_id: solicitud_id,
            },
            "POST"
          ).then((r) => {
            Api.loading(false);
            let est = {
              ...this.state.establecimiento,
            };
            est["documentos"] = r.documentos;
            this.setState({ establecimiento: est, solicitud_est: r.solicitud });
            this.handleEstBtn();
          });
        }
      });
    }
  }

  // funcion para cambiar el estatus de documento de caso especial
  handleCasoEspecialDocumentoEstatusChange(e) {
    e.stopPropagation();
    e.preventDefault();

    let rcedID = e.target.id,
      estatus = e.target.dataset.estatus,
      title = "¿Seguro que desea aceptar este documento?",
      btnConfirm = "Aceptar";

    if (estatus === "0") {
      title = "¿Seguro que desea rechazar este documento?";
      btnConfirm = "Rechazar";
    }

    Swal.fire({
      icon: "question",
      title: title,
      // input: "textarea",
      showCancelButton: true,
      confirmButtonText: btnConfirm,
      showLoaderOnConfirm: true,
      cancelButtonText: "Regresar",
      reverseButtons: true,
      cancelButtonColor: "Red",
      confirmButtonColor: "#4CD964",
      // preConfirm: (razon) => {
      //   if (razon !== "") {
      //     razonText = razon;
      //     return true;
      //   } else {
      //     Swal.showValidationMessage("Debe ingresar una razón");
      //   }
      // },
      // allowOutsideClick: () => !Swal.isLoading(),
    }).then((result) => {
      if (result.isConfirmed) {
        Api.loading(true);
        Api.fetch(
          "app/setCasoEspecialDocumentoEstatus",
          {
            id: rcedID,
            estatus,
          },
          "POST"
        ).then((res) => {
          Api.loading(false);
          let caso_especial = {
            ...this.state.caso_especial,
          };

          caso_especial.documentacion = res.caso_especial.documentacion;
          caso_especial.todosDocsAprobados = caso_especial.documentacion.every(
            (d) => d.aprobado === "1"
          );

          this.setState({
            caso_especial: caso_especial,
            solicitud_ce: res.solicitud,
          });
        });
      }
    });
  }

  handleSingleErrorForm(error, msg) {
    document.getElementById(error + "-error").style.display = "block";
    document.getElementById(error + "-error").innerText = msg;
    document.getElementById(error).classList.add("is-invalid");
  }

  // fn para limpar errores cuando cambie el estado del input que los tenga
  cleanErrorsValidation(elemento) {
    let divError = document.getElementById(elemento + "-error"),
      classInvalid = document.getElementById(elemento);

    if (divError && classInvalid) {
      divError.style.display = "none";
      divError.innerText = "";
      classInvalid.classList.remove("is-invalid");
    }
  }

  handleCasoEspecialEstatus(e) {
    let estatus = e.target.value,
      id = e.target.dataset.caso_especial_id,
      title = "¿Aceptar solicitud?",
      text = "Ingrese observaciones si existen.",
      btnConfirm = "Aceptar",
      observacion = "",
      importacion = { ...this.state.importacion };

    if (estatus === "4") {
      title = "Descripción del rechazo";
      text = "";
      btnConfirm = "Continuar";
      this.cleanErrorsValidation("importaction_texto");
      this.cleanErrorsValidation("fines_texto");
    }

    if (!importacion.importacion_texto && estatus === "5") {
      this.handleSingleErrorForm(
        "importacion_texto",
        "Ingrese texto de importación."
      );
    }

    if (!importacion.fines_texto && estatus === "5") {
      this.handleSingleErrorForm(
        "fines_texto",
        "Ingrese motivo de importación."
      );
    }

    if (
      (importacion.importacion_texto &&
        importacion.fines_texto &&
        estatus === "5") ||
      estatus === "4"
    ) {
      Swal.fire({
        icon: "warning",
        title: title,
        text: text,
        input: "textarea",
        showCancelButton: true,
        confirmButtonText: btnConfirm,
        showLoaderOnConfirm: true,
        cancelButtonText: "Regresar",
        reverseButtons: true,
        preConfirm: (razon) => {
          if (estatus === "4" && razon === "") {
            Swal.showValidationMessage("Debe ingresar una razón");
          } else {
            observacion = razon;
            return true;
          }
        },
        allowOutsideClick: () => !Swal.isLoading(),
      }).then((result) => {
        if (result.isConfirmed) {
          Api.loading(true);
          Api.fetch(
            "app/setCasoEspecialEstatus",
            {
              id,
              estatus,
              observacion,
              importacion,
            },
            "PUT"
          ).then((res) => {
            Api.loading(false);
            Swal.fire({
              title: res.message.title,
              text: res.message.text,
              icon: res.message.icon,
            });
            // No necesitamos refrescar, solo invocar la pagina actual del grid de casos especiales
            this.setCasosEspecialesPage(this.state.paginaActual);
            // Luego cerramos el modal
            this.setState({ openModalCasoEspecial: false });
          });
        }
      });
    }
  }

  // Handle Products
  handleProductoStatus(e) {
    let statusString = {
      Aceptar: 10,
      Rechazar: 4,
    };

    let refrenda = this.state.solicitud_prod.tramite_id === "11" ? 1 : 0;
    let tramite_id = this.state.solicitud_prod.tramite_id;
    let status = statusString[e.target.innerText];

    if (tramite_id === "8") {
      if (status === 10) {
        let razon = "";
        Swal.fire({
          title: "¿Aceptar solicitud?",
          //text: "Ingrese observaciones si existen.",
          //input: "textarea",
          html:
            '<textarea id="swal-input1" placeholder="Ingrese observaciones si existen." className="form' +
            '-control" height="30"></textarea>',
          input: "checkbox",
          inputValue: 0,
          inputPlaceholder: "Solicitar revisión de asesoría legal",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Aceptar",
          cancelButtonText: "Regresar",
          reverseButtons: true,
          cancelButtonColor: "Red",
          confirmButtonColor: "#4CD964",
          preConfirm: (r) => {
            razon = document.querySelector("#swal-input1").value;
            /*  if (razon === "") {
              Swal.showValidationMessage(
                "Es obligatorio ingresar una observación"
              );
            } */
          },
        }).then((result) => {
          if (result.isConfirmed) {
            this.handleChangeStatusProducto(
              e.target.value,
              razon,
              refrenda,
              result.value,
              tramite_id
            );
          }
        });
      } else {
        let razon = "";
        Swal.fire({
          title: "Rechazar solicitud",
          icon: "warning",
          html:
            '<textarea id="swal-input1" placeholder="Ingrese razón del rechazo" className="form' +
            '-control" height="30"></textarea>',
          /* input: "checkbox", inputValue: 0, inputPlaceholder: "Marcar solicitar corrección", */
          showCancelButton: true,
          confirmButtonText: "Rechazar",
          cancelButtonText: "Regresar",
          cancelButtonColor: "Red",
          reverseButtons: true,
          preConfirm: (r) => {
            razon = document.querySelector("#swal-input1").value;
            if (razon === "") {
              Swal.showValidationMessage(
                "Es obligatorio ingresar una observación"
              );
            }
          },
        }).then((result) => {
          if (result.isConfirmed) {
            this.handleChangeStatusProducto(
              e.target.value,
              razon,
              refrenda,
              0,//asesoria
              tramite_id
            );
          }
        });
      }
    } else {
      if (status === 10) {
        Swal.fire({
          title: "¿Aceptar solicitud?",
          text: "Ingrese observaciones si existen.",
          input: "textarea",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Aceptar",
          cancelButtonText: "Regresar",
          reverseButtons: true,
          cancelButtonColor: "Red",
          confirmButtonColor: "#4CD964",
        }).then((result) => {
          if (result.isConfirmed) {
            this.handleChangeStatusProducto(
              e.target.value,
              result.value,
              refrenda,
              0,
              tramite_id
            );
          }
        });
      } else {
        let razon = "";
        Swal.fire({
          title: "Rechazar solicitud",
          icon: "warning",
          html:
            '<textarea id="swal-input1" placeholder="Ingrese razón del rechazo" className="form' +
            '-control" height="30"></textarea>',
          /* input: "checkbox", inputValue: 0, inputPlaceholder: "Marcar solicitar corrección", */
          showCancelButton: true,
          confirmButtonText: "Rechazar",
          cancelButtonText: "Regresar",
          cancelButtonColor: "Red",
          confirmButtonColor: "#4CD964",
          reverseButtons: true,
          preConfirm: (r) => {
            razon = document.querySelector("#swal-input1").value;
            if (razon === "") {
              Swal.showValidationMessage(
                "Es obligatorio ingresar una observación"
              );
            }
          },
        }).then((result) => {
          if (result.isConfirmed) {
            this.handleChangeStatusProducto(
              e.target.value,
              razon,
              refrenda,
              0,
              tramite_id
            );
          }
        });
      }
    }
  }

  handleProductosDocumentoStatus(e) {
    e.stopPropagation();
    e.preventDefault();

    let id = e.target.id; //parseInt(id);
    let estatus = 1;
    let razonText = "";

    let solicitud_id = e.target.getAttribute("data-solicitud_id"); //this.state.solicitud_est.id;//
    // let solicitud_estatus = e.target.getAttribute("data-solicitud_estatus"); //this.state.solicitud_est.estatus;

    /* 
    if (solicitud_estatus === "En espera") {
      
      // this.handleChangeStatusRegente(2);
    } */

    let statusString = {
      Aprobar: 2,
      Rechazar: 3,
    };

    //	estatus = statusString[nom_boton];

    estatus = statusString[e.target.getAttribute("data-name")];

    if (estatus === 3) {
      //Si lo rechazas dime por que...

      Swal.fire({
        title: "Descripción del rechazo",
        input: "textarea",
        inputAttributes: {
          autocapitalize: "off",
        },
        showCancelButton: true,
        confirmButtonText: "Continuar",
        showLoaderOnConfirm: true,
        cancelButtonText: "Regresar",
        reverseButtons: true,
        cancelButtonColor: "Red",
        confirmButtonColor: "#4CD964",
        preConfirm: (razon) => {
          if (razon !== "") {
            razonText = razon;
            return true;
          } else {
            Swal.showValidationMessage("Debe ingresar una razón");
          }
        },
        allowOutsideClick: () => !Swal.isLoading(),
      }).then((result) => {
        //rechazado
        if (result.isConfirmed) {
          Api.loading(true);
          Api.fetch(
            "app/setProductoDocumentStatus",
            {
              id: id,
              estatus: 3,
              sinaip: 0,
              razon: razonText,
              solicitud_id: solicitud_id,
            },
            "POST"
          ).then((r) => {
            Api.loading(false);
            this.setState({ docProductos: r });
            this.handleProBtn();
          });
        }
      });
    } else if (estatus === 2) {
      //aceptado
      Swal.fire({
        title: "¿Seguro que desea aceptar este documento?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Regresar",
        reverseButtons: true,
        cancelButtonColor: "Red",
        confirmButtonColor: "#4CD964",
      }).then((result) => {
        if (result.isConfirmed) {
          Api.loading(true);
          Api.fetch(
            "app/setProductoDocumentStatus",
            {
              id: id,
              sinaip: 1,
              estatus: 4,
              razon: "",
              solicitud_id: solicitud_id,
            },
            "POST"
          ).then((r) => {
            Api.loading(false);

            this.setState({ docProductos: r });
            this.handleProBtn();
          });
        }
      });
    }
  }

  // Funcion para cambiar el estatus de los documentos ESTABLECIMIENTOS
  handleMedicoVetDocumentoStatus(e) {
    //CAMBIAR
    e.stopPropagation();
    e.preventDefault();

    let id = e.target.id;
    let estatus = 1;
    let razonText = "";

    let solicitud_id = e.target.getAttribute("data-solicitud_id");

    let statusString = {
      Aprobar: 2,
      Rechazar: 3,
    };

    estatus = statusString[e.target.getAttribute("data-name")];

    if (estatus === 3) {
      //Si lo rechazas dime por que...
      Swal.fire({
        title: "Descripción del rechazo",
        input: "textarea",
        inputAttributes: {
          autocapitalize: "off",
        },
        showCancelButton: true,
        confirmButtonText: "Continuar",
        showLoaderOnConfirm: true,
        cancelButtonText: "Regresar",
        cancelButtonColor: "Red",
        confirmButtonColor: "#4CD964",
        reverseButtons: true,
        preConfirm: (razon) => {
          if (razon !== "") {
            razonText = razon;
            return true;
          } else {
            Swal.showValidationMessage("Debe ingresar una razón");
          }
        },
        allowOutsideClick: () => !Swal.isLoading(),
      }).then((result) => {
        //rechazado
        if (result.isConfirmed) {
          Api.loading(true);
          Api.fetch(
            "app/setMedVetDocumentStatus",
            {
              id: id,
              estatus: "3",
              //sinaip: 0,
              razon: razonText,
              solicitud_id: solicitud_id,
            },
            "POST"
          ).then((r) => {
            Api.loading(false);
            let mv = {
              ...this.state.medico_veterinario,
            };
            mv["documentos"] = r;
            this.setState({ medico_veterinario: mv });
            this.handleMVBtn(); ////////////

            this.setMedicoVeterinarioPage(this.state.paginaActual_mv);
          });
        }
      });
    } else if (estatus === 2) {
      //aceptado
      Swal.fire({
        title: "¿Seguro que desea aceptar este documento?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Regresar",
        reverseButtons: true,
        cancelButtonColor: "Red",
        confirmButtonColor: "#4CD964",
      }).then((result) => {
        if (result.isConfirmed) {
          Api.loading(true);
          Api.fetch(
            "app/setMedVetDocumentStatus",
            {
              id: id,
              //sinaip: 1,
              estatus: "4",
              razon: "",
              solicitud_id: solicitud_id,
            },
            "POST"
          ).then((r) => {
            Api.loading(false);
            let mv = {
              ...this.state.medico_veterinario,
            };

            mv["documentos"] = r;
            this.setState({ medico_veterinario: mv });
            this.handleMVBtn(); //////////////////
          });
        }
      });
    }
  }

  //Funcion para controlar los checkbox de los documentos del regente
  handleRegentChecks(e) {
    let rChk = [];

    rChk = this.state.regenteDocsCheck;
    rChk[e.target.id] = e.target.checked;
    this.setState({ regenteDocsCheck: rChk, allRc: false });
  }

  //Funcion para controlar los checkbox de los documentos del establecimiento
  handleEstChecks(e) {
    let rChk = [];

    rChk = this.state.establecimientoDocsCheck;
    rChk[e.target.id] = e.target.checked;
    this.setState({ establecimientoDocsCheck: rChk, allEst: false });
  }

  //Funcion para controlar los checkbox de los documentos del producto
  handleProChecks(e) {
    let rChk = [];

    rChk = this.state.productoDocsCheck;
    rChk[e.target.id] = e.target.checked;
    this.setState({ productoDocsCheck: rChk, allPro: false });
  }

  //Funcion para controlar los checkbox de los documentos del producto
  handleMedicoVetChecks(e) {
    let rChk = [];

    rChk = this.state.medicoVetDocsCheck;
    rChk[e.target.id] = e.target.checked;
    this.setState({ medicoVetDocsCheck: rChk, allMV: false });
  }

  //Funcion para switchear entre marcado y desmarcado de todos checkbox
  allDocsRegent(e) {
    let rChk = [];
    for (let file in this.state.regente.documentos) {
      rChk[this.state.regente.documentos[file].id] = e.target.checked;
    }

    this.setState({
      regenteDocsCheck: rChk,
      allRegenteDocs: e.target.checked,
      allRc: e.target.checked,
    });
  }

  allDocsEst(e) {
    //
    let rChk = [];
    for (let file in this.state.establecimiento.documentos) {
      rChk[this.state.establecimiento.documentos[file].id] = e.target.checked;
    }
    //
    this.setState({
      establecimientoDocsCheck: rChk,
      allEstDocs: e.target.checked,
      allEst: e.target.checked,
    });
  }

  allDocsPro(e) {
    let rChk = [];

    for (let file in this.state.docProductos) {
      rChk[this.state.docProductos[file].id] = e.target.checked;
    }

    this.setState({
      productoDocsCheck: rChk,
      allProDocs: e.target.checked,
      allPro: e.target.checked,
    });
  }

  allDocsMV(e) {
    let rChk = [];

    for (let file in this.state.medico_veterinario.documentos) {
      rChk[this.state.medico_veterinario.documentos[file].id] =
        e.target.checked;
    }

    this.setState({
      medicoVetDocsCheck: rChk,
      allMVDocs: e.target.checked,
      allMV: e.target.checked,
    });
  }

  // Funcion para solicitar la descarga de los documentos del regente
  handleDownloadZipRegentes(e) {
    let docs = "";

    for (let file in this.state.regenteDocsCheck) {
      if (this.state.regenteDocsCheck[file]) {
        docs += file + ",";
      }
    }
    this.setState({
      previa_url: Api.url + "app/zipR/?docs=" + docs + "&" + Math.random(),
    });
  }

  // Funcion para solicitar la descarga de los documentos del producto
  handleDownloadZipProductos(e) {
    let docs = "";
    for (let file in this.state.productoDocsCheck) {
      if (this.state.productoDocsCheck[file]) {
        docs += file + ",";
      }
    }
    this.setState({
      previa_url: Api.url + "app/zipP/?docs=" + docs + "&" + Math.random(),
    });
  }

  // Funcion para solicitar la descarga de los documentos del establecimiento
  handleDownloadZipEstablecimientos(e) {
    let docs = "";
    for (let file in this.state.establecimientoDocsCheck) {
      if (this.state.establecimientoDocsCheck[file]) {
        docs += file + ",";
      }
    }
    this.setState({
      previa_url:
        Api.url +
        `app/zipE${this.state.am}/?docs=` +
        docs +
        "&" +
        Math.random(),
    });
  }

  // Funcion para solicitar la descarga de los documentos del establecimiento
  handleDownloadZipMedicoVet(e) {
    let docs = "";
    for (let file in this.state.medicoVetDocsCheck) {
      if (this.state.medicoVetDocsCheck[file]) {
        docs += file + ",";
      }
    }

    this.setState({
      previa_url: Api.url + "app/zipMV/?docs=" + docs + "&" + Math.random(),
    });
  }

  // Funcion para mostrar las vistas previas en grande y/o forzar la descarga
  handlePrevia(e) {
    let doc = e.target.getAttribute("data-file");
    this.setState({ previa: true, previa_url: doc });
  }

  //Funciones para controlar la validación de pagos
  handleOpenRegentPago(e) {
    Swal.fire({
      title: "Validación de Pago",
      input: "text",
      showCancelButton: true,
      confirmButtonText: "Guardar",
      cancelButtonText: "Regresar",
      reverseButtons: true,
      inputValidator: (numeroPago) => {
        // Si el valor es válido, debes regresar undefined. Si no, una cadena
        if (!numeroPago) {
          return "Por favor ingresa el número de orden de pago.";
        } else {
          return undefined;
        }
      },
    }).then((resultado) => {
      if (resultado.value) {
        this.handleChangeStatusRegente(3);
      }
    });
  }

  handleRegBtn = (e) => {
    //let rechazos = 0;
    let aprobados = 0;
    let sin_verificar = 0;
    let estdocs = document.querySelectorAll(".reg-doc-status");
    let mostrar_boton_rcz = true;

    for (let est in estdocs) {
      if (typeof estdocs[est] === "object") {
        if (estdocs[est].innerText === "Rechazado") {
          //rechazos++;
        } else if (estdocs[est].innerText === "Sin Verificar") {
          sin_verificar++;
        } else {
          aprobados++;
        }
      }
    }

    if((this.state.regente.tramite_id === "1" || this.state.regente.tramite_id === "2") &&
      (this.state.regente.accion_id === "2002" || this.state.regente.accion_id === "2")){
        mostrar_boton_rcz = false;
    }
     console.log(this.state.tramite_id);
    if (
      this.state.reg_estatus_tramite_id === "1" ||
      this.state.reg_estatus_tramite_id === "6"
    ) {
      if (sin_verificar === estdocs.length) {
        // NO SE HA TOCADO NINGÚN DOCUMENTO
        document.getElementById("rechazar_reg").classList = "btn btn-danger";
      } else {
        if(mostrar_boton_rcz){
          document.getElementById("rechazar_reg").classList = "hide"; // YA SE RESPONDIÓ DOC ENTONCES NO SE PUEDE RECHAZAR
        }else{
          document.getElementById("rechazar_reg").classList = "btn btn-danger";
        }
        if (aprobados === estdocs.length ) {
          //TODOS FUERON ACEPTADOS
          document.getElementById("aprobar_reg").classList = "btn btn-success";
        }
      }
    }

    if(this.state.regente.accion_id === "3002"  || this.state.tramite_id === "18"){ //si es reposicion se van a mostrar las dos opciones 
      //pensar en un caso si acaso se lleguen a pedir documentos
      document.getElementById("rechazar_reg").classList = "btn btn-danger";
      document.getElementById("aprobar_reg").classList = "btn btn-success";
    }
    //SI es verdadero se va a correccion
    return sin_verificar !== estdocs.length;
  };

  handleEstBtn() {
    let rechazos = 0;
    let sin_verificar = 0;
    let dte = this.modalEst.querySelector("#detalleEstablecimiento");

    let estdocs = dte.querySelectorAll(".est-doc-status");

    for (let est in estdocs) {
      if (typeof estdocs[est] === "object") {
        if (
          estdocs[est].innerText === "Rechazado" ||
          estdocs[est].innerText === "Sin Verificar"
        ) {
          rechazos++;
        }

        if (estdocs[est].innerText === "Sin Verificar") {
          sin_verificar++;
        }
      }
    }

    if (
      this.state.solicitud_est.estatus === "En espera SINAIP" ||
      this.state.solicitud_est.estatus === "Corrección" 
    ) {
      if (rechazos === 0) {
        dte.querySelector("#aprobar_est").classList = "btn btn-success";
      } else {
        dte.querySelector("#rechazar_est").classList = "btn btn-danger";
      }

      if (sin_verificar === estdocs.length) {
        dte.querySelector("#rechazar_est").classList = "btn btn-danger";
      } else {
        dte.querySelector("#rechazar_est").classList = "hide";
      }
    }

    //SI es verdadero se va a correccion
    return sin_verificar !== estdocs.length;
  }

  handleProBtn = (e) => {
    let rechazos = 0;
    let sin_verificar = 0;
    let prodocs = document.querySelectorAll(".pro-doc-status");
    for (let pro in prodocs) {
      if (typeof prodocs[pro] === "object") {
        if (
          prodocs[pro].innerText === "Rechazado" ||
          prodocs[pro].innerText === "Sin Verificar"
        ) {
          rechazos++;
        }

        if (prodocs[pro].innerText === "Sin Verificar") {
          sin_verificar++;
        }
      }
    }

    document.getElementById("rechazar_pro").classList = "hide";
    document.getElementById("aprobar_pro").classList = "hide";

    if (rechazos <= 0) {
      document.getElementById("aprobar_pro").classList = "btn btn-success";
    } else {
      document.getElementById("aprobar_pro").classList = "hide";
    }

    if (sin_verificar === prodocs.length) {
      document.querySelector("#rechazar_pro").classList = "btn btn-danger";
    } else {
      document.querySelector("#rechazar_pro").classList = "hide";
    }
  };

  handleMVBtn = (e) => {
    let rechazos = 0;
    let sin_verificar = 0;
    let mvdocs = document.querySelectorAll(".mv-doc-status");
    for (let m in mvdocs) {
      if (typeof mvdocs[m] === "object") {
        if (
          mvdocs[m].innerText === "Rechazado" ||
          mvdocs[m].innerText === "Sin Verificar"
        ) {
          rechazos++;
        }

        if (mvdocs[m].innerText === "Sin Verificar") {
          sin_verificar++;
        }
      }
    }

    if (rechazos <= 0) {
      document.getElementById("aprobar_mv").classList = "btn btn-success";
    } else {
      document.getElementById("aprobar_mv").classList = "hide";
    }

    if (sin_verificar === mvdocs.length) {
      document.querySelector("#rechazar_mv").classList = "btn btn-danger";
    } else {
      document.querySelector("#rechazar_mv").classList = "hide";
    }

    return sin_verificar !== mvdocs.length;
  };

  // Funcion para controlar el estado de la solicitud, rechazada o aceptada de
  // regente
  handleRegentStatus(e) {
    let statusString = {
      Aceptar: 5,
      Rechazar: 4,
    };

    let status = statusString[e.target.innerText];

    if (status === 5) {
      Swal.fire({
        title: "¿Aceptar solicitud?",
        text: "Ingrese observaciones si existen.",
        input: "textarea",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Regresar",
        reverseButtons: true,
        cancelButtonColor: "Red",
        confirmButtonColor: "#4CD964",
      }).then((result) => {
        if (result.isConfirmed) {
          this.handleChangeStatusRegente(e.target.value, result.value);
          if(this.state.regente.accion_id !== "3002"){//si es reposición ya se paga primero
            this.handleCreateOrdenPago();
          }
        }
      });
    } else {
      let razon = "";
      Swal.fire({
        title: "Rechazar solicitud",
        icon: "warning",
        html:
          '<textarea id="swal-input1" placeholder="Ingrese razón del rechazo" className="form' +
          '-control" height="30"></textarea>',
        /* input: "checkbox",
        inputValue: 0,
        inputPlaceholder: "Marcar solicitar corrección", */
        showCancelButton: true,
        confirmButtonText: "Rechazar",
        cancelButtonText: "Regresar",
        cancelButtonColor: "Red",
        confirmButtonColor: "#4CD964",
        reverseButtons: true,
        preConfirm: (r) => {
          razon = document.querySelector("#swal-input1").value;
          if (razon === "") {
            Swal.showValidationMessage(
              "Es obligatorio ingresar una observación"
            );
          } else {
            razon = razon;
          }
        },
      }).then((result) => {
        if (result.isConfirmed) {
          this.handleChangeStatusRegente(e.target.value, razon);
        }
      });
    }
  }

  handleMovimientoProducto(e) {
    let statusString = {
        Aceptar: 15,
        Rechazar: 4,
      },
      solicitud_id = e.target.getAttribute("data-solicitud_id");

    let status = statusString[e.target.innerText];

    if (status === 15) {
      Swal.fire({
        title: "¿Aceptar movimiento?",
        text: "Ingrese observaciones si existen.",
        input: "textarea",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Regresar",
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          Api.loading(true);
          Api.fetch(
            "app/updateStatusMP",
            {
              solicitud_id,
              estatus: e.target.value,
              observacion: result.value,
            },
            "PUT"
          ).then((data) => {
            Api.notify(data.message);

            // No necesitamos refrescar, solo invocar la pagina actual del grid de regentes
            this.setMovimientoProductosPage(this.state.paginaActual);
            // Luego cerramos el modal
            this.setState({ openModalMovimiento: false });

            Api.loading(false);
          });
        }
      });
    } else {
      let razon = "";
      Swal.fire({
        title: "Rechazar movimiento",
        icon: "warning",
        html:
          '<textarea id="swal-input1" placeholder="Ingrese razón del rechazo" className="form' +
          '-control" height="30"></textarea>',
        /* input: "checkbox",
        inputValue: 0,
        inputPlaceholder: "Marcar solicitar corrección", */
        showCancelButton: true,
        confirmButtonText: "Rechazar",
        cancelButtonText: "Regresar",
        reverseButtons: true,
        preConfirm: (r) => {
          razon = document.querySelector("#swal-input1").value;
          if (razon === "") {
            Swal.showValidationMessage(
              "Es obligatorio ingresar una observación"
            );
          }
        },
      }).then((result) => {
        if (result.isConfirmed) {
          Api.loading(true);
          Api.fetch(
            "app/updateStatusMP",
            {
              solicitud_id,
              estatus: e.target.value,
              observacion: razon.toUpperCase(),
            },
            "PUT"
          ).then((data) => {
            Api.notify(data.message);

            // No necesitamos refrescar, solo invocar la pagina actual del grid de regentes
            this.setMovimientoProductosPage(this.state.paginaActual);
            // Luego cerramos el modal
            this.setState({ openModalMovimiento: false });

            Api.loading(false);
          });
        }
      });
    }
  }

  // Funcion para controlar el estado de la solicitud, rechazada o aceptada de establecimiento
  handleEstablecimientoStatus(e) {
    let statusString = {
      Aceptar: 10,
      Rechazar: 4,
    };

    let status = statusString[e.target.innerText];

    if (status === 10) {
      Swal.fire({
        title: "¿Aceptar solicitud?",
        text: "Ingrese observaciones si existen.",
        input: "textarea",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Regresar",
        reverseButtons: true,
        cancelButtonColor: "Red",
        confirmButtonColor: "#4CD964",
      }).then((result) => {
        if (result.isConfirmed) {
          this.handleChangeStatusEstablecimiento(e.target.value, result.value);
        }
      });
    } else {
      let razon = "";
      Swal.fire({
        title: "Rechazar solicitud",
        icon: "warning",
        html:
          '<textarea id="swal-input1" placeholder="Ingrese razón del rechazo" className="form' +
          '-control" height="30"></textarea>',
        input: "checkbox",
        inputValue: 0,
        inputPlaceholder: "Marcar solicitar corrección",
        showCancelButton: true,
        confirmButtonText: "Rechazar",
        cancelButtonText: "Regresar",
        cancelButtonColor: "Red",
        confirmButtonColor: "#4CD964",
        reverseButtons: true,
        preConfirm: (r) => {
          razon = document.querySelector("#swal-input1").value;
          if (razon === "") {
            Swal.showValidationMessage(
              "Es obligatorio ingresar una observación"
            );
          }
        },
      }).then((result) => {
        if (result.isConfirmed) {
          this.handleChangeStatusEstablecimiento(
            e.target.value,
            razon,
            result.value
          );
        }
      });
    }
  }

  //Funcion para postear el status de solicitud establecimiento
  handleChangeStatusEstablecimiento(e, observacion = "", correccion = 0) {
    Api.loading(true);
    // Si requerimos corrección entonces cambiamos su estatus al 6 que corresponde a
    // correccion
    if (correccion && this.handleEstBtn()) {
      e = 6;
    }else if(this.state.solicitud_est.accion === "Reposición"){
      e = "5";
    }

    let solid = this.state.solicitud_est.id;
    if (this.state.am !== "") {
      solid = this.state.nota_marginal.solicitud_id;
    }

    Api.fetch(
      "app/updateStatusEst" + this.state.am,
      {
        id: solid,
        status: e,
        observacion: observacion,
        correccion: correccion,
        actividad_id: this.state.solicitud_est.actividad_id,
        establecimiento_id: this.state.establecimiento.establecimiento.id,
      },
      "PUT"
    ).then((r) => {
      Api.notify(r.message);
      if (e === 2) {
        // ESTE CASO SE HACE PARA AGREGAR CUANDO ES EN ESPERA Notificamos sin obstruir
        // el UI, que todo bien.
        Api.notify(r.message);
      } else {
        // No necesitamos refrescar, solo invocar la pagina actual del grid de regentes
        this.setEstablecimientosPage(this.state.paginaActual);
        // Luego cerramos el modal
        this.modalEst.close();

        this.setState({ modalEstablecimiento: false });
        Api.loading(false);

        Swal.fire({
          title: "Éxito",
          text: r.message,
          icon: "success",
        });
      }
    });
  }

  handleChangeStatusProducto(
    e,
    observacion = "",
    refrenda,
    asesoria = 0,
    tramite_id
  ) {
    Api.loading(true);

    if (e === "10") {
      e = 11;
    }

    if (asesoria) {
      e = 10;
    }

    if (refrenda && e !== "4") {
      e = 5; //y me falta crear la refrenda
    }

    let obj = {
      solicitud_id: this.state.solicitud_prod.id,
    };

    Api.fetch(
      "app/updateStatusPro",
      {
        id: this.state.solicitud_pro.id,
        status: e,
        tramite_id: tramite_id,
        observacion: observacion,
        asesoria: asesoria,
        refrenda: refrenda,
      },
      "PUT"
    ).then((r) => {
      if (refrenda && e !== "4") {
        Api.fetch("app/createRefrenda", obj, "post").then((ref) => {
          Api.loading(false);
          this.modalPro.close();
          this.setProductosPage(this.state.paginaActual_p);
          Swal.fire({
            title: ref.message.title,
            text: ref.message.text,
            icon: ref.message.icon,
          });
        });
      } else {
        Api.loading(false);
        this.modalPro.close();
        this.setProductosPage(this.state.paginaActual_p);
        Swal.fire({
          title: "Éxito",
          text: r.message,
          icon: "success",
        });
      }      
    });
  }

  //Funcion para postear el status
  handleChangeStatusRegente(e, observacion = "", correccion = 0) {
    Api.loading(true);
    // Si requerimos corrección entonces cambiamos su estatus al 6 que corresponde a
    // correccion
    if (correccion && this.handleRegBtn()) {
      e = 6;
    }

    Api.fetch(
      "app/updateStatusApp",
      {
        id: this.state.regente.id,
        status: e,
        observacion: observacion,
        correccion: correccion,
      },
      "PUT"
    ).then((r) => {
      if (e === 2) {
        // ESTE CASO SE HACE PARA AGREGAR CUANDO ES EN ESPERA Notificamos sin obstruir
        // el UI, que todo bien.
        Api.notify(r.message);
      } else {
        // No necesitamos refrescar, solo invocar la pagina actual del grid de regentes
        this.setRegentesPage(this.state.paginaActual);
        // Luego cerramos el modal
        this.setState({ modalRegente: false });
        Api.loading(false);

        Swal.fire({
          title: "Éxito",
          text: r.message,
          icon: "success",
        });
      }
    });
  }

  // Funcion para controlar el estado de la solicitud, rechazada o aceptada de establecimiento
  handleMedicoVetStatus(e) {
    let statusString = {
      Aceptar: 5,
      Rechazar: 4,
    };
    // let solicitud_id = e.target.getAttribute("data-solicitud_id"); //this.state.solicitud_est.id;//

    let status = statusString[e.target.innerText];

    if (status === 5) {
      //let razon = "";
      Swal.fire({
        title: "¿Aceptar solicitud?",
        text: "Ingrese observaciones si existen.",
        input: "textarea",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Regresar",
        cancelButtonColor: "Red",
        confirmButtonColor: "#4CD964",
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.handleChangeStatusMedicoVet(e.target.value, result.value);
        }
      });
    } else {
      let razon = "";
      Swal.fire({
        title: "Rechazar solicitud",
        icon: "warning",
        html:
          '<textarea id="swal-input1" placeholder="Ingrese razón del rechazo" className="form' +
          '-control" height="30"></textarea>',
        showCancelButton: true,
        confirmButtonText: "Rechazar",
        cancelButtonText: "Regresar",
        reverseButtons: true,
        cancelButtonColor: "Red",
        confirmButtonColor: "#4CD964",
        preConfirm: (r) => {
          razon = document.querySelector("#swal-input1").value;
          if (razon === "") {
            Swal.showValidationMessage(
              "Es obligatorio ingresar una observación"
            );
          }
        },
      }).then((result) => {
        if (result.isConfirmed) {
          this.handleChangeStatusMedicoVet(
            e.target.value,
            razon //,
            //result.value
          );
        }
      });
    }
  }

  //Funcion para postear el status de solicitud establecimiento
  handleChangeStatusMedicoVet(e, observacion = "", correccion = 0) {
    Api.loading(true);
    // Si requerimos corrección entonces cambiamos su estatus al 6 que corresponde a
    // correccion
    if (correccion && this.handleMVBtn()) {
      e = 6;
    }

    Api.fetch(
      "app/updateStatusMV",
      {
        id: this.state.solicitud_mv.id,
        status: e,
        observacion: observacion,
        correccion: correccion,
      },
      "PUT"
    ).then((r) => {
      if (e === 2) {
        //aceptado
        // ESTE CASO SE HACE PARA AGREGAR CUANDO ES EN Revision. Notificamos sin obstruir el UI
        Api.notify(r.message);
      } else {
        // No necesitamos refrescar, solo invocar la pagina actual del grid de regentes
        this.setMedicoVeterinarioPage(this.state.paginaActual_mv);
        this.modalMV.close(); //cerramos el modal
        this.setState({ modalMV: false });
        Api.loading(false);
        Swal.fire({
          title: r.m.title,
          text: r.m.text,
          icon: r.m.icon,
        });
      }
    });
  }

  //Funcion para crear la orden de pago
  handleCreateOrdenPago() {
    //tomamos la informacion del regente y la solicitud
    const postData = { ...this.state.regente };

    Api.fetch("app/createPayOrder", postData, "post").then((r) => {
      //Notificamos sin obstruir el UI, que todo bien.
      Api.notify(r.message);
    });
  }
  //Terminamos con el control de regentes funcion para usuario_revisa
  handleUpdateRevisa(id) {
    Api.fetch(
      "app/updateUsuarioRevisa",
      {
        id,
      },
      "PUT"
    ).then((r) => {
      //this.setRegentesPage(this.state.paginaActual);
    });
  }

  modalCons = {};
  handleOpenConstancias(e) {
    let tituloModal = e.target.dataset.folio;
    let solid = e.target.getAttribute("data-solicitud-id");
    let detalle = document.querySelector("#detalleConstancia");
    //this.setState({ validez_id: "0", texto_acta: "" });

    Api.loading(true);

    Api.fetch("app/getSolicitudesConstancia?id=" + solid).then((e) => {
      this.setState({
        constancia: e.constancias,
        solicitud_cons: e.solicitud,
        working: false,
        constancia_revisada_8: false,
      });

      let tipo_cons = this.state.solicitud_cons.constancia_tipo_id;
      let textoLibre = [1, 2, 3, 12];
      let encuentra_tl = textoLibre.includes(parseInt(tipo_cons));

      if (encuentra_tl) {
        let f_txt_libre = detalle.querySelector("#f_cons_txt_libre");
        f_txt_libre.merge(e.constancias);

        let selectElement = detalle.querySelector("#texto_acta");
        if (e.constancias.validez_id !== null) {
          selectElement.value = e.constancias.texto_acta;
          selectElement.disabled = "disabled";
        } else {
          selectElement.addEventListener("change", this.handleTextActaChange);
          selectElement.value = this.state.texto_acta;
          selectElement.disabled = "";
        }
      } else {
        if (tipo_cons === "4") {
          let f_actividad = detalle.querySelector("#f_cons_actividad");
          f_actividad.merge(e.constancias);
        } else if (tipo_cons === "5") {
          let f_regente = detalle.querySelector("#f_cons_regente");
          f_regente.merge(e.constancias);
        } else if (
          tipo_cons === "6" ||
          tipo_cons === "7" ||
          tipo_cons === "10" ||
          tipo_cons === "11"
        ) {
          let f_establecimiento = detalle.querySelector(
            "#f_cons_establecimiento"
          );

          Api.fetch("app/getConsProductosSolicitud?id=" + solid).then((d) => {
            this.setState({
              cons_productos: d,
            });
          });

          f_establecimiento.merge(e.constancias);
        } else if (tipo_cons === "8") {
          let f_establecimiento = detalle.querySelector(
            "#f_cons_establecimiento"
          );

          Api.fetch("app/getProductoConstanciaAM?id=" + solid).then((d) => {
            this.setState({
              cons_productos: d,
            });

            let btnList = detalle.querySelectorAll(".btn-cons-am");
            btnList.forEach((btn) => {
              btn.addEventListener("click", this.addProductosConsAM);
            });

            let textlist = detalle.querySelectorAll(".txt-am");
            textlist.forEach((txt) => {
              txt.addEventListener("change", this.handleTextAM);
            });
          });

          f_establecimiento.merge(e.constancias);
        } else if (tipo_cons === "9") {
          let f_representante = detalle.querySelector("#f_cons_representante");

          f_representante.merge(e.constancias);
        }
      }

      detalle.querySelector("#regresar_cons").addEventListener("click", (e) => {
        this.modalCons.close();
        this.setState({ validez_id: "0", texto_acta: "" });

        let validez = detalle.querySelector("#f_validez");
        validez.querySelector("#validez_id").value = "0";
        let selectElement = detalle.querySelector("#texto_acta");
        selectElement.value = this.state.texto_acta;
      });

      if (
        this.state.solicitud_cons.estatus_tramite_id === "4" ||
        this.state.solicitud_cons.estatus_tramite_id === "5"
      ) {
        detalle.querySelector("#rechazar_cons").disabled = "disabled";
        detalle.querySelector("#aprobar_cons").disabled = "disabled";

        if (e.constancias.validez_id !== null) {
          this.setState({ validez_id: e.constancias.validez_id, constancia_revisada_8: true});
          let validez = detalle.querySelector("#f_validez");
          validez.querySelector("#validez_id").value = e.constancias.validez_id;
          validez.querySelector("#validez_id").disabled = "disabled";
        }
      } else {
        this.handleUpdateRevisa(solid);
        detalle
          .querySelector("#rechazar_cons")
          .addEventListener("click", this.handleConstanciaStatus);
        detalle
          .querySelector("#aprobar_cons")
          .addEventListener("click", this.handleConstanciaStatus);
        detalle.querySelector("#rechazar_cons").disabled = "";
        detalle.querySelector("#aprobar_cons").disabled = "";

        let validez = detalle.querySelector("#f_validez");
        validez.querySelector("#validez_id").value = "0";
        validez.querySelector("#validez_id").disabled = "";
      }

      this.modalCons = Api.modal({
        title: "Folio solicitud: " + tituloModal,
        html: detalle,
      });
      Api.loading(false);
    });
  }

  handleConstanciaStatus(e) {
    let statusString = {
      Aceptar: 5,
      Rechazar: 4,
    };
    let solicitud_id = this.state.solicitud_cons.id;
    let cons_tipo_id = this.state.solicitud_cons.constancia_tipo_id;
    let status = statusString[e.target.innerText];
    let validez_id = this.state.validez_id;
    let texto_acta = this.state.texto_acta;
    const tipo_id = ["1", "2", "3", "12"];
    let productos = this.state.cons_productos;

    if (status === 5) {
      if (validez_id === "0") {
        Swal.fire({
          title: "Error",
          icon: "warning",
          text: "Favor de ingresar la validez de la constancia",
        });
      } else if (
        texto_acta === "" &&
        tipo_id.includes(cons_tipo_id)
        /* (cons_tipo_id === "1" ||
          cons_tipo_id === "2" ||
          cons_tipo_id === "3" ||
          cons_tipo_id === "12") */
      ) {
        Swal.fire({
          title: "Error",
          icon: "warning",
          text: "Favor de ingresar el texto del acta",
        });
      } else {
        let obj_constancia = {
          sol_id: solicitud_id,
          cons_tipo_id: cons_tipo_id,
          val_id: validez_id,
          productos: productos,
          txt_acta: texto_acta,
        };

        Swal.fire({
          title: "¿Aceptar solicitud?",
          text: "Ingrese observaciones si existen.",
          input: "textarea",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Aceptar",
          cancelButtonText: "Regresar",
          cancelButtonColor: "Red",
          confirmButtonColor: "#4CD964",
          reverseButtons: true,
        }).then((result) => {
          if (result.isConfirmed) {
            Api.loading(true);
            this.handleChangeStatusConstancia(
              e.target.value,
              solicitud_id,
              result.value
            );
            this.handleCreateConstancia(obj_constancia);
          }
        });
      }
    } else {
      let razon = "";
      Swal.fire({
        title: "Rechazar solicitud",
        icon: "warning",
        html:
          '<textarea id="swal-input1" placeholder="Ingrese razón del rechazo" class="form' +
          '-control" height="30"></textarea>',
        showCancelButton: true,
        confirmButtonText: "Rechazar",
        cancelButtonText: "Regresar",
        cancelButtonColor: "Red",
        confirmButtonColor: "#4CD964",
        reverseButtons: true,
        preConfirm: (r) => {
          razon = document.querySelector("#swal-input1").value;
          if (razon === "") {
            Swal.showValidationMessage(
              "Es obligatorio ingresar una observación"
            );
          }
        },
      }).then((result) => {
        if (result.isConfirmed) {
          Api.loading(true);
          this.handleChangeStatusConstancia(
            e.target.value,
            solicitud_id,
            razon
          );
        }
      });
    }
  }

  handleChangeStatusConstancia(e, id, observacion = "") {
    Api.loading(true);
    Api.fetch(
      "app/updateStatusCons",
      {
        id: id,
        status: e,
        observacion: observacion,
      },
      "PUT"
    ).then((r) => {
      Api.loading(false);
      this.setConstanciasPage(this.state.paginaActual_c);
      this.modalCons.close();

      this.setState({ validez_id: "0", texto_acta: "" });

      let detalle = document.querySelector("#detalleConstancia");
      let validez = detalle.querySelector("#f_validez");
      validez.querySelector("#validez_id").value = "0";
      let selectElement = detalle.querySelector("#texto_acta");
      selectElement.value = this.state.texto_acta;

      Api.notify(r.message);
    });
  }

  handleCreateConstancia(obj) {
    Api.fetch("app/createConstancia", obj, "post").then((r) => {});
  }

  /* inicio certificados */

  modalCer = {};
  handleOpenCertificado(e) {
    Api.loading(true);
    let solid = e.target.getAttribute("data-solicitud-id");
    let certificado_id = e.target.getAttribute("data-certificado-id");

    Api.fetch(
      "app/getInfoCertificado",
      { certificado_id: certificado_id, solicitud_id: solid },
      "POST"
    ).then((e) => {
      this.setState({
        certificado: e.certificado,
        solicitud_cer: e.solicitud,
        working: false,
        openModalCertificado: true,
      });

      Api.loading(false);
    });
  }

  handleOpenMovimiento(e) {
    Api.loading(true);

    let bitacoraMovimientoID = e.target.getAttribute(
      "data-bitacora-movimiento-id"
    );

    Api.fetch(
      "app/getInfoMovimiento?bitacora_movimiento_id=" + bitacoraMovimientoID
    ).then((e) => {
      this.setState({
        movimiento: e.movimiento,
        solicitud_mov: e.solicitud,
        working: false,
        openModalMovimiento: true,
      });

      Api.loading(false);
    });
  }

  handleOpenCasoEspecial(e) {
    Api.loading(true);

    let detalleCasoEspecialId = e.target.id;

    Api.fetch(
      "app/getInfoCasoEspecial?detalle_caso_especial_id=" +
        detalleCasoEspecialId
    ).then((ce) => {
      ce.caso_especial.todosDocsAprobados =
        ce.caso_especial.documentacion.every((d) => d.aprobado === "1");

      this.setState({
        caso_especial: ce.caso_especial,
        solicitud_ce: ce.solicitud,
        working: false,
        openModalCasoEspecial: true,
        importacion: {
          importacion_texto: "",
          fines_texto: "",
        },
      });

      Api.loading(false);
    });
  }

  // Funcion para solicitar la descarga de los documentos del establecimiento
  handleDownloadZipCertificados(e) {
    let docs = "";
    for (let file in this.state.establecimientoDocsCheck) {
      if (this.state.establecimientoDocsCheck[file]) {
        docs += file + ",";
      }
    }
    this.setState({
      previa_url:
        Api.url +
        `app/zipE${this.state.am}/?docs=` +
        docs +
        "&" +
        Math.random(),
    });
  }

  // Funcion para controlar el estado de la solicitud, rechazada o aceptada de establecimiento
  handleCertificadoStatus(e) {
    let statusString = {
      Aceptar: 5,
      Rechazar: 4,
    };

    let status = statusString[e.target.innerText];

    if (status === 5) {
      Swal.fire({
        title: "¿Aceptar solicitud?",
        text: "Ingrese observaciones si existen.",
        input: "textarea",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Regresar",
        cancelButtonColor: "Red",
        confirmButtonColor: "#4CD964",
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.handleChangeStatusCertificado(e.target.value, result.value);
        }
      });
    } else {
      let razon = "";
      Swal.fire({
        title: "Rechazar solicitud",
        icon: "warning",
        html:
          '<textarea id="swal-input1" placeholder="Ingrese razón del rechazo" class="form' +
          '-control" height="30"></textarea>',
        //inputPlaceholder: "Marcar solicitar corrección",
        showCancelButton: true,
        confirmButtonText: "Rechazar",
        cancelButtonText: "Regresar",
        cancelButtonColor: "Red",
        confirmButtonColor: "#4CD964",
        reverseButtons: true,
        preConfirm: (r) => {
          razon = document.querySelector("#swal-input1").value;
          if (razon === "") {
            Swal.showValidationMessage(
              "Es obligatorio ingresar una observación"
            );
          }
        },
      }).then((result) => {
        if (result.isConfirmed) {
          this.handleChangeStatusCertificado(
            e.target.value,
            razon,
            result.value
          );
        }
      });
    }
  }

  //Funcion para postear el status de solicitud establecimiento
  handleChangeStatusCertificado(e, observacion = "", correccion = 0) {
    Api.loading(true);

    let solicitud = { ...this.state.solicitud_cer };
    let certificado = { ...this.state.certificado };

    //tenemos que checar que todas los certificados esten aprobados para poder cambiar el estatus de mi solicitud a aceptada
    //hasta entonces se podran enviar a impresiones
    //si se acepta un certificado y no se ha terminado de aceptar los otros se pondra :
    //EN ESPERA VALIDACION OTRO CERTIFICADO??
    Api.fetch(
      "app/updateStatusCertificado",
      {
        id: solicitud.id,
        status: e,
        observacion: observacion,
        correccion: correccion,
        certificado_id: certificado.id,
      },
      "PUT"
    ).then((r) => {
      Api.loading(false);
      this.setState({ openModalCertificado: false });
      this.setCertificadoPage(this.state.paginaActual_cer);
    });
  }

  /*

    allDocsCer(e) {
      let rChk = [];
      for (let file in this.state.establecimiento.documentos) {
        rChk[this.state.establecimiento.documentos[file].id] = e.target.checked;
      }
      this.setState({
        establecimientoDocsCheck: rChk,
        allEstDocs: e.target.checked,
        allEst: e.target.checked,
      });
    } */

  closeModalCertificado() {
    this.setState({ openModalCertificado: false });
    /*   Swal.fire({
      title: "¿Seguro que quiere cerrar el formulario de certificado de exportación?",
      showCancelButton: true,
      confirmButtonText: "Aceptar",
      cancelButtonText: "Regresar",
      reverseButtons: true,
      }).then((result) => {
      if (result.isConfirmed) {
          this.setState({ openModalCEE: false });
          if(limpiar === 1){
              this.limpiarCampos(2);
          }
      }
      }); */
  }

  closeModalPrecertificado() {
    this.setState({ openModalPrecertificado: false });
  }

  closeModalMovimiento() {
    this.setState({ openModalMovimiento: false });
  }

  closeModalCasoEspecial() {
    this.setState({ openModalCasoEspecial: false });
  }

  /*fin certificados*/
  handleTextActaChange(e) {
    let txt = e.target.value.toUpperCase();
    this.setState({
      texto_acta: txt,
    });
  }

  handleTextAM(e) {
    let txt = e.target.value.toUpperCase();
    this.setState({
      text_AM: txt,
    });
  }

  addProductosConsAM = (e) => {
    let i = e.target.getAttribute("data-index");
    let productos = this.state.cons_productos;

    productos[i].text_am = this.state.text_AM;

    this.setState({
      cons_productos: productos,
    });
  };

  handleOpenModalPrecertificado(e) {
    let solicitud_id = e.target.getAttribute("data-solicitud");
    Api.loading(true);
    Api.fetch(
      "app/getSolicitudPrecertificado?solicitud_id=" + solicitud_id
    ).then((response) => {
      if (response) {
        if (response.tipo_producto_id === "2") {
          //veterinario
          response.tipo_producto = "VETERINARIO";
        } else {
          //nomas existen dos casos Alimento
          response.tipo_producto = "ALIMENTO";
        }

        this.setState({
          solicitud_pre: response,
          registros_docs_pre: response.documentos.length,
          working: false,
          openModalPrecertificado: true,
        });

        this.handleBtnPRE();
        let detalle = document.querySelector("#SolicitudPrecertificado");
        let docAcepta = detalle.querySelectorAll(".documento-pre-rechazar");

        docAcepta.forEach((doc) => {
          doc.addEventListener("click", this.handlesolicitudDocumentoStatusPre);
        });

        let docRechaza = detalle.querySelectorAll(".documento-pre-aceptar");

        docRechaza.forEach((doc) => {
          doc.addEventListener("click", this.handlesolicitudDocumentoStatusPre);
        });

        let docVistaPrevia = detalle.querySelectorAll(".vista-previa");
        docVistaPrevia.forEach((doc) => {
          doc.addEventListener("click", this.handlePreviaPre);
        });

        let docsCheck = [];
        for (let file in response.documentos) {
          docsCheck[response.documentos[file].id] = false;
          this.setState({ solicitudDocsCheck: docsCheck });
        }

        let checkboxs = detalle.querySelectorAll(".checkbox_pre");
        checkboxs.forEach((doc) => {
          doc.addEventListener("change", this.handleSolicitudChecks);
        });

        if (
          this.state.solicitud_pre.estatus_tramite_id === "4" ||
          this.state.solicitud_pre.estatus_tramite_id === "5" ||
          this.state.solicitud_pre.estatus_tramite_id === "10"
        ) {
          detalle.querySelector("#rechazar_pre").classList =
            "btn btn-danger blockea";
          detalle.querySelector("#aprobar_pre").classList =
            "btn btn-success blockea";
        } else {
          detalle
            .querySelector("#rechazar_pre")
            .addEventListener("click", this.handlePrecertificadoStatus);
          detalle
            .querySelector("#aprobar_pre")
            .addEventListener("click", this.handlePrecertificadoStatus);
        }

        Api.loading(false);
      }
    });
  }

  handlesolicitudDocumentoStatusPre(e) {
    e.stopPropagation();
    e.preventDefault();

    let id = e.target.id; //parseInt(id);
    let razonText = "";
    let estatus = 1;
    let solicitud = { ...this.state.solicitud_pre };

    let statusString = {
      Aprobar: 2,
      Rechazar: 3,
    };

    estatus = statusString[e.target.getAttribute("data-name")];

    if (estatus === 3) {
      //Si lo rechazas dime por que...

      Swal.fire({
        title: "Descripción del rechazo",
        input: "textarea",
        inputAttributes: {
          autocapitalize: "off",
        },
        showCancelButton: true,
        confirmButtonText: "Continuar",
        showLoaderOnConfirm: true,
        cancelButtonText: "Regresar",
        cancelButtonColor: "Red",
        confirmButtonColor: "#4CD964",
        reverseButtons: true,
        preConfirm: (razon) => {
          if (razon !== "") {
            razonText = razon;
            return true;
          } else {
            Swal.showValidationMessage("Debe ingresar una razón");
          }
        },
        allowOutsideClick: () => !Swal.isLoading(),
      }).then((result) => {
        //rechazado
        if (result.isConfirmed) {
          Api.loading(true);
          Api.fetch(
            "app/updateStatusDocPRE",
            {
              id: id,
              estatus: 3,
              razon: razonText,
              solicitud_id: solicitud.id,
            },
            "POST"
          ).then((d) => {
            Api.loading(false);
            solicitud.documentos = d;
            this.setState({ solicitud_pre: solicitud });
            this.handleBtnPRE();
          });
        }
      });
    } else if (estatus === 2) {
      //aceptado
      Swal.fire({
        title: "¿Seguro que desea aceptar este documento?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Regresar",
        reverseButtons: true,
        cancelButtonColor: "Red",
        confirmButtonColor: "#4CD964",
      }).then((result) => {
        if (result.isConfirmed) {
          Api.loading(true);
          Api.fetch(
            "app/updateStatusDocPRE",
            {
              id: id,
              estatus: 4,
              razon: "",
              solicitud_id: solicitud.id,
            },
            "POST"
          ).then((d) => {
            Api.loading(false);
            solicitud.documentos = d;
            this.setState({ solicitud_pre: solicitud });
            this.handleBtnPRE();
          });
        }
      });
    }
  }

  handleBtnPRE() {
    let detalle = document.querySelector("#SolicitudPrecertificado");
    //let rechazos = 0;
    let sin_verificar = 0;
    let pcedocs = detalle.querySelectorAll(".pce-doc-status");
    for (let pce in pcedocs) {
      if (typeof pcedocs[pce] === "object") {
        /* if (
          pcedocs[pce].innerText === "Rechazado" //|| pcedocs[pce].innerText === "Sin Verificar"
        ) {
          rechazos++;
        } */

        if (pcedocs[pce].innerText === "Sin Verificar") {
          sin_verificar++;
        }
      }
    }

    if (this.state.solicitud_pre.estatus_tramite_id === "9") {
      detalle.querySelector("#rechazar_pre").classList = "hide";
      detalle.querySelector("#aprobar_pre").classList = "hide";

      //if (rechazos === 0 && sin_verificar <= 0) {
      if (this.state.solicitud_pre.documentos.length === 0) {
        //si no tiene documentos entonces muestrame los dos
        detalle.querySelector("#aprobar_pre").classList = "btn btn-success";
        detalle.querySelector("#rechazar_pre").classList = "btn btn-danger";
      } else if (sin_verificar < 1) {
        detalle.querySelector("#aprobar_pre").classList = "btn btn-success";
      } else {
        detalle.querySelector("#rechazar_pre").classList = "btn btn-danger";
      }

      /*       if (sin_verificar > 0) {
        detalle.querySelector("#rechazar_pre").classList = "btn btn-danger";
      } */
    }
  }

  handlePrecertificadoStatus(e) {
    //validar que el campo de observacion no este vacio
    let statusString = {
      Aceptar: 5,
      Rechazar: 4,
    };

    let status = statusString[e.target.innerText];
    if (status === 5) {
      Swal.fire({
        title: "¿Aceptar solicitud?",
        text: "Ingrese observaciones si existen.",
        input: "textarea",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonColor: "Red",
        confirmButtonColor: "#4CD964",
        cancelButtonText: "Regresar",
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.handleChangeStatusPRE(e.target.value, result.value);
        }
      });
    } else {
      let razon = "";
      Swal.fire({
        title: "Rechazar solicitud",
        icon: "warning",
        html:
          '<textarea id="swal-input1" placeholder="Ingrese razón del rechazo" className="form' +
          '-control" height="30"></textarea>',
        inputPlaceholder: "Marcar solicitar corrección",
        showCancelButton: true,
        confirmButtonText: "Rechazar",
        cancelButtonText: "Regresar",
        cancelButtonColor: "Red",
        confirmButtonColor: "#4CD964",
        reverseButtons: true,
        preConfirm: (r) => {
          razon = document.querySelector("#swal-input1").value;
          if (razon === "") {
            Swal.showValidationMessage(
              "Es obligatorio ingresar una observación"
            );
          }
        },
      }).then((result) => {
        if (result.isConfirmed) {
          this.handleChangeStatusPRE(e.target.value, razon, result.value);
        }
      });
    }
  }

  handleChangeStatusPRE(e, observacion = "") {
    Api.loading(true);
    let solid = this.state.solicitud_pre.sol_id;

    Api.fetch(
      "app/updateStatusPRE",
      {
        id: solid,
        status: e,
        observacion: observacion,
        informacion: this.state.solicitud_pre,
      },
      "PUT"
    ).then((r) => {
      Api.notify(r.message);
      if (e === 2) {
        Api.notify(r.message);
      } else {
        this.setPrecertificadosPage(this.state.paginaActual_pre);
        Api.loading(false);
        this.closeModalPrecertificado();
      }
    });
  }

  allDocsSolPre(e) {
    let rChk = [];
    for (let file in this.state.solicitud_pre.documentos) {
      rChk[this.state.solicitud_pre.documentos[file].id] = e.target.checked;
    }

    this.setState({
      solicitudDocsCheckPre: rChk,
      allSolDocsPre: e.target.checked,
      allDocsPre: e.target.checked,
    });
  }

  handlePreviaPre(e) {
    //let doc = e.target.getAttribute("data-file");
    let id = e.target.getAttribute("data-id");
    let doc = Api.url + `app/vistapreviaPRE/?id=${id}`;
    this.setState({ previa: true, previa_url: doc });
  }

  handlePreviaClosePre() {
    this.setState({ previa: false });
  }

  handleDownloadZipPRE() {
    let docs = "";
    for (let file in this.state.solicitudDocsCheckPre) {
      if (this.state.solicitudDocsCheckPre[file]) {
        docs += file + ",";
      }
    }

    if (docs !== "") {
      this.setState({
        previa_url: Api.url + `app/ZipPRE/?docs=` + docs + "&" + Math.random(),
      });
    }
  }

  handleSolicitudChecksPre(e) {
    let rChk = [];

    rChk = this.state.solicitudDocsCheckPre;
    rChk[e.target.id] = e.target.checked;

    this.setState({ solicitudDocsCheckPre: rChk, allDocsPre: false });
  }

  handleOpenModalAutorizacion(e) {
    let solicitud_id = e.target.getAttribute("data-solicitud");
    Api.loading(true);
    Api.fetch(
      "app/getSolicitudAutorizacionDA?solicitud_id=" + solicitud_id
    ).then((response) => {
      if (response) {
        this.setState({
          solicitud_ada: response,
          working: false,
          openModalAutorizacion: true,
        });

        let detalle = document.querySelector("#SolicitudADA");
        if (
          this.state.solicitud_ada.estatus_tramite_id === "4" ||
          this.state.solicitud_ada.estatus_tramite_id === "5" ||
          this.state.solicitud_ada.estatus_tramite_id === "17"
        ) {
          detalle.querySelector("#rechazar_ada").classList =
            "btn btn-danger blockea";
          detalle.querySelector("#aprobar_ada").classList =
            "btn btn-success blockea";
        } else {
          detalle
            .querySelector("#rechazar_ada")
            .addEventListener("click", this.handleAutorizacionStatus);
          detalle
            .querySelector("#aprobar_ada")
            .addEventListener("click", this.handleAutorizacionStatus);
        }

        if (this.state.solicitud_ada.estatus_tramite_id === "5") {
          detalle
            .querySelector("#desactivar_ada")
            .addEventListener("click", this.handleDesactivarSolicitud);
        }
        Api.loading(false);
      }
    });
  }

  closeModalAutorizacion() {
    this.setState({ openModalAutorizacion: false });
  }

  handleAutorizacionStatus(e) {
    e.stopPropagation();
    e.preventDefault();

    let statusString = {
      Aceptar: 5,
      Rechazar: 4,
    };

    let status = statusString[e.target.innerText];
    if (status === 5) {
      Swal.fire({
        title: "¿Aceptar solicitud?",
        text: "Ingrese observaciones si existen.",
        input: "textarea",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Regresar",
        cancelButtonColor: "Red",
        confirmButtonColor: "#4CD964",
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.handleChangeStatusADA(e.target.value, result.value);
        }
      });
    } else {
      let razon = "";
      Swal.fire({
        title: "Rechazar solicitud",
        icon: "warning",
        html:
          '<textarea id="swal-input1" placeholder="Ingrese razón del rechazo" class="form' +
          '-control" height="30"></textarea>',
        inputPlaceholder: "Marcar solicitar corrección",
        showCancelButton: true,
        confirmButtonText: "Rechazar",
        cancelButtonText: "Regresar",
        cancelButtonColor: "Red",
        confirmButtonColor: "#4CD964",
        reverseButtons: true,
        preConfirm: (r) => {
          razon = document.querySelector("#swal-input1").value;
          if (razon === "") {
            Swal.showValidationMessage(
              "Es obligatorio ingresar una observación"
            );
          }
        },
      }).then((result) => {
        if (result.isConfirmed) {
          this.handleChangeStatusADA(e.target.value, razon, result.value);
        }
      });
    }
  }

  handleChangeStatusADA(e, observacion = "") {
    Api.loading(true);
    let solid = this.state.solicitud_ada.sol_id;

    Api.fetch(
      "app/updateStatusADA",
      {
        id: solid,
        status: e,
        observacion: observacion,
        informacion: this.state.solicitud_ada,
        medico: false,
      },
      "PUT"
    ).then((data) => {
      Api.loading(false);
      Swal.fire({
        icon: "success",
        title: data.message,
        timer: 3000,
      }).then(() => {
        this.closeModalAutorizacion();
        this.setAutorizacionPage(this.state.paginaActual_ada);
      });
    }).catch((error) => {
      error.json().then((message) => {
        Api.loading(false);
        Swal.fire({
          title: "Ocurrió un error",
          icon: "error",
          text: message.message,
        });
        this.setState({ procesando: false });
      }); //catching errors to show notification
    }); 
  }

  handleDesactivarSolicitud(e) {
    let solicitud_id = this.state.solicitud_ada.sol_id;
    let razon = "";

    Swal.fire({
      title: "¿Seguro que desea desactivar la solicitud?",
      icon: "question",
      html:
        '<textarea id="swal-input3" placeholder="Ingrese razón" class="form' +
        '-control" height="30"></textarea>',
      showCancelButton: true,
      confirmButtonText: "Desactivar",
      cancelButtonText: "Regresar",
      reverseButtons: true,
      preConfirm: (r) => {
        razon = document.querySelector("#swal-input3").value;
        if (razon === "") {
          Swal.showValidationMessage("Es obligatorio ingresar una razón");
        }
      },
    }).then((result) => {
      if (result.isConfirmed) {
        this.handleUpdateSolicitudADA(solicitud_id, razon);
      }
    });
  }

  handleUpdateSolicitudADA(solicitud_id, razon) {
    Api.loading(true);
    Api.fetch(
      "app/desactivarSolicitudADA",
      {
        id: solicitud_id,
        observacion: razon,
      },
      "PUT"
    ).then((r) => {
      Api.notify(r.message);
      this.setAutorizacionPage(this.state.paginaActual_ada);
      Api.loading(false);
      this.closeModalAutorizacion();
    });
  }

  render() {
    return (
      <div className="row">
        <div className="col-xl-12">
          <Nav tabs={true}>
            <NavItem>
              <NavLink
                className={classnames({
                  active: this.state.activeTab === "1",
                })}
                onClick={() => {
                  this.toggleTab("1");
                }}
              >
                <span className="d-sm-none">
                  REGENTES
                  <span className="label label-success m-l-5 t-minus-1">
                    {this.state.registros}
                  </span>
                </span>
                <span className="d-sm-block d-none">
                  REGENTES
                  <span className="label label-success m-l-5 t-minus-1">
                    {this.state.registros}
                  </span>
                </span>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({
                  active: this.state.activeTab === "2",
                })}
                onClick={() => {
                  this.toggleTab("2");
                }}
              >
                <span className="d-sm-none">
                  ESTABLECIMIENTOS
                  <span className="label label-success m-l-5 t-minus-1">
                    {this.state.registros_e}
                  </span>
                </span>
                <span className="d-sm-block d-none">
                  ESTABLECIMIENTOS
                  <span className="label label-success m-l-5 t-minus-1">
                    {this.state.registros_e}
                  </span>
                </span>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({
                  active: this.state.activeTab === "3",
                })}
                onClick={() => {
                  this.toggleTab("3");
                }}
              >
                <span className="d-sm-none">
                  PRODUCTOS
                  <span className="label label-success m-l-5 t-minus-1">
                    {this.state.registros_p}
                  </span>
                </span>
                <span className="d-sm-block d-none">
                  PRODUCTOS
                  <span className="label label-success m-l-5 t-minus-1">
                    {this.state.registros_p}
                  </span>
                </span>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({
                  active: this.state.activeTab === "4",
                })}
                onClick={() => {
                  this.toggleTab("4");
                }}
              >
                <span className="d-sm-none">
                  CONSTANCIAS
                  <span className="label label-success m-l-5 t-minus-1">
                    {this.state.registros_c}
                  </span>
                </span>
                <span className="d-sm-block d-none">
                  CONSTANCIAS
                  <span className="label label-success m-l-5 t-minus-1">
                    {this.state.registros_c}
                  </span>
                </span>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({
                  active: this.state.activeTab === "5",
                })}
                onClick={() => {
                  this.toggleTab("5");
                }}
              >
                <span className="d-sm-none">
                  MÉDICO VETERINARIO
                  <span className="label label-success m-l-5 t-minus-1">
                    {this.state.registros_mv}
                  </span>
                </span>
                <span className="d-sm-block d-none">
                  MÉDICO VETERINARIO
                  <span className="label label-success m-l-5 t-minus-1">
                    {this.state.registros_mv}
                  </span>
                </span>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({
                  active: this.state.activeTab === "6",
                })}
                onClick={() => {
                  this.toggleTab("6");
                }}
              >
                <span className="d-sm-none">
                  CERTIFICADOS
                  <span className="label label-success m-l-5 t-minus-1">
                    {this.state.registros_cer}
                  </span>
                </span>
                <span className="d-sm-block d-none">
                  CERTIFICADOS
                  <span className="label label-success m-l-5 t-minus-1">
                    {this.state.registros_cer}
                  </span>
                </span>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({
                  active: this.state.activeTab === "7",
                })}
                onClick={() => {
                  this.toggleTab("7");
                }}
              >
                <span className="d-sm-none">
                  PRECERTIFICADOS
                  <span className="label label-success m-l-5 t-minus-1">
                    {this.state.registros_pre}
                  </span>
                </span>
                <span className="d-sm-block d-none">
                  PRECERTIFICADOS
                  <span className="label label-success m-l-5 t-minus-1">
                    {this.state.registros_pre}
                  </span>
                </span>
              </NavLink>
            </NavItem>
            {/* movimiento productos */}
            <NavItem>
              <NavLink
                className={classnames({
                  active: this.state.activeTab === "8",
                })}
                onClick={() => {
                  this.toggleTab("8");
                }}
              >
                <span className="d-sm-none">
                  MOVIMIENTOS
                  <span className="label label-success m-l-5 t-minus-1">
                    {this.state.registros_m}
                  </span>
                </span>
                <span className="d-sm-block d-none">
                  MOVIMIENTOS
                  <span className="label label-success m-l-5 t-minus-1">
                    {this.state.registros_m}
                  </span>
                </span>
              </NavLink>
            </NavItem>
            {/* autorización */}
            <NavItem>
              <NavLink
                className={classnames({
                  active: this.state.activeTab === "9",
                })}
                onClick={() => {
                  this.toggleTab("9");
                }}
              >
                <span className="d-sm-none">
                  AUTORIZACIÓN DE ADQUISICIÓN
                  <span className="label label-success m-l-5 t-minus-1">
                    {this.state.registros_ada}
                  </span>
                </span>
                <span className="d-sm-block d-none">
                  AUTORIZACIÓN DE ADQUISICIÓN
                  <span className="label label-success m-l-5 t-minus-1">
                    {this.state.registros_ada}
                  </span>
                </span>
              </NavLink>
            </NavItem>
            {/* casos especiales */}
            <NavItem>
              <NavLink
                className={classnames({
                  active: this.state.activeTab === "10",
                })}
                onClick={() => {
                  this.toggleTab("10");
                }}
              >
                <span className="d-sm-none">
                  CASOS ESPECIALES
                  <span className="label label-success m-l-5 t-minus-1">
                    {this.state.registros_ce}
                  </span>
                </span>
                <span className="d-sm-block d-none">
                  CASOS ESPECIALES
                  <span className="label label-success m-l-5 t-minus-1">
                    {this.state.registros_ce}
                  </span>
                </span>
              </NavLink>
            </NavItem>
          </Nav>
          <TabContent activeTab={this.state.activeTab}>
            <TabPane tabId="1">
              <div className="table-responsive">
                <fieldset>
                  <div id="busquedaRegente"></div>
                </fieldset>
                <table className="table table-striped m-b-0 table-hover">
                  <thead>
                    <tr>
                      <th className="text-center">Folios</th>
                      <th className="text-center">Trámite</th>
                      <th className="text-center">Nombre</th>
                      <th className="text-center">Fecha</th>
                      <th className="text-center">Tipo regente</th>
                      <th className="text-center">Fecha verificación</th>
                      <th className="text-center">Estado</th>
                      <th className="text-center">Acción</th>
                    </tr>
                  </thead>
                  <tbody className={this.state.workingGrid ? "hide" : ""}>
                    {this.state.regentes && this.state.regentes.length > 0 ? (
                      this.state.regentes.map((reg) => (
                        <tr
                          key={reg.id}
                          className={
                            reg.dias > 15 && reg.estatus === "En espera"
                              ? "alerta"
                              : ""
                          }
                        >
                          <td className="text-center">{reg.folio}</td>
                          <td className="text-center">{reg.solicitud}</td>
                          <td className="text-center">{reg.nombre}</td>

                          <td className="text-center">
                            {format(
                              new Date(reg.fecha_solicitud),
                              "dd/MM/yyyy"
                            )}
                          </td>
                          <td className="text-center">{reg.tipo}</td>
                          <td align="center">
                            {reg.fecha_aprueba_sinaip !== null
                              ? format(
                                  new Date(reg.fecha_aprueba_sinaip),
                                  "dd/MM/yyyy"
                                )
                              : ""}
                          </td>
                          <td className="text-center">{reg.estatus}</td>

                          <td className="text-center">
                            {reg.estatus !== "En espera de pago" &&
                            reg.estatus !== "En espera de documentación" /* &&
                            reg.solicitud !== "Reposición" */ ? (
                              <button
                                onClick={this.handleOpenRegent}
                                id={"button_reg_" + reg.id}
                                data-regente-id={reg.id}
                                className="btn bg-gradient-blue"
                              >
                                <i
                                  id={"i_reg_" + reg.id}
                                  data-regente-id={reg.id}
                                  className="fas fa-folder-open"
                                ></i>
                              </button>
                            ) : (
                              ""
                            )}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td className="text-center">No hay datos</td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                    )}
                  </tbody>
                </table>
                <div className={this.state.workingGrid ? "m-10" : "hide"}>
                  <div className="progress-bar bg-orange progress-bar-striped progress-bar-animated">
                    CARGANDO INFORMACIÓN
                  </div>
                </div>
                <hr />
                <div className="d-flex align-items-center justify-content-center">
                  <ul className="pagination mb-0">
                    <li className="page-item">
                      <button
                        onClick={() => {
                          this.setRegentesPage(1);
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-double-left"></i>
                      </button>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          if (this.state.paginaActual - 1 > 0) {
                            this.setRegentesPage(this.state.paginaActual - 1);
                          }
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-left"></i>
                      </button>
                    </li>
                    <li className="page-item d-flex align-items-center px-2">
                      <div>
                        Página
                        <strong>
                          {" "}
                          {this.state.paginaActual} de {this.state.paginas}
                        </strong>
                      </div>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          if (
                            this.state.paginas >=
                            this.state.paginaActual + 1
                          ) {
                            this.setRegentesPage(this.state.paginaActual + 1);
                          }
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-right"></i>
                      </button>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          this.setRegentesPage(this.state.paginas);
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-double-right"></i>
                      </button>
                    </li>
                  </ul>
                  <div className="ml-3 mr-1">Página:</div>
                  <div className="width-50 mx-2">
                    <input
                      className="form-control"
                      onChange={this.handleRegentePage}
                      type="number"
                      min="1"
                      max={this.state.paginas}
                      value={this.state.paginaActual}
                    />
                  </div>
                  <div></div>
                </div>
              </div>
            </TabPane>
            <TabPane tabId="2">
              <div className="table-responsive">
                <fieldset>
                  <div id="busquedaEstablecimiento"></div>
                </fieldset>
                <table className="table table-striped m-b-0 table-hover">
                  <thead>
                    <tr>
                      <th className="text-center">Folio</th>
                      <th className="text-center">Trámite</th>
                      <th className="text-center">Fecha</th>
                      <th className="text-center">Razón social</th>
                      <th className="text-center">Tipo establecimiento</th>
                      <th className="text-center">Tipo actividad</th>
                      <th className="text-center">Aprobación SINAIP</th>
                      <th className="text-center">Aprobación asesoría legal</th>
                      <th className="text-center">Estado</th>
                      <th>Acción</th>
                    </tr>
                  </thead>
                  <tbody className={this.state.workingGrid ? "hide" : ""}>
                    {this.state.establecimientos &&
                    this.state.establecimientos.length > 0 ? (
                      this.state.establecimientos.map((est) => (
                        <tr
                          key={est.id}
                          className={
                            est.dias > 15 && est.estatus === "En espera"
                              ? "alerta"
                              : ""
                          }
                        >
                          <td className="text-center">{est.folio_solicitud}</td>
                          <td className="text-center">{est.solicitud}</td>
                          <td className="text-center">
                            {format(
                              new Date(est.fecha_solicitud),
                              "dd/MM/yyyy"
                            )}
                          </td>
                          <td className="text-center">{est.razon_social}</td>
                          <td className="text-center" title={est.tipo}>
                            {est.tipo.substr(0, 100)}...
                          </td>
                          <td className="text-center" title={est.actividad}>
                            {est.actividad.substr(0, 100)}...
                          </td>
                          <td align="center">
                            {est.fecha_aprueba_sinaip !== null
                              ? est.fecha_aprueba_sinaip.split("-")
                              .reverse()
                              .join("-")
                              .replaceAll("-", "/")
                              : ""}
                          </td>
                          <td align="center">
                            {est.fecha_aprueba_asesoria !== null
                              ? (
                                est.fecha_aprueba_asesoria.split("-")
                                    .reverse()
                                    .join("-")
                                    .replaceAll("-", "/")
                                
                                )
                              : ""}
                          </td>
                          <td className="text-center">{est.estatus}</td>
                          <td className="text-center">
                            {est.estatus_tramite_id !== 8 &&
                            est.estatus_tramite_id !== 7 &&
                            est.estatus_tramite_id !== 3 &&
                            est.estatus_tramite_id !== 13 ? (
                              <button
                                onClick={this.handleOpenEstablecimiento}
                                id={"button_est_" + est.id}
                                data-establecimiento_id={est.establecimiento_id}
                                data-folio={est.folio_solicitud}
                                data-solicitud-id={est.id}
                                className="btn bg-gradient-blue"
                              >
                                <i
                                  id={"i_est_" + est.id}
                                  data-establecimiento_id={
                                    est.establecimiento_id
                                  }
                                  data-folio={est.folio_solicitud}
                                  data-solicitud-id={est.id}
                                  className="fas fa-folder-open"
                                ></i>
                              </button>
                            ) : (
                              ""
                            )}
                            {est.estatus_tramite_id === "13" ||
                            est.estatus_tramite_id === "14" ? (
                              <a
                                href={
                                  "/establecimiento/" +
                                  est.campo_valor +
                                  "/" +
                                  est.id
                                }
                              >
                                <button
                                  id={"button_est_am_" + est.id}
                                  data-establecimiento_id={
                                    est.establecimiento_id
                                  }
                                  data-folio={est.folio_solicitud}
                                  data-solicitud-id={est.id}
                                  className="btn bg-gradient-yellow"
                                >
                                  <i
                                    id={"i_est_am_" + est.id}
                                    data-establecimiento_id={
                                      est.establecimiento_id
                                    }
                                    data-folio={est.folio_solicitud}
                                    data-solicitud-id={est.id}
                                    className="fas fa-edit"
                                  ></i>
                                </button>
                              </a>
                            ) : (
                              ""
                            )}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td>No hay datos</td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                    )}
                  </tbody>
                </table>
                <div className={this.state.workingGrid ? "m-10" : "hide"}>
                  <div className="progress-bar bg-orange progress-bar-striped progress-bar-animated">
                    CARGANDO INFORMACIÓN
                  </div>
                </div>
                <hr />
                <div className="d-flex align-items-center justify-content-center">
                  <ul className="pagination mb-0">
                    <li className="page-item">
                      <button
                        onClick={() => {
                          this.setEstablecimientosPage(1);
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-double-left"></i>
                      </button>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          if (this.state.paginaActual_e - 1 > 0) {
                            this.setEstablecimientosPage(
                              this.state.paginaActual_e - 1
                            );
                          }
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-left"></i>
                      </button>
                    </li>
                    <li className="page-item d-flex align-items-center px-2">
                      <div>
                        Página
                        <strong>
                          {" "}
                          {this.state.paginaActual_e} de {this.state.paginas_e}
                        </strong>
                      </div>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          if (
                            this.state.paginas_e >=
                            this.state.paginaActual_e + 1
                          ) {
                            this.setEstablecimientosPage(
                              this.state.paginaActual_e + 1
                            );
                          }
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-right"></i>
                      </button>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          this.setEstablecimientosPage(this.state.paginas_e);
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-double-right"></i>
                      </button>
                    </li>
                  </ul>
                  <div className="ml-3 mr-1">Página:</div>
                  <div className="width-50 mx-2">
                    <input
                      className="form-control"
                      onChange={this.handleEstablecimientoPage}
                      type="number"
                      min="1"
                      max={this.state.paginas_e}
                      value={this.state.paginaActual_e}
                    />
                  </div>
                  <div></div>
                </div>
              </div>
            </TabPane>
            <TabPane tabId="3">
              <div className="table-responsive">
                <fieldset>
                  <div id="busquedaProducto"></div>
                </fieldset>

                <table className="table table-striped m-b-0 table-hover">
                  <thead>
                    <tr>
                      <th className="text-center">Folio</th>
                      <th className="text-center">Trámite</th>
                      <th className="text-center">Fecha</th>
                      <th className="text-center">Nombre comercial</th>
                      <th className="text-center">Tipo producto</th>
                      <th className="text-center">Aprueba SINAIP</th>
                      <th className="text-center">Aprueba asesoría legal</th>
                      <th className="text-center">Estado</th>
                      <th className="text-center">Acción</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.productos.length > 0
                    ? (
                      this.state.productos.map((pro, index) => (
                        <tr key={index}>
                          <td className="text-center">{pro.folio_solicitud}</td>
                          <td className="text-center">{pro.solicitud}</td>
                          <td className="text-center">
                            {format(
                              new Date(pro.fecha_solicitud),
                              "dd/MM/yyyy"
                            )}
                          </td>
                          <td
                            title={pro.nombre_comercial}
                            className="text-center"
                          >
                            {String(pro.nombre_comercial).slice(0, 100)}
                          </td>
                          <td title={pro.tipo_producto} className="text-center">
                            {pro.tipo_producto.slice(0, 200)}
                          </td>
                          <td>
                            {pro.fecha_aprueba_sinaip !== null
                              ? pro.fecha_aprueba_sinaip
                                  .split("-")
                                  .reverse()
                                  .join("-")
                                  .replaceAll("-", "/")
                              : ""}
                          </td>
                          <td>
                            {pro.fecha_aprueba_asesoria !== null
                              ? pro.fecha_aprueba_asesoria
                                  .split("-")
                                  .reverse()
                                  .join("-")
                                  .replaceAll("-", "/")
                              : ""}
                          </td>
                          <td className="text-center">{pro.descripcion}</td>

                          <td className="text-center">
                            {pro.estatus_tramite_id !== 3 &&
                            pro.estatus_tramite_id !== 7 &&
                            pro.tramite_id !== "11" &&
                            pro.estatus_tramite_id !== 13 ? (
                              <button
                                onClick={this.handleOpenProductos}
                                id={"button_pro_" + pro.detalle_solicitud_id}
                                data-solicitud-id={pro.solicitud_id}
                                data-producto_id={pro.producto_id}
                                data-folio={pro.folio_solicitud}
                                data-tipo={pro.tipo_producto}
                                className="btn bg-gradient-blue"
                              >
                                <i
                                  id={"i_pro_" + pro.detalle_solicitud_id}
                                  data-solicitud-id={pro.solicitud_id}
                                  data-producto_id={pro.producto_id}
                                  data-folio={pro.folio_solicitud}
                                  data-tipo={pro.tipo_producto}
                                  className="fas fa-folder-open"
                                ></i>
                              </button>
                            ) : pro.tramite_id === "11" ? (
                              <button
                                onClick={this.handleOpenProductosRefrenda}
                                id={
                                  "button_pro_ref_" +
                                  pro.solicitud_de_refrenda_id
                                }
                                data-solicitud-id={pro.solicitud_de_refrenda_id}
                                data-solicitud-tramite={pro.tramite_id}
                                data-folio={pro.folio_solicitud}
                                className="btn bg-gradient-blue"
                              >
                                <i
                                  id={
                                    "i_pro_ref" + pro.solicitud_de_refrenda_id
                                  }
                                  data-solicitud-id={
                                    pro.solicitud_de_refrenda_id
                                  }
                                  data-solicitud-tramite={pro.tramite_id}
                                  data-folio={pro.folio_solicitud}
                                  className="fas fa-folder-open"
                                ></i>
                              </button>
                            ) : null}

                            {pro.estatus_tramite_id === "11" ? (
                              <button
                                onClick={this.handleClasificacionProd}
                                id={"button_clas_" + pro.id}
                                data-folio={pro.folio_solicitud}
                                data-solicitud-id={pro.solicitud_id}
                                data-rset={JSON.stringify(pro)}
                                className="btn bg-gradient-orange"
                              >
                                <i
                                  id={"i_clas_" + pro.id}
                                  data-solicitud-id={pro.solicitud_id}
                                  data-producto_id={pro.producto_id}
                                  data-folio={pro.folio_solicitud}
                                  data-rset={JSON.stringify(pro)}
                                  className="fas fa-list"
                                ></i>
                              </button>
                            ) : null}
                            {pro.estatus_tramite_id === "13" ? (
                              <button
                                onClick={this.handleEditarProducto}
                                id={"button_editar_pro_" + pro.solicitud_id}
                                data-folio={pro.folio_solicitud}
                                data-solicitud-id={pro.solicitud_id}
                                data-rset={JSON.stringify(pro)}
                                className="btn bg-gradient-yellow"
                              >
                                <i
                                  id={"i_editar_pro_" + pro.solicitud_id}
                                  data-solicitud-id={pro.solicitud_id}
                                  data-producto_id={pro.producto_id}
                                  data-folio={pro.folio_solicitud}
                                  data-rset={JSON.stringify(pro)}
                                  className="fas fa-edit"
                                ></i>
                              </button>
                            ) : null}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td>No hay datos</td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                    )}
                  </tbody>
                </table>
                <div className={this.state.workingGrid ? "m-10" : "hide"}>
                  <div className="progress-bar bg-orange progress-bar-striped progress-bar-animated">
                    CARGANDO INFORMACIÓN
                  </div>
                </div>
                <hr />
                <div className="d-flex align-items-center justify-content-center">
                  <ul className="pagination mb-0">
                    <li className="page-item">
                      <button
                        onClick={() => {
                          this.setProductosPage(1);
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-double-left"></i>
                      </button>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          if (this.state.paginaActual_p - 1 > 0) {
                            this.setProductosPage(
                              this.state.paginaActual_p - 1
                            );
                          }
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-left"></i>
                      </button>
                    </li>
                    <li className="page-item d-flex align-items-center px-2">
                      <div>
                        Página
                        <strong>
                          {" "}
                          {this.state.paginaActual_p} de {this.state.paginas_p}
                        </strong>
                      </div>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          if (
                            this.state.paginas_p >=
                            this.state.paginaActual_p + 1
                          ) {
                            this.setProductosPage(
                              this.state.paginaActual_p + 1
                            );
                          }
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-right"></i>
                      </button>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          this.setProductosPage(this.state.paginas_p);
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-double-right"></i>
                      </button>
                    </li>
                  </ul>
                  <div className="ml-3 mr-1">Ver Página:</div>
                  <div className="width-50 mx-2">
                    <input
                      className="form-control"
                      onChange={this.setProductosPage}
                      type="number"
                      min="1"
                      max={this.state.paginas_p}
                      value={this.state.paginaActual_p}
                    />
                  </div>
                  <div></div>
                </div>
              </div>
            </TabPane>
            <TabPane tabId="4">
              <div className="table-responsive">
                <fieldset>
                  <div id="busquedaConstancia"></div>
                </fieldset>
                <table className="table table-striped m-b-0 table-hover">
                  <thead>
                    <tr>
                      <th className="text-center">Folio</th>
                      <th className="text-center">Fecha</th>
                      <th className="text-center">Tipo constancia</th>
                      <th className="text-center">Nombre</th>
                      <th className="text-center">Estado</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.constancias.length > 0 ? (
                      this.state.constancias.map((cons, index) => (
                        <tr key={index}>
                          <td className="text-center">
                            {cons.folio_solicitud}
                          </td>
                          <td className="text-center">
                            {format(
                              new Date(cons.fecha_solicitud),
                              "dd/MM/yyyy"
                            )}
                          </td>
                          <td className="text-center">
                            {cons.tipo_constancia}
                          </td>
                          <td className="text-center">{cons.usuario_solicita}</td>
                          <td className="text-center">{cons.estatus}</td>
                          <td className="text-center">
                            {cons.estatus_tramite_id !== 1 ? (
                              <button
                                id={"button_cons_" + cons.id}
                                onClick={this.handleOpenConstancias}
                                data-folio={cons.folio_solicitud}
                                data-tipo={cons.constancia_tipo_id}
                                data-solicitud-id={cons.id}
                                className="btn bg-gradient-blue"
                              >
                                <i
                                  id={"i_cons_" + cons.id}
                                  data-folio={cons.folio_solicitud}
                                  data-tipo={cons.constancia_tipo_id}
                                  data-solicitud-id={cons.id}
                                  className="fas fa-folder-open"
                                ></i>
                              </button>
                            ) : null}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td className="text-center">No hay datos</td>
                        <td></td>
                        <td></td>
                      </tr>
                    )}
                  </tbody>
                </table>
                <div className={this.state.workingGrid ? "m-10" : "hide"}>
                  <div className="progress-bar bg-orange progress-bar-striped progress-bar-animated">
                    CARGANDO INFORMACIÓN
                  </div>
                </div>
                <hr />
                <div className="d-flex align-items-center justify-content-center">
                  <ul className="pagination mb-0">
                    <li className="page-item">
                      <button
                        onClick={() => {
                          this.setConstanciasPage(1);
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-double-left"></i>
                      </button>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          if (this.state.paginaActual_c - 1 > 0) {
                            this.setConstanciasPage(
                              this.state.paginaActual_c - 1
                            );
                          }
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-left"></i>
                      </button>
                    </li>
                    <li className="page-item d-flex align-items-center px-2">
                      <div>
                        Página
                        <strong>
                          {" "}
                          {this.state.paginaActual_c} de {this.state.paginas_c}
                        </strong>
                      </div>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          if (
                            this.state.paginas_c >=
                            this.state.paginaActual_c + 1
                          ) {
                            this.setConstanciasPage(
                              this.state.paginaActual_c + 1
                            );
                          }
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-right"></i>
                      </button>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          this.setConstanciasPage(this.state.paginas_c);
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-double-right"></i>
                      </button>
                    </li>
                  </ul>
                  <div className="ml-3 mr-1">Ver Página:</div>
                  <div className="width-50 mx-2">
                    <input
                      className="form-control"
                      onChange={this.setConstanciasPage}
                      type="number"
                      min="1"
                      max={this.state.paginas_c}
                      value={this.state.paginaActual_c}
                    />
                  </div>
                  <div></div>
                </div>
              </div>
            </TabPane>
            <TabPane tabId="5">
              <div className="table-responsive">
                <fieldset>
                  <div id="busquedaMedicoV"></div>
                </fieldset>
                <table className="table table-striped m-b-0 table-hover">
                  <thead>
                    <tr>
                      <th className="text-center">Folio</th>
                      <th className="text-center">Trámite</th>
                      <th className="text-center">Fecha</th>
                      <th className="text-center">Nombre</th>
                      <th className="text-center">Fecha verificación</th>
                      <th className="text-center">Estado</th>
                      <th className="text-center">Acción</th>
                    </tr>
                  </thead>
                  <tbody className={this.state.workingGrid ? "hide" : ""}>
                    {this.state.medicos_veterinarios.length > 0 ? (
                      this.state.medicos_veterinarios.map((mv) => (
                        <tr
                          key={mv.id}
                          className={
                            mv.dias > 15 && mv.estatus === "En espera"
                              ? "alerta"
                              : ""
                          }
                        >
                          <td className="text-center">{mv.folio_solicitud}</td>
                          <td className="text-center">{mv.accion}</td>

                          <td className="text-center">
                            {format(new Date(mv.fecha_solicitud), "dd/MM/yyyy")}
                          </td>
                          <td className="text-center">{mv.nombre_medico}</td>

                          <td align="center">
                            {mv.fecha_aprueba_sinaip !== null
                              ? mv.fecha_aprueba_sinaip
                                  .split("-")
                                  .reverse()
                                  .join("-")
                                  .replaceAll("-", "/")
                              : ""}
                          </td>
                          <td className="text-center">{mv.estatus}</td>

                          <td className="text-center">
                            {mv.estatus_tramite_id === "1" ||
                            mv.estatus_tramite_id === "5" ||
                            mv.estatus_tramite_id === "6" ? (
                              <button
                                onClick={this.handleOpenMedicoVeterinario}
                                id={"button_mv_" + mv.id}
                                data-medico_veterinario_id={
                                  mv.medico_veterinario_id
                                }
                                data-folio={mv.folio_solicitud}
                                data-solicitud-id={mv.id}
                                className="btn bg-gradient-blue"
                              >
                                <i
                                  id={"i_mv_" + mv.id}
                                  data-medico_veterinario_id={
                                    mv.medico_veterinario_id
                                  }
                                  data-folio={mv.folio_solicitud}
                                  data-solicitud-id={mv.id}
                                  className="fas fa-folder-open"
                                ></i>
                              </button>
                            ) : (
                              ""
                            )}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td>No hay datos</td>
                        <td></td>
                        <td></td>
                      </tr>
                    )}
                  </tbody>
                </table>
                <div className={this.state.workingGrid ? "m-10" : "hide"}>
                  <div className="progress-bar bg-orange progress-bar-striped progress-bar-animated">
                    CARGANDO INFORMACIÓN
                  </div>
                </div>
                <hr />
                <div className="d-flex align-items-center justify-content-center">
                  <ul className="pagination mb-0">
                    <li className="page-item">
                      <button
                        onClick={() => {
                          this.setMedicoVeterinarioPage(1);
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-double-left"></i>
                      </button>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          if (this.state.paginaActual_mv - 1 > 0) {
                            this.setMedicoVeterinarioPage(
                              this.state.paginaActual_mv - 1
                            );
                          }
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-left"></i>
                      </button>
                    </li>
                    <li className="page-item d-flex align-items-center px-2">
                      <div>
                        Página
                        <strong>
                          {" "}
                          {this.state.paginaActual_mv} de{" "}
                          {this.state.paginas_mv}
                        </strong>
                      </div>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          if (
                            this.state.paginas_mv >=
                            this.state.paginaActual_mv + 1
                          ) {
                            this.setMedicoVeterinarioPage(
                              this.state.paginaActual_mv + 1
                            );
                          }
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-right"></i>
                      </button>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          this.setMedicoVeterinarioPage(this.state.paginas_mv);
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-double-right"></i>
                      </button>
                    </li>
                  </ul>
                  <div className="ml-3 mr-1">Página:</div>
                  <div className="width-50 mx-2">
                    <input
                      className="form-control"
                      onChange={this.handleMedicoVeterinarioPage}
                      type="number"
                      min="1"
                      max={this.state.paginas_mv}
                      value={this.state.paginaActual_mv}
                    />
                  </div>
                  <div></div>
                </div>
              </div>
            </TabPane>
            <TabPane tabId="6">
              <div className="table-responsive">
                <fieldset>
                  <div id="busquedaCertificados"></div>
                </fieldset>
                <table className="table table-striped m-b-0 table-hover">
                  <thead>
                    <tr>
                      <th className="text-center">Folio Certificado</th>
                      <th className="text-center">Folio Solicitud</th>
                      <th className="text-center">Trámite</th>
                      <th className="text-center">Fecha</th>
                      <th className="text-center">Tipo certificado</th>
                      <th className="text-center">Fecha verificación</th>
                      <th className="text-center">Estado certificado</th>
                      <th className="text-center">Estado solicitud</th>
                      <th className="text-center">Acción</th>
                    </tr>
                  </thead>
                  <tbody className={this.state.workingGrid ? "hide" : ""}>
                    {this.state.certificados.length > 0 ? (
                      this.state.certificados.map((cer, index) => (
                        <tr
                          key={index}
                          className={
                            cer.dias > 15 && cer.estatus === "En espera"
                              ? "alerta"
                              : ""
                          }
                        >
                          <td className="text-center">
                            {cer.folio_certificado}
                          </td>
                          <td className="text-center">{cer.folio_solicitud}</td>

                          <td className="text-center">{cer.accion}</td>

                          <td className="text-center">
                            {format(
                              new Date(cer.fecha_solicitud),
                              "dd/MM/yyyy"
                            )}
                          </td>
                          <td className="text-center">
                            {cer.tipo_certificado}
                          </td>

                          <td align="center">
                            {cer.fecha_aprueba_sinaip !== null
                              ? cer.fecha_aprueba_sinaip
                                  .split("-")
                                  .reverse()
                                  .join("-")
                                  .replaceAll("-", "/")
                              : ""}
                          </td>
                          <td className="text-center">
                            {cer.estatus_certificado}
                          </td>
                          <td className="text-center">{cer.estatus}</td>

                          <td className="text-center">
                            {cer.estatus_tramite_id === "2" ||
                            cer.estatus_tramite_id === "9" ||
                            cer.estatus_tramite_id === "5" ||
                            cer.estatus_tramite_id === "4" ? (
                              <button
                                onClick={this.handleOpenCertificado}
                                id={"button_cer_" + cer.certificado_id}
                                data-certificado-id={cer.certificado_id}
                                data-solicitud-id={cer.solicitud_id}
                                data-folio={cer.folio_certificado}
                                className="btn bg-gradient-blue"
                              >
                                <i
                                  id={"i_cer_" + cer.certificado_id}
                                  data-certificado-id={cer.certificado_id}
                                  data-solicitud-id={cer.solicitud_id}
                                  data-folio={cer.folio_certificado}
                                  className="fas fa-folder-open"
                                ></i>
                              </button>
                            ) : (
                              ""
                            )}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td>No hay datos</td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                    )}
                  </tbody>
                </table>
                <div className={this.state.workingGrid ? "m-10" : "hide"}>
                  <div className="progress-bar bg-orange progress-bar-striped progress-bar-animated">
                    CARGANDO INFORMACIÓN
                  </div>
                </div>
                <hr />
                <div className="d-flex align-items-center justify-content-center">
                  <ul className="pagination mb-0">
                    <li className="page-item">
                      <button
                        onClick={() => {
                          this.setCertificadoPage(1);
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-double-left"></i>
                      </button>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          if (this.state.paginaActual_cer - 1 > 0) {
                            this.setCertificadoPage(
                              this.state.paginaActual_cer - 1
                            );
                          }
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-left"></i>
                      </button>
                    </li>
                    <li className="page-item d-flex align-items-center px-2">
                      <div>
                        Página
                        <strong>
                          {" "}
                          {this.state.paginaActual_cer} de{" "}
                          {this.state.paginas_cer}
                        </strong>
                      </div>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          if (
                            this.state.paginas_cer >=
                            this.state.paginaActual_cer + 1
                          ) {
                            this.setCertificadoPage(
                              this.state.paginaActual_cer + 1
                            );
                          }
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-right"></i>
                      </button>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          this.setCertificadoPage(this.state.paginas_cer);
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-double-right"></i>
                      </button>
                    </li>
                  </ul>
                  <div className="ml-3 mr-1">Página:</div>
                  <div className="width-50 mx-2">
                    <input
                      className="form-control"
                      onChange={this.handleCertificadoPage}
                      type="number"
                      min="1"
                      max={this.state.paginas_cer}
                      value={this.state.paginaActual_cer}
                    />
                  </div>
                  <div></div>
                </div>
              </div>
            </TabPane>
            <TabPane tabId="7">
              <fieldset>
                <div id="f_busqueda_pre"></div>
              </fieldset>
              <div className="table-responsive">
                <table className="table table-striped m-b-0 table-hover">
                  <thead>
                    <tr>
                      <th className="text-center">Folio precertificado</th>
                      <th className="text-center">Folio solicitud</th>
                      <th className="text-center">Solicitud</th>
                      <th className="text-center">Fecha</th>
                      <th className="text-center">Tipo precertificado</th>
                      <th className="text-center">Estatus</th>
                      <th className="text-center"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.precertificados.map((pre, index) => (
                      <tr key={index}>
                        <td className="text-center">{pre.folio}</td>
                        <td className="text-center">{pre.folio_solicitud}</td>
                        <td className="text-center">{pre.tramite}</td>
                        <td className="text-center">
                          {format(new Date(pre.fecha_solicitud), "dd/MM/yyyy")}
                        </td>
                        <td className="text-center">
                          {pre.tipo_precertificado}
                        </td>
                        <td className="text-center">{pre.estatus}</td>
                        <td className="text-center">
                          <button
                            onClick={this.handleOpenModalPrecertificado}
                            id={pre.id}
                            data-pro={pre.id}
                            data-solicitud={pre.solicitud_id}
                            className="btn btn-info"
                          >
                            <i
                              className="fas fa-folder-open"
                              id={pre.id}
                              data-solicitud={pre.solicitud_id}
                            ></i>
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div className={this.state.workingGrid ? "m-10" : "hide"}>
                  <div className="progress-bar bg-orange progress-bar-striped progress-bar-animated">
                    CARGANDO INFORMACIÓN
                  </div>
                </div>
                <hr />
                <div className="d-flex align-items-center justify-content-center">
                  <ul className="pagination mb-0">
                    <li className="page-item">
                      <button
                        onClick={() => {
                          this.setPrecertificadosPage(1);
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-double-left"></i>
                      </button>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          if (this.state.paginaActual_pre - 1 > 0) {
                            this.setPrecertificadosPage(
                              this.state.paginaActual_pre - 1
                            );
                          }
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-left"></i>
                      </button>
                    </li>
                    <li className="page-item d-flex align-items-center px-2">
                      <div>
                        Página
                        <strong>
                          {" "}
                          {this.state.paginaActual_pre} de{" "}
                          {this.state.paginas_pre}
                        </strong>
                      </div>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          if (
                            this.state.paginas_pre >=
                            this.state.paginaActual_pre + 1
                          ) {
                            this.setPrecertificadosPage(
                              this.state.paginaActual_pre + 1
                            );
                          }
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-right"></i>
                      </button>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          this.setPrecertificadosPage(this.state.paginas_pre);
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-double-right"></i>
                      </button>
                    </li>
                  </ul>
                  <div className="ml-3 mr-1">Ver Página:</div>
                  <div className="width-50 mx-2">
                    <input
                      className="form-control"
                      onChange={this.setPrecertificadosPage}
                      type="number"
                      min="1"
                      max={this.state.paginas_pre}
                      value={this.state.paginaActual_pre}
                    />
                  </div>
                </div>
              </div>
            </TabPane>

            <TabPane tabId="8">
              <div className="table-responsive">
                <fieldset>
                  <div id="buscadorMP"></div>
                </fieldset>
                <table className="table table-striped m-b-0 table-hover">
                  <thead>
                    <tr>
                      <th className="text-center">Folio Solicitud</th>
                      <th className="text-center">Establecimiento envía</th>
                      <th className="text-center">Establecimiento recibe</th>
                      <th className="text-center">Producto</th>
                      <th className="text-center">Número de registro</th>
                      <th className="text-center">Estado solicitud</th>
                      <th className="text-center">Fecha</th>
                      <th className="text-center">Acción</th>
                    </tr>
                  </thead>
                  <tbody className={this.state.workingGridMP ? "hide" : ""}>
                    {this.state.movimientos.length > 0 ? (
                      this.state.movimientos.map((mov, index) => (
                        <tr
                          key={index}
                          className={
                            mov.dias > 15 && mov.estatus === "En espera"
                              ? "alerta"
                              : ""
                          }
                        >
                          <td className="text-center">{mov.folio_solicitud}</td>

                          <td className="text-center">
                            {mov.establecimiento_envia_nombre}
                          </td>

                          <td align="center">
                            {mov.establecimiento_recibe_nombre}
                          </td>
                          <td align="center">{mov.nombre_comercial}</td>
                          <td align="center">{mov.no_registro_drycip}</td>
                          <td className="text-center">{mov.estatus}</td>
                          <td className="text-center">
                            {format(
                              new Date(mov.fecha_solicitud),
                              "dd/MM/yyyy"
                            )}
                          </td>

                          <td className="text-center">
                            {["9", "5", "4"].includes(
                              mov.estatus_tramite_id
                            ) ? (
                              <button
                                onClick={this.handleOpenMovimiento}
                                id={mov.bitacora_movimiento_id}
                                data-bitacora-movimiento-id={
                                  mov.bitacora_movimiento_id
                                }
                                className="btn bg-gradient-blue"
                              >
                                <i
                                  id={mov.bitacora_movimiento_id}
                                  className="fas fa-folder-open"
                                  data-bitacora-movimiento-id={
                                    mov.bitacora_movimiento_id
                                  }
                                ></i>
                              </button>
                            ) : (
                              "N/A"
                            )}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr key="1">
                        <td className="text-center" colSpan="9">
                          No hay datos
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
                <div className={this.state.workingGridMP ? "m-10" : "hide"}>
                  <div className="progress-bar bg-orange progress-bar-striped progress-bar-animated">
                    CARGANDO INFORMACIÓN
                  </div>
                </div>
                <hr />
                <div className="d-flex align-items-center justify-content-center">
                  <ul className="pagination mb-0">
                    <li className="page-item">
                      <button
                        onClick={() => {
                          this.setMovimientoProductosPage(1);
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-double-left"></i>
                      </button>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          if (this.state.paginaActual_m - 1 > 0) {
                            this.setMovimientoProductosPage(
                              this.state.paginaActual_m - 1
                            );
                          }
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-left"></i>
                      </button>
                    </li>
                    <li className="page-item d-flex align-items-center px-2">
                      <div>
                        Página
                        <strong>
                          {" "}
                          {this.state.paginaActual_m} de {this.state.paginas_m}
                        </strong>
                      </div>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          if (
                            this.state.paginas_m >=
                            this.state.paginaActual_m + 1
                          ) {
                            this.setMovimientoProductosPage(
                              this.state.paginaActual_m + 1
                            );
                          }
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-right"></i>
                      </button>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          this.setMovimientoProductosPage(this.state.paginas_m);
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-double-right"></i>
                      </button>
                    </li>
                  </ul>
                  <div className="ml-3 mr-1">Página:</div>
                  <div className="width-50 mx-2">
                    <input
                      className="form-control"
                      onChange={this.handleMovimientoProductosPage}
                      type="number"
                      min="1"
                      max={this.state.paginas_m}
                      value={this.state.paginaActual_m}
                    />
                  </div>
                  <div></div>
                </div>
              </div>
            </TabPane>
            <TabPane tabId="9">
              <div className="table-responsive">
                <fieldset>
                  <div id="busquedaAutorizacion"></div>
                </fieldset>
                <table className="table table-striped m-b-0 table-hover">
                  <thead>
                    <tr>
                      <th className="text-center">Folio</th>
                      <th className="text-center">Establecimiento</th>
                      <th className="text-center">Fecha</th>
                      <th className="text-center">Estatus</th>
                      <th className="text-center"></th>
                    </tr>
                  </thead>
                  <tbody className={this.state.workingGrid ? "hide" : ""}>
                    {this.state.autorizacion.length > 0 ? (
                      this.state.autorizacion.map((ada, index) => (
                        <tr key={index}>
                          <td className="text-center">{ada.folio_solicitud}</td>
                          <td className="text-center">{ada.razon_social}</td>

                          <td className="text-center">
                            {format(
                              new Date(ada.fecha_solicitud),
                              "dd/MM/yyyy"
                            )}
                          </td>
                          <td className="text-center">{ada.estatus}</td>

                          <td className="text-center">
                            {ada.estatus_id !== "8" &&
                            ada.estatus_id !== "7" ? (
                              <button
                                onClick={this.handleOpenModalAutorizacion}
                                id={"button_ada_" + ada.id}
                                data-solicitud={ada.sol_id}
                                className="btn bg-gradient-blue"
                              >
                                <i
                                  id={"i_ada_" + ada.id}
                                  data-solicitud={ada.sol_id}
                                  className="fas fa-folder-open"
                                ></i>
                              </button>
                            ) : (
                              ""
                            )}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td></td>
                        <td></td>
                        <td className="text-center">No hay datos</td>
                        <td></td>
                        <td></td>
                      </tr>
                    )}
                  </tbody>
                </table>
                <div className={this.state.workingGrid ? "m-10" : "hide"}>
                  <div className="progress-bar bg-orange progress-bar-striped progress-bar-animated">
                    CARGANDO INFORMACIÓN
                  </div>
                </div>
                <hr />
                <div className="d-flex align-items-center justify-content-center">
                  <ul className="pagination mb-0">
                    <li className="page-item">
                      <button
                        onClick={() => {
                          this.setAutorizacionPage(1);
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-double-left"></i>
                      </button>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          if (this.state.paginaActual_ada - 1 > 0) {
                            this.setAutorizacionPage(
                              this.state.paginaActual_ada - 1
                            );
                          }
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-left"></i>
                      </button>
                    </li>
                    <li className="page-item d-flex align-items-center px-2">
                      <div>
                        Página
                        <strong>
                          {" "}
                          {this.state.paginaActual_ada} de{" "}
                          {this.state.paginas_ada}
                        </strong>
                      </div>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          if (
                            this.state.paginas_ada >=
                            this.state.paginaActual_ada + 1
                          ) {
                            this.setAutorizacionPage(
                              this.state.paginaActual_ada + 1
                            );
                          }
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-right"></i>
                      </button>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          this.setAutorizacionPage(this.state.paginas_ada);
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-double-right"></i>
                      </button>
                    </li>
                  </ul>
                  <div className="ml-3 mr-1">Página:</div>
                  <div className="width-50 mx-2">
                    <input
                      className="form-control"
                      onChange={this.setAutorizacionPage}
                      type="number"
                      min="1"
                      max={this.state.paginas_ada}
                      value={this.state.paginaActual_ada}
                    />
                  </div>
                  <div></div>
                </div>
              </div>
            </TabPane>
            <TabPane tabId="10">
              <div className="table-responsive">
                <fieldset>
                  <div id="buscadorCE"></div>
                </fieldset>
                <table className="table table-striped m-b-0 table-hover">
                  <thead>
                    <tr>
                      <th className="text-center">Folio solicitud</th>
                      <th className="text-center">Fecha solicitud</th>
                      <th className="text-center">Tipo importación</th>
                      <th className="text-center">
                        Establecimiento importador
                      </th>
                      <th className="text-center">
                        Establecimiento fabricante
                      </th>
                      <th className="text-center">Estado</th>
                      <th className="text-center">Fecha verificación</th>
                      <th className="text-center">Acción</th>
                    </tr>
                  </thead>
                  <tbody className={this.state.workingGridCE ? "hide" : ""}>
                    {this.state.casos_especiales.length > 0 ? (
                      this.state.casos_especiales.map((ce, index) => (
                        <tr
                          key={index}
                          // className={
                          //   ce.dias > 15 && ce.estatus === "En espera"
                          //     ? "alerta"
                          //     : ""
                          // }
                        >
                          <td className="text-center">{ce.folio_solicitud}</td>

                          <td className="text-center">
                            {ce.fecha_solicitud_fmt}
                          </td>

                          <td align="center">{ce.tipo_importacion_nombre}</td>
                          <td align="center">{ce.importador_razon_social}</td>
                          <td align="center">{ce.fabricante_razon_social}</td>
                          <td className="text-center">{ce.estado_tramite}</td>
                          <td className="text-center">
                            {ce.fecha_aprueba_sinaip_fmt}
                          </td>

                          <td className="text-center">
                            {["4", "5", "9", "18"].includes(
                              ce.estatus_tramite_id
                            ) ? (
                              <button
                                onClick={this.handleOpenCasoEspecial}
                                id={ce.detalle_casos_especiales_id}
                                className="btn bg-gradient-blue"
                              >
                                <i
                                  id={ce.detalle_casos_especiales_id}
                                  className="fas fa-folder-open"
                                ></i>
                              </button>
                            ) : null}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr key="1">
                        <td className="text-center" colSpan="9">
                          No hay datos
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
                <div className={this.state.workingGridCE ? "m-10" : "hide"}>
                  <div className="progress-bar bg-orange progress-bar-striped progress-bar-animated">
                    CARGANDO INFORMACIÓN
                  </div>
                </div>
                <hr />
                <div className="d-flex align-items-center justify-content-center">
                  <ul className="pagination mb-0">
                    <li className="page-item">
                      <button
                        onClick={() => {
                          this.setCasosEspecialesPage(1);
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-double-left"></i>
                      </button>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          if (this.state.paginaActual_ce - 1 > 0) {
                            this.setCasosEspecialesPage(
                              this.state.paginaActual_ce - 1
                            );
                          }
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-left"></i>
                      </button>
                    </li>
                    <li className="page-item d-flex align-items-center px-2">
                      <div>
                        Página
                        <strong>
                          {" "}
                          {this.state.paginaActual_ce} de{" "}
                          {this.state.paginas_ce}
                        </strong>
                      </div>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          if (
                            this.state.paginas_ce >=
                            this.state.paginaActual_ce + 1
                          ) {
                            this.setCasosEspecialesPage(
                              this.state.paginaActual_ce + 1
                            );
                          }
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-right"></i>
                      </button>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          this.setCasosEspecialesPage(this.state.paginas_ce);
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-double-right"></i>
                      </button>
                    </li>
                  </ul>
                  <div className="ml-3 mr-1">Página:</div>
                  <div className="width-50 mx-2">
                    <input
                      className="form-control"
                      onChange={this.handleCasosEspecialesPage}
                      type="number"
                      min="1"
                      max={this.state.paginas_ce}
                      value={this.state.paginaActual_ce}
                    />
                  </div>
                  <div></div>
                </div>
              </div>
            </TabPane>
          </TabContent>
        </div>
        <Modal isOpen={this.state.modalRegente} modalClassName="modal-message">
          <ModalHeader toggle={() => this.setState({ modalRegente: false })}>
            Folio de solicitud: {this.state.regente.folio_solicitud}
          </ModalHeader>
          <ModalBody>
            <div className={this.state.working ? "" : "hide"}>
              <div className="progress-bar bg-orange progress-bar-striped progress-bar-animated">
                CARGANDO INFORMACIÓN
              </div>
            </div>

            <div className={this.state.working ? "hide" : ""}>
              <div className="row">
                <div className="col-lg-3">
                  <div className="widget100 widget widget-stats bg-gradient-teal m-b-10">
                    <div className="stats-icon stats-icon-lg">
                      <i className="fab fa-lg fa-fw m-r-10 fa-wpforms"></i>
                    </div>
                    <div className="stats-content">
                      <div className="stats-title">Trámite</div>

                      <div className="stats-desc">
                        <h5>{this.state.regente.accion}</h5>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3">
                  <div className="widget100 widget widget-stats bg-gradient-yellow m-b-10">
                    <div className="stats-icon stats-icon-lg">
                      <i className="fas fa-lg fa-fw m-r-10 fa-question-circle"></i>
                    </div>
                    <div className="stats-content">
                      <div className="stats-title">Tipo</div>

                      <div className="stats-desc">
                        <h5>{this.state.regente.tipo}</h5>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3">
                  <div className="widget100 widget widget-stats bg-gradient-blue m-b-10">
                    <div className="stats-icon stats-icon-lg">
                      <i className="fas fa-lg fa-fw m-r-10 fa-clock"></i>
                    </div>
                    <div className="stats-content">
                      <div className="stats-title">Estado</div>

                      <div className="stats-desc">
                        <h5>{this.state.regente.estatus}</h5>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3">
                  <div className="widget100 widget widget-stats bg-gradient-green m-b-10">
                    <div className="stats-icon stats-icon-lg">
                      <i className="fas fa-lg fa-fw m-r-10 fa-calendar-alt"></i>
                    </div>
                    <div className="stats-content">
                      <div className="stats-title">Fecha</div>

                      <div className="stats-desc">
                        <h5>
                          {this.state.regente.fecha_solicitud
                            ? this.state.regente.fecha_solicitud
                                .split(" ")[0]
                                .split("-")
                                .reverse()
                                .join("-")
                                .replaceAll("-", "/")
                            : "N/A"}
                        </h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <hr />
              <fieldset className="col-md-12">
                <legend>Datos generales</legend>

                <div className="row">
                  <div className="form-group col-md-4">
                    <label>Folio Regente</label>
                    <div className="form-control">
                      {this.state.regente.folio_regente}
                    </div>
                  </div>

                  <div className="form-group col-md-4">
                    <label>Número de identificación</label>
                    <div className="form-control">
                      {this.state.regente.numero_identificacion}
                    </div>
                  </div>

                  <div className="form-group col-md-4">
                    <label>Código IPSA</label>
                    <div className="form-control">
                      {this.state.regente.tipo_regente_id === "1" ? 
                        this.state.regente.codigo_ipsa
                        : "N/A"}
                    </div>
                  </div>

                  <div className="form-group col-md-4">
                    <label>Nombre</label>
                    <div className="form-control">
                      {this.state.regente.nombres}
                    </div>
                  </div>
                  <div className="form-group col-md-4">
                    <label>Apellido paterno</label>
                    <div className="form-control">
                      {this.state.regente.apellido_paterno}
                    </div>
                  </div>
                  <div className="form-group col-md-4">
                    <label>Apellido materno</label>
                    <div className="form-control">
                      {this.state.regente.apellido_materno}
                    </div>
                  </div>

                  {this.state.regente.tipo_regente_id === "1" ? (
                    <>
                      <div className="form-group col-md-6">
                        <label className="text-warning">Nombre SGI</label>
                        <div className="form-control" id="nombreSGI">
                          {this.state.regente.sgi_info &&
                          this.state.regente.sgi_info.NombreMedico
                            ? this.state.regente.sgi_info.NombreMedico
                            : "N/A"}
                        </div>
                      </div>
                      <div className="form-group col-md-6">
                        <label className="text-warning">
                          Fecha de vencimiento SGI
                        </label>
                        <div className="form-control" id="caducaSGI">
                          {this.state.regente.sgi_info &&
                          this.state.regente.sgi_info.Caduca
                            ? this.state.regente.sgi_info.Caduca.substring(
                                0,
                                10
                              )
                                .split("-")
                                .reverse()
                                .join("/")
                            : "N/A"}
                        </div>
                      </div>
                    </>
                  ) : null}
                  <div className="form-group col-md-4">
                    <label>Correo electrónico</label>
                    <div className="form-control">
                      {this.state.regente.correo_electronico}
                    </div>
                  </div>

                  <div className="form-group col-md-4">
                    <label>Teléfono convencional</label>
                    <div className="form-control">
                      {this.state.regente.telefono_convencional}
                    </div>
                  </div>

                  <div className="form-group col-md-4">
                    <label>Celular</label>
                    <div className="form-control">
                      {this.state.regente.telefono_celular}
                    </div>
                  </div>

                  <div className="form-group col-md-12">
                    <label>Dirección</label>
                    <div className="form-control">
                      {this.state.regente.direccion}
                    </div>
                  </div>

                  <div className="form-group col-md-6">
                    <label>Departamento</label>
                    <div className="form-control">
                      {this.state.regente.departamento}
                    </div>
                  </div>

                  <div className="form-group col-md-6">
                    <label>Municipio</label>
                    <div className="form-control">
                      {this.state.regente.municipio}
                    </div>
                  </div>

                  <div className="form-group col-md-12">
                    <label>Profesiones</label>
                    <div className="form-control">
                      {this.state.regente.profesion}
                    </div>
                  </div>
                </div>
              </fieldset>
              <hr className={ this.state.regente.documentos.length ? "" : "hide" }/>
              <fieldset
                className={
                  this.state.regente.documentos.length ? "col-md-12" : "hide"
                }
              >
                <legend>Documentación</legend>
                <div className="table-responsive">
                  <button
                    className="btn btn-primary pull-right"
                    onClick={this.handleDownloadZipRegentes}
                  >
                    Descargar selección
                  </button>
                  <table className="table table-striped m-b-0 table-hover">
                    <thead>
                      <tr>
                        <th width="50">
                          <div className="checkbox checkbox-inline checkbox-css">
                            <input
                              onChange={this.allDocsRegent}
                              type="checkbox"
                              value={this.state.allRc || false}
                              name="allc"
                              checked={this.state.allRc || false}
                              id="allc"
                            />
                            <label htmlFor="allc">Todos</label>
                          </div>
                        </th>
                        <th className="text-center">Vista previa</th>
                        <th className="text-center">Documento</th>
                        <th className="text-center">Fecha carga</th>
                        <th className="text-center">Estado</th>
                        <th className="text-center">Fecha aprobación</th>
                        <th className="text-center">Acción</th>
                      </tr>
                    </thead>
                    <tbody className={this.state.working ? "hide" : "show"}>
                      {this.state.regente.documentos.map((reg) => (
                        <tr key={reg.id}>
                          <td className="text-center">
                            <div className="checkbox checkbox-inline checkbox-css">
                              <input
                                type="checkbox"
                                id={reg.id}
                                onChange={this.handleRegentChecks}
                                name={reg.id}
                                value={
                                  this.state.regenteDocsCheck[reg.id] || false
                                }
                                checked={
                                  this.state.regenteDocsCheck[reg.id] || false
                                }
                              />
                              <label htmlFor={reg.id}></label>
                            </div>
                          </td>
                          <td className="text-center">
                            <img
                              alt="Vista previa"
                              className="rounded btn"
                              data-file={
                                Api.url + `app/documento/?id=${reg.id}`
                              }
                              onClick={this.handlePrevia}
                              width="60"
                              src={
                                Api.url + `app/documento/?id=${reg.id}&thumb=1`
                              }
                            />
                          </td>
                          <td className="text-center">{reg.documento}</td>
                          <td className="text-center">
                            {reg.fecha_subida !== null
                              ? reg.fecha_subida
                                  .split(" ")[0]
                                  .split("-")
                                  .reverse()
                                  .join("-")
                                  .replaceAll("-", "/")
                              : "N/A"}
                          </td>
                          <td className="text-center reg-doc-status">
                            {reg.estatus}
                          </td>
                          <td className="text-center">
                            {reg.fecha_aprueba_sinaip !== null
                              ? reg.fecha_aprueba_sinaip
                                  .split("-")
                                  .reverse()
                                  .join("-")
                                  .replaceAll("-", "/")
                              : ""}
                          </td>
                          <td className="text-center">
                            <div className="btn-group">
                              <a
                                href={
                                  Api.url +
                                  `app/documento/?id=${reg.id}&download=1`
                                }
                                className="btn btn-primary"
                              >
                                <i className="fas fa-file-download"></i>
                              </a>
                              <button
                                className="btn btn-danger"
                                data-solicitud_id={reg.solicitud_id}
                                data-solicitud_estatus={reg.estatus}
                                data-rrd-id={reg.id}
                                id={"button_rechazar_reg_doc_" + reg.id}
                                onClick={this.handleRegentDocumentStatus}
                                data-toggle="tooltip"
                                data-placement="top"
                                data-name="Rechazar"
                                disabled={reg.aprobado !== "1" ? true : false}
                              >
                                <i
                                  className="fas fa-ban"
                                  data-solicitud_id={reg.solicitud_id}
                                  data-solicitud_estatus={reg.estatus}
                                  data-rrd-id={reg.id}
                                  id={"i_rechazar_reg_doc" + reg.id}
                                  onClick={this.handleRegentDocumentStatus}
                                  data-name="Rechazar"
                                  disabled={reg.aprobado !== "1" ? true : false}
                                ></i>
                                Rechazar
                              </button>
                              <button
                                className="btn btn-success"
                                data-solicitud_id={reg.solicitud_id}
                                data-solicitud_estatus={reg.estatus}
                                data-rrd-id={reg.id}
                                id={"button_aceptar_reg_doc_" + reg.id}
                                onClick={this.handleRegentDocumentStatus}
                                data-toggle="tooltip"
                                data-placement="top"
                                data-name="Aprobar"
                                disabled={reg.aprobado !== "1" ? true : false}
                              >
                                <i
                                  className="fas fa-check"
                                  data-solicitud_id={reg.solicitud_id}
                                  data-solicitud_estatus={reg.estatus}
                                  data-rrd-id={reg.id}
                                  id={"i_aceptar_reg_doc" + reg.id}
                                  onClick={this.handleRegentDocumentStatus}
                                  data-name="Aprobar"
                                  disabled={reg.aprobado !== "1" ? true : false}
                                ></i>
                                Aprobar
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </fieldset>
              <hr />
              <div className="col-md-12">
                <div className="btn-group  pull-left">
                  <button
                    className="btn btn-white "
                    onClick={() => {
                      this.setRegentesPage(this.state.paginaActual);
                      this.setState({ modalRegente: false });
                    }}
                  >
                    Regresar
                  </button>
                </div>

                <div className="btn-group pull-right col-md-4">
                  <button
                    onClick={this.handleRegentStatus}
                    value="4"
                    id="rechazar_reg"
                    className="btn btn-danger hide"
                  >
                    Rechazar
                  </button>
                  <button
                    onClick={this.handleRegentStatus}
                    value="5"
                    id="aprobar_reg"
                    className="btn btn-success hide"
                  >
                    Aceptar
                  </button>
                </div>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <div className={this.state.previa ? "previa" : "hide"}>
          <iframe
            title="Vista previa"
            className="rounded"
            src={this.state.previa_url}
          ></iframe>
          <center>
            <div className="btn-group">
              <button
                onClick={() => {
                  this.setState({ previa: false, previa_url: "" });
                }}
                className="btn btn-danger"
              >
                Regresar
              </button>
              <a
                className="btn btn-primary"
                href={this.state.previa_url + "&download=1"}
                download="download"
              >
                Descargar
              </a>
            </div>
          </center>
        </div>
        {/***************  DETALLE ESTABLECIMIENTO  ***************/}
        <div className="hide">
          <div id="detalleEstablecimiento">
            <div className="row">
              <div className="col-lg-3">
                <div className="widget100 widget widget-stats bg-gradient-teal m-b-10">
                  <div className="stats-icon stats-icon-lg">
                    <i className="fab fa-lg fa-fw m-r-10 fa-wpforms"></i>
                  </div>
                  <div className="stats-content">
                    <div className="stats-title">Trámite</div>

                    <div className="stats-desc">
                      <h5>{this.state.solicitud_est.accion}</h5>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="widget100 widget widget-stats bg-gradient-yellow m-b-10">
                  <div className="stats-icon stats-icon-lg">
                    <i className="fas fa-lg fa-fw m-r-10 fa-question-circle"></i>
                  </div>
                  <div className="stats-content">
                    <div className="stats-title">Tipo</div>

                    <div className="stats-desc">
                      <h5 className="estTipo">
                        {this.state.solicitud_est.tipo}
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="widget100 widget widget-stats bg-gradient-blue m-b-10">
                  <div className="stats-icon stats-icon-lg">
                    <i className="fas fa-lg fa-fw m-r-10 fa-clock"></i>
                  </div>
                  <div className="stats-content">
                    <div className="stats-title">Estado</div>

                    <div className="stats-desc">
                      <h5>{this.state.solicitud_est.estatus}</h5>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="widget100 widget widget-stats bg-gradient-green m-b-10">
                  <div className="stats-icon stats-icon-lg">
                    <i className="fas fa-lg fa-fw m-r-10 fa-calendar-alt"></i>
                  </div>
                  <div className="stats-content">
                    <div className="stats-title">Fecha</div>

                    <div className="stats-desc">
                      <h5>
                        {this.state.solicitud_est.fecha_solicitud
                          .split(" ")[0]
                          .split("-")
                          .reverse()
                          .join("-")
                          .replaceAll("-", "/")}
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <div className="col-12">
                <fieldset>
                  <legend>detalles establecimiento</legend>
                  <div id="establecimiento"></div>
                </fieldset>
              </div>
            </div>
            <hr></hr>
            <div className="row">
              <div className="col-12">
                <fieldset>
                  <legend>Detalles del representante legal</legend>
                  <div id="representanteLegal"></div>
                </fieldset>
              </div>
            </div>
            <hr></hr>
            <div className="row">
              <div className="col-12">
                <fieldset>
                  <legend>Detalles de regentes</legend>
                  <div id="gridRegente"></div>
                </fieldset>
              </div>
            </div>
            <hr/>
            <div className="row">
              <div className="col-12">
                <fieldset>
                  <legend>Características del establecimiento</legend>
                  <div id="caracteristicas"></div>
                  <hr></hr>
                  <div id="condiciones"></div>
                </fieldset>
              </div>
            </div>
            <div className="row">
              <div className="col-12 hide" id="anotacion_marginal">
                <fieldset className="orange-stroke">
                  <legend>
                    Anotación marginal <b id="nota_marginal"></b>
                  </legend>
                  <div id="detalle_ame"></div>
                </fieldset>
              </div>
            </div>
            <hr className={
                  this.state.establecimiento.documentos.length
                    ? "col-md-12"
                    : "hide"
                }/>
            <div className="row">
              <div
                className={
                  this.state.establecimiento.documentos.length
                    ? "col-md-12"
                    : "hide"
                }
              >
                <fieldset className="col-md-12">
                  <legend>Documentación</legend>
                  <div className="table-responsive">
                    <button
                      className="btn btn-primary pull-right"
                      id="descarga_docs_est"
                      //onClick={this.handleDownloadZipEstablecimientos}
                    >
                      Descargar selección
                    </button>
                    <table className="table table-striped m-b-0 table-hover">
                      <thead>
                        <tr>
                          <th width="50">
                            <div className="checkbox checkbox-inline checkbox-css">
                              <input
                                onChange={this.allDocsEst}
                                type="checkbox"
                                value={this.state.allEst || false}
                                name="allc_e"
                                checked={this.state.allEst || false}
                                id="allc_e"
                              />
                              <label htmlFor="allc_e">Todos</label>
                            </div>
                          </th>
                          <th className="text-center">Vista previa</th>
                          <th className="text-center">Documento</th>
                          <th className="text-center">Fecha carga</th>
                          <th className="text-center">Estado</th>
                          <th className="text-center">
                            Fecha aprobación SINAIP
                          </th>
                          <th className="text-center">
                            Fecha aprobación asesoría legal
                          </th>
                          <th className="text-center">Acción</th>
                        </tr>
                      </thead>
                      <tbody className={this.state.working ? "hide" : "show"}>
                        {this.state.establecimiento.documentos.map((est) => (
                          <tr key={est.id}>
                            <td className="text-center">
                              <div className="checkbox checkbox-inline checkbox-css">
                                <input
                                  type="checkbox"
                                  className="checkbox_est"
                                  id={est.id}
                                  onChange={(e) => {}}
                                  name={est.id}
                                  value={
                                    this.state.establecimientoDocsCheck[
                                      est.id
                                    ] || false
                                  }
                                  checked={
                                    this.state.establecimientoDocsCheck[
                                      est.id
                                    ] || false
                                  }
                                />
                                <label htmlFor={est.id}></label>
                              </div>
                            </td>
                            <td className="text-center">
                              <img
                                alt="Vista previa"
                                className="rounded btn vista-previa"
                                data-file={
                                  Api.url +
                                  `app/documentoE${this.state.am}/?id=${est.id}`
                                }
                                onClick={this.handlePrevia}
                                width="60"
                                src={
                                  Api.url +
                                  `app/documentoE${this.state.am}/?id=${est.id}&thumb=1`
                                }
                              />
                            </td>
                            <td className="text-center">
                              {est.documento.replace(
                                "**ACTIVIDAD**",
                                est.actividad
                              )}
                            </td>
                            <td align="center">
                              {est.created !== null
                                ? format(new Date(est.created), "dd/MM/yyyy")
                                : ""}
                            </td>

                            <td className="text-center est-doc-status">
                              {est.estatus}
                            </td>

                            <td align="center">
                              {est.fecha_aprueba_sinaip !== null
                                ? est.fecha_aprueba_sinaip
                                    .split("-")
                                    .reverse()
                                    .join("-")
                                    .replaceAll("-", "/")
                                : ""}
                            </td>
                            <td align="center">
                              {est.fecha_aprueba_asesoria !== null
                                ? est.fecha_aprueba_asesoria
                                    .split("-")
                                    .reverse()
                                    .join("-")
                                    .replaceAll("-", "/")
                                : ""}
                            </td>
                            <td className="text-center">
                              <div className="btn-group">
                                <a
                                  href={
                                    Api.url +
                                    `app/documentoE${this.state.am}/?id=${est.id}&download=1`
                                  }
                                  className="btn btn-primary"
                                >
                                  <i className="fas fa-file-download"></i>
                                </a>
                                <button
                                  className={
                                    est.aprobado !== "1" || this.state.solicitud_est.estatus_tramite_id === "4"
                                      ? "blockea btn btn-danger "
                                      : "btn btn-danger documento-rechazar"
                                  }
                                  data-solicitud_id={est.solicitud_id}
                                  data-solicitud_estatus={est.estatus}
                                  id={est.id}
                                  onClick={
                                    this.handleEstablecimientoDocumentoStatus
                                  }
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  name="Rechazar"
                                  disabled={est.aprobado !== "1" || this.state.solicitud_est.estatus_tramite_id === "4"? true : false}
                                  data-name="Rechazar"
                                >
                                  <i
                                    className="fas fa-ban documento-rechazar"
                                    data-solicitud_id={est.solicitud_id}
                                    data-solicitud_estatus={est.estatus}
                                    id={est.id}
                                    onClick={
                                      this.handleEstablecimientoDocumentoStatus
                                    }
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    data-name="Rechazar"
                                    disabled={
                                      est.aprobado !== "1" ? true : false
                                    }
                                  ></i>
                                  Rechazar
                                </button>
                                <button
                                  className={
                                    est.aprobado !== "1" || this.state.solicitud_est.estatus_tramite_id === "4"
                                      ? "blockea btn btn-success "
                                      : "btn btn-success documento-aceptar"
                                  }
                                  data-solicitud_id={est.solicitud_id}
                                  data-solicitud_estatus={est.estatus}
                                  id={est.id}
                                  onClick={
                                    this.handleEstablecimientoDocumentoStatus
                                  }
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  data-name="Aprobar"
                                  disabled={est.aprobado !== "1" || this.state.solicitud_est.estatus_tramite_id === "4"? true : false}
                                >
                                  <i
                                    className="fas fa-check  documento-aceptar"
                                    data-solicitud_id={est.solicitud_id}
                                    data-solicitud_estatus={est.estatus}
                                    id={est.id}
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    data-name="Aprobar"
                                    disabled={
                                      est.aprobado !== "1" || this.state.solicitud_est.estatus_tramite_id === "4"? true : false
                                    }
                                  ></i>
                                  Aprobar
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </fieldset>
              </div>
            </div>
            <hr/>
            <div className="row">
              <div className="col-md-12">
                <div className="btn-group pull-left col-md-4">
                  <button
                    onClick={this.handleEstablecimientoStatus}
                    value="4"
                    id="rechazar_est"
                    className="btn btn-danger hide "
                  >
                    Rechazar
                  </button>
                </div>
                <div className="btn-group pull-right col-md-4">
                  <button id="regresar_est" className="btn btn-white ">
                    Regresar
                  </button>
                  <button
                    onClick={this.handleEstablecimientoStatus}
                    value="10"
                    id="aprobar_est"
                    className="btn btn-success hide "
                  >
                    Aceptar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/***************  DETALLE PRODUCTO  ***************/}
        <div className="hide">
          <div id="detalleProducto">
            <div className="row">
              <div className="col-lg-3">
                <div className="widget100 widget widget-stats bg-gradient-teal m-b-10">
                  <div className="stats-icon stats-icon-lg">
                    <i className="fab fa-lg fa-fw m-r-10 fa-wpforms"></i>
                  </div>
                  <div className="stats-content">
                    <div className="stats-title">Trámite</div>

                    <div className="stats-desc">
                      <h5>{this.state.solicitud_prod.accion}</h5>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="widget100 widget widget-stats bg-gradient-yellow m-b-10">
                  <div className="stats-icon stats-icon-lg">
                    <i className="fas fa-lg fa-fw m-r-10 fa-question-circle"></i>
                  </div>
                  <div className="stats-content">
                    <div className="stats-title">Tipo</div>

                    <div className="stats-desc">
                      <h5>{this.state.solicitud_prod.tipo}</h5>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="widget100 widget widget-stats bg-gradient-blue m-b-10">
                  <div className="stats-icon stats-icon-lg">
                    <i className="fas fa-lg fa-fw m-r-10 fa-clock"></i>
                  </div>
                  <div className="stats-content">
                    <div className="stats-title">Estado</div>

                    <div className="stats-desc">
                      <h5>{this.state.solicitud_prod.estatus}</h5>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="widget100 widget widget-stats bg-gradient-green m-b-10">
                  <div className="stats-icon stats-icon-lg">
                    <i className="fas fa-lg fa-fw m-r-10 fa-calendar-alt"></i>
                  </div>
                  <div className="stats-content">
                    <div className="stats-title">Fecha</div>

                    <div className="stats-desc">
                      <h5>
                        {this.state.solicitud_prod.fecha_solicitud
                          ? this.state.solicitud_prod.fecha_solicitud
                              .split("-")
                              .join("-")
                              .replaceAll("-", "/")
                          : this.state.solicitud_prod.fecha_solicitud}
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <div className="col-12">
                {this.state.solicitud_prod.tramite_id !== "11" ? (
                  <div>
                    {/* <fieldset>
                    <legend>Comercial</legend>
                    <div id="d_nombre"></div>
                    </fieldset> */}
                    <hr></hr>
                    <div id="producto">
                      <fieldset>
                        <legend>
                          Detalle del producto{" "}
                          {this.state.solicitud_prod.tipo_producto_veterinario}
                        </legend>
                        <div id="d_producto"></div>
                        {/*    <div id="d_producto_vet" className={((this.state.solicitud_prod.tipo_producto_id !== "reactivos_diagnosticos" )? "" : "hide")}></div>
                        <div id="d_producto_bio" className={((this.state.solicitud_prod.tipo_producto_id !== "reactivos_diagnosticos" )? "" : "hide")}></div> */}
                      </fieldset>
                      <hr></hr>
                      <fieldset>
                        <legend>Detalles tipo de producto</legend>
                        <div
                          id="producto_activo"
                          className={
                            this.state.solicitud_prod
                              .tipo_producto_veterinario_id === "1" ||
                            this.state.solicitud_prod
                              .tipo_producto_veterinario_id === "3"
                              ? ""
                              : "hide"
                          }
                        ></div>
                        <div
                          id="excipiente"
                          className={
                            this.state.solicitud_prod
                              .tipo_producto_veterinario_id === "1" ||
                            this.state.solicitud_prod
                              .tipo_producto_veterinario_id === "3"
                              ? ""
                              : "hide"
                          }
                        ></div>
                        <div
                          id="biologica"
                          className={
                            this.state.solicitud_prod
                              .tipo_producto_veterinario_id === "2"
                              ? ""
                              : "hide"
                          }
                        ></div>
                        <div
                          id="quimica"
                          className={
                            this.state.solicitud_prod
                              .tipo_producto_veterinario_id === "2"
                              ? ""
                              : "hide"
                          }
                        ></div>
                        <div
                          id="analisis"
                          className={
                            this.state.solicitud_prod
                              .tipo_producto_veterinario_id === "5"
                              ? ""
                              : "hide"
                          }
                        ></div>
                        <div
                          id="ingredientes"
                          className={
                            this.state.solicitud_prod
                              .tipo_producto_veterinario_id === "5"
                              ? ""
                              : "hide"
                          }
                        ></div>
                        <div
                          id="dosis"
                          className={
                            this.state.solicitud_pro
                              .tipo_producto_veterinario_id === "3" ||
                            this.state.solicitud_prod
                              .tipo_producto_veterinario_id === "4"
                              ? "hide"
                              : ""
                          }
                        ></div>
                        <div
                          id="modo_empleo"
                          className={
                            this.state.solicitud_prod
                              .tipo_producto_veterinario_id === "3"
                              ? ""
                              : "hide"
                          }
                        ></div>
                        <div
                          id="envase"
                          className={
                            this.state.solicitud_prod
                              .tipo_producto_veterinario_id !== "4"
                              ? ""
                              : "hide"
                          }
                        ></div>
                        <div
                          id="periodo"
                          className={
                            this.state.solicitud_pro
                              .tipo_producto_veterinario_id === "3" ||
                            this.state.solicitud_prod
                              .tipo_producto_veterinario_id === "4"
                              ? "hide"
                              : ""
                          }
                        ></div>
                        <div
                          id="componente"
                          className={
                            this.state.solicitud_prod
                              .tipo_producto_veterinario_id === "4"
                              ? ""
                              : "hide"
                          }
                        ></div>
                        <div
                          id="especie_interes"
                          className={
                            this.state.solicitud_prod
                              .tipo_producto_veterinario_id === "4"
                              ? ""
                              : "hide"
                          }
                        ></div>
                        <div
                          id="presentaciones"
                          className={
                            this.state.solicitud_prod
                              .tipo_producto_veterinario_id === "4"
                              ? ""
                              : "hide"
                          }
                        ></div>
                      </fieldset>
                    </div>
                    <hr></hr>
                    {/* <fieldset>
                        <legend>Representantes Legales</legend>
                        <div id="representanteLegal_pro"></div>
                      </fieldset> 
                      <hr></hr>*/}
                    <fieldset>
                      <legend>Regente</legend>
                      <div id="regente_pro"></div>
                    </fieldset>

                    <fieldset
                      className={
                        this.state.solicitud_prod.anotacion_marginal
                          ? ""
                          : "hide"
                      }
                    >
                      <legend>
                        Anotación Marginal{" "}
                        {this.state.solicitud_prod.anotacion_marginal}
                      </legend>
                      <div id="anotacion_marginal_prod"></div>
                    </fieldset>
                  </div>
                ) : (
                  <div>
                    <fieldset>
                      <legend>Detalle de refrenda</legend>
                      <div id="f_refrenda" className=""></div>
                    </fieldset>
                    <hr></hr>
                    <fieldset>
                      <legend>Productos refrenda</legend>
                      <div id="refrenda_productos"></div>
                    </fieldset>
                  </div>
                )}

                <hr></hr>
                <fieldset
                  className={
                    this.state.docProductos.length ? "col-md-12" : "hide"
                  }
                >
                  <legend>Documentación</legend>
                  <div className="table-responsive">
                    <button
                      className="btn btn-primary pull-right"
                      id="descarga_docs_pro"
                    >
                      Descargar selección
                    </button>
                    <table className="table table-striped m-b-0 table-hover">
                      <thead>
                        <tr>
                          <th width="50">
                            <div className="checkbox checkbox-inline checkbox-css">
                              <input
                                onChange={this.allDocsPro}
                                type="checkbox"
                                value={this.state.allPro || false}
                                name="allc_p"
                                checked={this.state.allPro || false}
                                id="allc_p"
                              />
                              <label htmlFor="allc_p">Todos</label>
                            </div>
                          </th>
                          <th className="text-center">Vista previa</th>
                          <th className="text-center">Documento</th>
                          <th className="text-center">Fecha carga</th>
                          <th className="text-center">Estado</th>
                          <th className="text-center">
                            Fecha aprobación SINAIP
                          </th>
                          <th className="text-center">
                            Fecha aprobación asesoría legal
                          </th>
                          <th className="text-center">Acción</th>
                        </tr>
                      </thead>
                      <tbody className={this.state.working ? "hide" : "show"}>
                        {this.state.docProductos.map((dpro) => (
                          <tr key={dpro.id}>
                            <td className="text-center">
                              <div className="checkbox checkbox-inline checkbox-css">
                                <input
                                  type="checkbox"
                                  className="checkbox_pro"
                                  id={dpro.id}
                                  name={dpro.id}
                                  value={
                                    this.state.productoDocsCheck[dpro.id] ||
                                    false
                                  }
                                  checked={
                                    this.state.productoDocsCheck[dpro.id] ||
                                    false
                                  }
                                  onChange={(e) => {}}
                                />
                                <label htmlFor={dpro.id}></label>
                              </div>
                            </td>
                            <td className="text-center">
                              <img
                                alt="Vista previa"
                                className="rounded btn vista-previa"
                                data-file={
                                  this.state.solicitud_prod
                                    .anotacion_marginal === false
                                    ? Api.url + `app/documentoP/?id=${dpro.id}`
                                    : Api.url +
                                      `app/documentoPAM/?id=${dpro.id}`
                                }
                                width="60"
                                src={
                                  this.state.solicitud_prod
                                    .anotacion_marginal === false
                                    ? Api.url +
                                      `app/documentoP/?id=${dpro.id}&thumb=1`
                                    : Api.url +
                                      `app/documentoPAM/?id=${dpro.id}&thumb=1`
                                }
                              />
                            </td>
                            <td className="text-center">{dpro.documento}</td>
                            <td className="text-center">
                              {dpro.created
                                ? format(new Date(dpro.created), "dd/MM/yyyy")
                                : ""}
                            </td>
                            <td className="text-center pro-doc-status">
                              {dpro.estatus}
                            </td>
                            <td className="text-center">
                              {dpro.fecha_aprueba_sinaip
                                ? dpro.fecha_aprueba_sinaip
                                    .split("-")
                                    .reverse()
                                    .join("-")
                                    .replaceAll("-", "/")
                                : ""}
                            </td>
                            <td className="text-center">
                              {dpro.fecha_aprueba_asesoria
                                ? dpro.fecha_aprueba_asesoria
                                    .split("-")
                                    .reverse()
                                    .join("-")
                                    .replaceAll("-", "/")
                                : ""}
                            </td>

                            <td className="text-center">
                              <div className="btn-group">
                                <a
                                  href={
                                    this.state.solicitud_prod
                                      .anotacion_marginal === false
                                      ? Api.url +
                                        `app/documentoP/?id=${dpro.id}&download=1`
                                      : Api.url +
                                        `app/documentoPAM/?id=${dpro.id}&download=1`
                                  }
                                  className="btn btn-primary"
                                >
                                  <i className="fas fa-file-download"></i>
                                </a>
                                <button
                                  className="btn btn-danger documento-pro-rechazar"
                                  data-solicitud_id={dpro.solicitud_id}
                                  data-solicitud_estatus={dpro.estatus}
                                  id={dpro.id}
                                  onClick={this.handleProductosDocumentoStatus}
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  data-name="Rechazar"
                                  disabled={
                                    dpro.aprobado !== "1" ? true : false
                                  }
                                >
                                  <i
                                    className="fas fa-ban"
                                    data-solicitud_id={dpro.solicitud_id}
                                    data-solicitud_estatus={dpro.estatus}
                                    id={dpro.id}
                                    onClick={
                                      this.handleProductosDocumentoStatus
                                    }
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    data-name="Rechazar"
                                    disabled={
                                      dpro.aprobado !== "1" ? true : false
                                    }
                                  ></i>{" "}
                                  Rechazar
                                </button>
                                <button
                                  className="btn btn-success documento-pro-aceptar"
                                  data-solicitud_id={dpro.solicitud_id}
                                  data-solicitud_estatus={dpro.estatus}
                                  id={dpro.id}
                                  onClick={this.handleProductosDocumentoStatus}
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  data-name="Aprobar"
                                  disabled={
                                    dpro.aprobado !== "1" ? true : false
                                  }
                                >
                                  <i
                                    className="fas fa-check  documento-aceptar"
                                    data-solicitud_id={dpro.solicitud_id}
                                    data-solicitud_estatus={dpro.estatus}
                                    id={dpro.id}
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    data-name="Aprobar"
                                    disabled={
                                      dpro.aprobado !== "1" ? true : false
                                    }
                                  ></i>{" "}
                                  Aprobar
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </fieldset>
                <template>
                  <div id="clasificacion"></div>
                </template>
              </div>
              <div className="col-md-12">
                {/* <div className="btn-group  pull-left">
                    <button
                      className="btn btn-white "
                      onClick={() => {
                        this.setEstablecimientosPage(this.state.paginaActual);
                        this.setState({ modalEstablecimiento: false });
                      }}>
                      Regresar
                    </button>
                  </div> */}
                <div className="btn-group pull-left col-md-4">
                  <button
                    onClick={this.handleProductoStatus}
                    value="4"
                    id="rechazar_pro"
                    className="btn btn-danger "
                  >
                    Rechazar
                  </button>
                </div>
                <div className="btn-group pull-right col-md-4">
                  <button id="regresar_pro" className="btn btn-white ">
                    Regresar
                  </button>
                  <button
                    onClick={this.handleProductoStatus}
                    value="10"
                    id="aprobar_pro"
                    className="btn btn-success hide "
                  >
                    Aceptar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/****** DETALLE CONSTANCIAS ******/}
        <div className="hide">
          <div id="detalleConstancia">
            <div className="row">
              <div className="col-lg-3">
                <div className="widget100 widget widget-stats bg-gradient-teal m-b-10">
                  <div className="stats-icon stats-icon-lg">
                    <i className="fab fa-lg fa-fw m-r-10 fa-wpforms"></i>
                  </div>
                  <div className="stats-content">
                    <div className="stats-title">Trámite</div>

                    <div className="stats-desc">
                      <h5>{this.state.solicitud_cons.nombre_servicio}</h5>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="widget100 widget widget-stats bg-gradient-yellow m-b-10">
                  <div className="stats-icon stats-icon-lg">
                    <i className="fas fa-lg fa-fw m-r-10 fa-question-circle"></i>
                  </div>
                  <div className="stats-content">
                    <div className="stats-title">Tipo</div>

                    <div className="stats-desc">
                      <h5>{this.state.solicitud_cons.tipo_constancia}</h5>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="widget100 widget widget-stats bg-gradient-blue m-b-10">
                  <div className="stats-icon stats-icon-lg">
                    <i className="fas fa-lg fa-fw m-r-10 fa-clock"></i>
                  </div>
                  <div className="stats-content">
                    <div className="stats-title">Estado</div>

                    <div className="stats-desc">
                      <h5>{this.state.solicitud_cons.estatus}</h5>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="widget100 widget widget-stats bg-gradient-green m-b-10">
                  <div className="stats-icon stats-icon-lg">
                    <i className="fas fa-lg fa-fw m-r-10 fa-calendar-alt"></i>
                  </div>
                  <div className="stats-content">
                    <div className="stats-title">Fecha</div>

                    <div className="stats-desc">
                      <h5>
                        {this.state.solicitud_cons.fecha_solicitud !== null
                          ? this.state.solicitud_cons.fecha_solicitud
                              .split("-")
                              .join("-")
                              .replaceAll("-", "/")
                          : this.state.solicitud_cons.fecha_solicitud}
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <fieldset>
              <legend>Detalle Constancia</legend>
              <div
                id="f_cons_regente"
                className={
                  this.state.solicitud_cons.constancia_tipo_id === "5"
                    ? ""
                    : "hide"
                }
              ></div>
              <div
                id="f_cons_txt_libre"
                className={
                  this.state.solicitud_cons.constancia_tipo_id === "1" ||
                  this.state.solicitud_cons.constancia_tipo_id === "2" ||
                  this.state.solicitud_cons.constancia_tipo_id === "3" ||
                  this.state.solicitud_cons.constancia_tipo_id === "12"
                    ? ""
                    : "hide"
                }
              ></div>
              <div
                id="f_cons_actividad"
                className={
                  this.state.solicitud_cons.constancia_tipo_id === "4"
                    ? ""
                    : "hide"
                }
              ></div>
              <div
                id="f_cons_establecimiento"
                className={
                  this.state.solicitud_cons.constancia_tipo_id === "6" ||
                  this.state.solicitud_cons.constancia_tipo_id === "7" ||
                  this.state.solicitud_cons.constancia_tipo_id === "8" ||
                  this.state.solicitud_cons.constancia_tipo_id === "10" ||
                  this.state.solicitud_cons.constancia_tipo_id === "11"
                    ? ""
                    : "hide"
                }
              ></div>
              <div
                id="f_cons_representante"
                className={
                  this.state.solicitud_cons.constancia_tipo_id === "9"
                    ? ""
                    : "hide"
                }
              ></div>
            </fieldset>

            <div
              className={
                this.state.solicitud_cons.constancia_tipo_id === "6" ||
                this.state.solicitud_cons.constancia_tipo_id === "7" ||
                this.state.solicitud_cons.constancia_tipo_id === "10" ||
                this.state.solicitud_cons.constancia_tipo_id === "11"
                  ? "table-responsive"
                  : "hide"
              }
            >
              <fieldset>
                <legend>Productos</legend>
                <table className="table table-striped m-b-0 table-hover blockea ">
                  <thead>
                    <tr>
                      <th>Nombre común</th>
                      <th>Número de registro</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.cons_productos.map((pro, index) => (
                      <tr key={index} id={index}>
                        <td>{pro.nombre_comercial}</td>
                        <td>{pro.no_registro_producto}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </fieldset>
            </div>
            <div
              className={
                this.state.solicitud_cons.constancia_tipo_id === "8"
                  ? ""
                  : "hide"
              }
            >
              <hr />
              {this.state.cons_productos.map((pro, index) => (
                <fieldset key={index}>
                  <legend>
                    {pro.nombre_comercial}, {pro.descripcion}
                  </legend>
                  <div className="form-group col-md-12">
                    <label>Petición:</label>
                    <input
                      type="text"
                      value={pro.peticion}
                      className="form-control"
                      placeholder="Petición"
                      name="peticion"
                      disabled={true}
                      id="peticion"
                    />

                    <label>Valor anterior:</label>
                    <input
                      type="text"
                      value={
                        pro.valor_anterior === null ? "N/A" : pro.valor_anterior
                      }
                      className="form-control"
                      placeholder="Valor anterior"
                      name="v_a"
                      disabled={true}
                      id="v_a"
                    />

                    <label>Valor nuevo:</label>
                    <input
                      type="text"
                      value={pro.valor_nuevo === null ? "N/A" : pro.valor_nuevo}
                      className="form-control"
                      placeholder="Valor nuevo"
                      name="v_p"
                      disabled={true}
                      id="v_p"
                    />
                    <label>
                      Agregar texto anotación marginal en constancia
                    </label>
                    <textarea
                      className="form-control txt-am"
                      placeholder="Ingresar texto"
                      name="txt_pro_cons"
                      value={pro.text_am}
                      maxLength={this.state.txt_actaMaxLen}
                      data-index={index}
                      disabled={this.state.constancia_revisada_8}
                      onChange={(e) => {
                        this.handleTextAM(e);
                      }}
                    ></textarea>
                  </div>
                  <div className="form-group btn-cons pull-left col-md-4">
                    <button
                      value="Continuar"
                      className="btn btn-green btn-cons-am"
                      //data-producto={pro}
                      data-index={index}
                      disabled={this.state.constancia_revisada_8}
                      data-txt={pro.text_am}
                      onClick={(e) => {
                        this.addProductosConsAM(e);
                      }}
                    >
                      listo
                    </button>
                  </div>
                </fieldset>
              ))}
            </div>

            <hr />
            <div
              className={
                this.state.solicitud_cons.constancia_tipo_id === "1" ||
                this.state.solicitud_cons.constancia_tipo_id === "2" ||
                this.state.solicitud_cons.constancia_tipo_id === "3" ||
                this.state.solicitud_cons.constancia_tipo_id === "12"
                  ? ""
                  : "hide"
              }
            >
              <fieldset>
                <legend>Texto acta</legend>
                <textarea
                  className="form-control"
                  id="texto_acta"
                  defaultValue={this.state.texto_acta}
                  placeholder="Ingresar texto acta"
                  name="txt_PO"
                  rows="5"
                  maxLength={this.state.txt_actaMaxLen}
                ></textarea>
              </fieldset>
            </div>

            <div>
              <fieldset>
                <legend>Validez</legend>
                <div id="f_validez"></div>
              </fieldset>
            </div>

            <div className="col-md-12">
              <div className="btn-group pull-left col-md-4">
                <button
                  onClick={this.handleConstanciaStatus}
                  value="4" // Rechazada
                  id="rechazar_cons"
                  className="btn btn-danger "
                  disabled=""
                >
                  Rechazar
                </button>
              </div>
              <div className="btn-group pull-right col-md-4">
                <button id="regresar_cons" className="btn btn-white ">
                  Regresar
                </button>
                <button
                  onClick={this.handleConstanciaStatus}
                  value="5" // Aceptada
                  id="aprobar_cons"
                  className="btn btn-success"
                  disabled=""
                >
                  Aceptar
                </button>
              </div>
            </div>
          </div>
        </div>

        {/***************  DETALLE MEDICO VETERINARIO  ***************/}
        <div className="hide">
          <div id="detalleMedicoVeterinario">
            <div className="row">
              <div className="col-lg-3">
                <div className="widget100 widget widget-stats bg-gradient-teal m-b-10">
                  <div className="stats-icon stats-icon-lg">
                    <i className="fab fa-lg fa-fw m-r-10 fa-wpforms"></i>
                  </div>
                  <div className="stats-content">
                    <div className="stats-title">Trámite</div>

                    <div className="stats-desc">
                      <h5>{this.state.solicitud_mv.accion}</h5>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="widget100 widget widget-stats bg-gradient-yellow m-b-10">
                  <div className="stats-icon stats-icon-lg">
                    <i className="fas fa-lg fa-fw m-r-10 fa-question-circle"></i>
                  </div>
                  <div className="stats-content">
                    <div className="stats-title">Tipo</div>

                    <div className="stats-desc">
                      <h5>{this.state.solicitud_mv.tramite}</h5>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="widget100 widget widget-stats bg-gradient-blue m-b-10">
                  <div className="stats-icon stats-icon-lg">
                    <i className="fas fa-lg fa-fw m-r-10 fa-clock"></i>
                  </div>
                  <div className="stats-content">
                    <div className="stats-title">Estado</div>

                    <div className="stats-desc">
                      <h5>{this.state.solicitud_mv.estatus}</h5>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="widget100 widget widget-stats bg-gradient-green m-b-10">
                  <div className="stats-icon stats-icon-lg">
                    <i className="fas fa-lg fa-fw m-r-10 fa-calendar-alt"></i>
                  </div>
                  <div className="stats-content">
                    <div className="stats-title">Fecha</div>

                    <div className="stats-desc">
                      <h5>
                        {this.state.solicitud_mv.fecha_solicitud
                          ? this.state.solicitud_mv.fecha_solicitud
                              .split(" ")[0]
                              .split("-")
                              .reverse()
                              .join("-")
                              .replaceAll("-", "/")
                          : this.state.solicitud_mv.fecha_solicitud}
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <hr></hr>
              <div className="col-12">
                <fieldset>
                  <legend>Detalle solicitud</legend>
                  <div id="medico_veterinario"></div>
                </fieldset>
              </div>
              <hr></hr>
              <div className="col-12">
                <fieldset>
                  <legend>Establecimientos</legend>
                  <div id="establecimientos_mv"></div>
                </fieldset>
              </div>
              <hr></hr>

              <div className="col-12">
                <fieldset
                  className={
                    this.state.medico_veterinario.documentos.length
                      ? "col-md-12"
                      : "hide"
                  }
                >
                  <legend>Documentación</legend>
                  <div className="table-responsive">
                    <button
                      className="btn btn-primary pull-right"
                      id="descarga_docs_mv"
                      //onClick={this.handleDownloadZipEstablecimientos}
                    >
                      Descargar selección
                    </button>
                    <table className="table table-striped m-b-0 table-hover">
                      <thead>
                        <tr>
                          <th width="50">
                            <div className="checkbox checkbox-inline checkbox-css">
                              <input
                                onChange={(e) => {}}
                                type="checkbox"
                                value={this.state.allMV || false}
                                name="allc_mv"
                                checked={this.state.allMV || false}
                                id="allc_mv"
                              />
                              <label htmlFor="allc_mv">Todos</label>
                            </div>
                          </th>
                          <th className="text-center">Vista previa</th>
                          <th className="text-center">Documento</th>
                          <th className="text-center">Fecha carga</th>
                          <th className="text-center">Estado</th>
                          <th className="text-center">Fecha aprobación</th>
                          <th className="text-center">Acción</th>
                        </tr>
                      </thead>
                      <tbody className={this.state.working ? "hide" : "show"}>
                        {this.state.medico_veterinario.documentos.map((mv) => (
                          <tr key={mv.id}>
                            <td className="text-center">
                              <div className="checkbox checkbox-inline checkbox-css">
                                <input
                                  type="checkbox"
                                  className="checkbox_mv"
                                  id={mv.id}
                                  onChange={(e) => {}}
                                  name={mv.id}
                                  value={
                                    this.state.medicoVetDocsCheck[mv.id] ||
                                    false
                                  }
                                  checked={
                                    this.state.medicoVetDocsCheck[mv.id] ||
                                    false
                                  }
                                />
                                <label htmlFor={mv.id}></label>
                              </div>
                            </td>
                            <td className="text-center">
                              <img
                                alt="Vista previa"
                                className="rounded btn vista-previa"
                                data-file={
                                  Api.url + `app/documentoMV/?id=${mv.id}`
                                }
                                onClick={this.handlePrevia}
                                width="60"
                                src={
                                  Api.url +
                                  `app/documentoMV/?id=${mv.id}&thumb=1`
                                }
                              />
                            </td>

                            <td className="text-center">{mv.documento}</td>
                            <td align="center">
                              {mv.fecha_subida !== null
                                ? format(
                                    new Date(mv.fecha_subida),
                                    "dd/MM/yyyy"
                                  )
                                : ""}
                            </td>
                            <td className="text-center mv-doc-status">
                              {mv.estatus}
                            </td>

                            <td align="center">
                              {mv.fecha_aprueba_sinaip !== null
                                ? mv.fecha_aprueba_sinaip
                                    .split("-")
                                    .reverse()
                                    .join("-")
                                    .replaceAll("-", "/")
                                : "N/A"}
                            </td>
                            <td className="text-center">
                              <div className="btn-group">
                                <a
                                  href={
                                    Api.url +
                                    `app/documentoMV/?id=${mv.id}&download=1`
                                  }
                                  className="btn btn-primary"
                                >
                                  <i className="fas fa-file-download"></i>
                                </a>
                                <button
                                  className="btn btn-danger documento-rechazar"
                                  data-solicitud_id={mv.solicitud_id}
                                  data-solicitud_estatus={mv.estatus}
                                  id={mv.id}
                                  onClick={this.handleMedicoVetDocumentoStatus}
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  name="Rechazar"
                                  disabled={mv.aprobado !== "1" ? true : false}
                                  data-name="Rechazar"
                                >
                                  <i
                                    className="fas fa-ban documento-rechazar"
                                    data-solicitud_id={mv.solicitud_id}
                                    data-solicitud_estatus={mv.estatus}
                                    id={mv.id}
                                    onClick={
                                      this.handleMedicoVetDocumentoStatus
                                    }
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    data-name="Rechazar"
                                    disabled={
                                      mv.aprobado !== "1" ? true : false
                                    }
                                  ></i>
                                  Rechazar
                                </button>
                                <button
                                  className="btn btn-success documento-aceptar"
                                  data-solicitud_id={mv.solicitud_id}
                                  data-solicitud_estatus={mv.estatus}
                                  id={mv.id}
                                  onClick={this.handleMedicoVetDocumentoStatus}
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  data-name="Aprobar"
                                  disabled={mv.aprobado !== "1" ? true : false}
                                >
                                  <i
                                    className="fas fa-check  documento-aceptar"
                                    data-solicitud_id={mv.solicitud_id}
                                    data-solicitud_estatus={mv.estatus}
                                    id={mv.id}
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    data-name="Aprobar"
                                    disabled={
                                      mv.aprobado !== "1" ? true : false
                                    }
                                  ></i>
                                  Aprobar
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </fieldset>
              </div>
              <div className="col-md-12">
                <div className="btn-group pull-left col-md-4">
                  <button
                    onClick={this.handleMedicoVetStatus}
                    value="4"
                    id="rechazar_mv"
                    className="btn btn-danger"
                  >
                    Rechazar
                  </button>
                </div>
                <div className="btn-group pull-right col-md-4">
                  <button id="regresar_mv" className="btn btn-white ">
                    Regresar
                  </button>
                  <button
                    onClick={this.handleMedicoVetStatus}
                    value="5"
                    id="aprobar_mv"
                    className="btn btn-success hide"
                  >
                    Aceptar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/**Certificados */}
        <Modal
          isOpen={this.state.openModalCertificado}
          tabIndex="-1"
          style={{
            maxWidth: "100%",
            width: "85%",
          }}
        >
          <ModalHeader
            toggle={() => {
              this.closeModalCertificado();
              //this.limpiarCampos(2);
            }}
            className="text-center"
          >
            Solicitud: {this.state.solicitud_cer.folio_solicitud}
          </ModalHeader>
          <ModalBody>
            <ModalSolicitudCertificado
              key={this.state.solicitud_cer.solicitud_id}
              component={this}
              state={this.state}
            />
          </ModalBody>
        </Modal>
        {/* fin */}

        {/**Precertificados */}
        <Modal
          isOpen={this.state.openModalPrecertificado}
          tabIndex="-1"
          style={{
            maxWidth: "100%",
            width: "85%",
          }}
        >
          <ModalHeader
            toggle={() => {
              this.closeModalPrecertificado();
            }}
            className="text-center"
          >
            Solicitud: {this.state.solicitud_pre.folio_solicitud}
          </ModalHeader>
          <ModalBody>
            <ModalSolicitudPrecertificado
              key={this.state.solicitud_pre.solicitud_id}
              component={this}
              state={this.state}
            />
          </ModalBody>
        </Modal>

        {/* Movimientos */}
        <Modal
          isOpen={this.state.openModalMovimiento}
          tabIndex="-1"
          style={{
            maxWidth: "100%",
            width: "85%",
          }}
        >
          <ModalHeader
            toggle={() => {
              this.closeModalMovimiento();
              //this.limpiarCampos(2);
            }}
            className="text-center"
          >
            Solicitud: {this.state.solicitud_mov.folio_solicitud}
          </ModalHeader>
          <ModalBody>
            <div className={this.state.workingGridMP ? "" : "hide"}>
              <div className="progress-bar bg-orange progress-bar-striped progress-bar-animated">
                CARGANDO INFORMACIÓN
              </div>
            </div>
            <ModalSolicitudMovimiento
              key={this.state.solicitud_mov.solicitud_id}
              handlePrevia={this.handlePrevia}
              setMovimientoProductosPage={this.setMovimientoProductosPage}
              closeModalMovimientos={this.closeModalMovimientos}
              handleMovimientoProducto={this.handleMovimientoProducto}
              state={this.state}
            />
          </ModalBody>
        </Modal>
        {/* fin */}
        {/**AUTORIAZCIÓN*/}
        <Modal
          isOpen={this.state.openModalAutorizacion}
          tabIndex="-1"
          style={{
            maxWidth: "100%",
            width: "85%",
          }}
        >
          <ModalHeader
            toggle={() => {
              this.closeModalAutorizacion();
            }}
            className="text-center"
          >
            Solicitud: {this.state.solicitud_ada.folio_solicitud}
          </ModalHeader>
          <ModalBody>
            <ModalSolicitudAutorizacion
              key={this.state.solicitud_ada.solicitud_id}
              component={this}
              state={this.state}
            />
          </ModalBody>
        </Modal>
        {/** FIN */}
        {/* Casos especiales */}
        <Modal
          isOpen={this.state.openModalCasoEspecial}
          tabIndex="-1"
          style={{
            maxWidth: "100%",
            width: "85%",
          }}
        >
          <ModalHeader
            toggle={() => {
              this.closeModalCasoEspecial();
              //this.limpiarCampos(2);
            }}
            className="text-center"
          >
            Solicitud: {this.state.solicitud_ce.folio_solicitud}
          </ModalHeader>
          <ModalBody>
            <div className={this.state.workingGridMP ? "" : "hide"}>
              <div className="progress-bar bg-orange progress-bar-striped progress-bar-animated">
                CARGANDO INFORMACIÓN
              </div>
            </div>
            <ModalSolicitudCasoEspecial
              key={this.state.solicitud_mov.solicitud_id}
              handlePrevia={this.handlePrevia}
              handleCasoEspecialDocumentoEstatusChange={
                this.handleCasoEspecialDocumentoEstatusChange
              }
              setCasosEspecialesPage={this.setCasosEspecialesPage}
              closeModalCasoEspecial={this.closeModalCasoEspecial}
              handleCasosEspecialesPage={this.handleCasosEspecialesPage}
              handleCasoEspecialEstatus={this.handleCasoEspecialEstatus}
              handleImportacionAdicionalDataChange={
                this.handleImportacionAdicionalDataChange
              }
              state={this.state}
            />
          </ModalBody>
        </Modal>
        {/* fin */}
        <ModalClasificacion component={this} state={this.state} />
      </div>
    );
  }
}
let App = (props) => {
  const auth = useAuth();
  const history = useHistory();
  return <Applications auth={auth} history={history} {...props} />;
};
export default App;
